import type { TranslationDictionary } from '@eliadmin/core/src/i18n/translation-snapshot-types';

export const GENERATED_TRANSLATIONS = Object.freeze({
  "text1": "Hľadať",
  "text2": "Vaša objednávka",
  "text3": "Čakanie na platbu bankovým prevodom",
  "text4": "Dobrý deň",
  "text5": "Pre objednávku",
  "text6": "očakávame platbu bankovým prevodom.",
  "text7": "Objednávka doručená",
  "text8": "Vaša objednávka bola úspešne doručená.",
  "text9": "Parametre",
  "text10": "facebooku",
  "text11": "Objednávka odoslaná",
  "text12": "je na ceste k Vám.",
  "text13": "Detailný pohyb Vašej zásielky môžete sledovať kliknutím na číslo zásielky.",
  "text14": "Sledovacie číslo zásielky:",
  "text15": "ďakujeme za nákup",
  "text16": "Vašu objednávku evidujeme pod kódom",
  "text17": "Detail objednávky",
  "text18": "Vytvorená:",
  "text19": "Kód",
  "text20": "Produkt",
  "text21": "Jednotková cena",
  "text22": "Množstvo",
  "text23": "Celková cena",
  "text24": "Zľava",
  "text25": "Zľavy",
  "text26": "Celková suma",
  "text27": "Platobné údaje",
  "text28": "IBAN",
  "text29": "Peňažný ústav",
  "text30": "Suma",
  "text31": "Variabilný symbol",
  "text32": "Adresa doručenia",
  "text33": "Meno",
  "text34": "Priezvisko",
  "text35": "E-mail",
  "text36": "Telefón",
  "text37": "Obchodné meno",
  "text38": "Ulica",
  "text39": "Mesto",
  "text40": "PSČ",
  "text41": "Štát",
  "text42": "IČO",
  "text43": "DIČ",
  "text44": "IČ DPH",
  "text45": "Fakturačná adresa",
  "text46": "Objednávka zrušená",
  "text47": "bola zrušená.",
  "text48": "Platba akceptovaná",
  "text49": "bola uhradená.",
  "text50": "Stav objednávky je možné sledovať aj po prihlásení na užívateľský účet.",
  "text51": "Prihlásiť sa do môjho účtu",
  "text52": "Vrátená objednávka",
  "text53": "bola vrátená",
  "text54": "Vrátenie peňazí",
  "text55": "Pre objednávku",
  "text56": "Peniaze vám boli vrátené.",
  "text57": "Poznámka",
  "text58": "Cena dopravy",
  "text59": "Cena platby",
  "text60": "Podobné produkty",
  "text61": "Obľúbené produkty",
  "text62": "Objednávka prijatá",
  "text63": "Objednávka",
  "text64": "DPH",
  "text65": "č.",
  "text66": "je na ceste k Vám.",
  "text67": "Registrácia úspešná",
  "text68": "Vaša registrácia bola úspešná.",
  "text69": "Vygenerované heslo:",
  "text70": "Doporučujeme si po prihlásení heslo zmeniť.",
  "text71": "Prihlásiť sa do vášho konta môžete v sekcii",
  "text72": "Užívateľský účet",
  "text73": "alebo kliknutím na tlačítko prihlásiť sa",
  "text74": "Prihlásiť sa do môjho účtu",
  "text75": "MÔJ EMAIL:",
  "text76": "LINK LACNEJŠIEHO PRODUKTU:",
  "text77": "LINK VÁŠHO PRODUKTU:",
  "text78": "Prajeme všetko najlepšie k narodeninám.",
  "text79": "LINK PRODUKTU:",
  "text80": "Správa:",
  "text81": "Predmet",
  "text82": "Kontaktný formulár",
  "text83": "ako prejav dôvery Vám zasielame zľavový kupón",
  "text84": "vo výške",
  "text85": "Platnosť kupónu je od",
  "text86": "do",
  "text87": "Odber noviniek",
  "text88": "kliknutím na tlačidlo nižšie potvrdíte odber noviniek.",
  "text89": "Potvrdiť odber noviniek",
  "text90": "Potvrdenie položiek",
  "text91": "Vami vrátený tovar sme prijali. Ďakujeme veľmi pekne. Peniaze už sú na ceste k Vám. Spôsob vrátenia peňazí bude závisieť na spôsobe platby, ktorú ste si v objednávke vybrali.",
  "text92": "Ak by sa Vaše údaje o produktoch, ktoré ste nahlásili zo svojho užívateľského účtu, líšili od vrátených produktov, potom si vyhradzujeme právo opäť zaťažiť Vašu kreditnú kartu už uhradenou čiastkou.",
  "text93": "Vezmite prosím na vedomie, že každý vrátený balík je spracovaný zvlášť. V prípade, že ste odoslali ďalšie produkty v inom balíku, obdržíte samostatné potvrdenie o prijatí.",
  "text94": "Vrátené produkty:",
  "text95": "kliknutím nižšie na tlačidlo obnovíte heslo.",
  "text96": "Obnoviť heslo",
  "text97": "Platba objednávky neprebehla správne",
  "text98": "Vašu platbu môžete zopakovať",
  "text99": "Kliknutím na tento odkaz budete presmerovaný na platobnú bránu.",
  "text100": "Ďakujeme za objednávku",
  "text101": "Otázka",
  "text102": "Otázka na produkt:",
  "text103": "Žiadosť o vrátenie",
  "text104": "dostali sme Vašu žiadosť na vrátenie. Môžete začať chystať balík.",
  "text105": "Peniaze Vám vrátime okamžite po obdržaní Vami vráteného tovaru, najneskôr do 14 dní.",
  "text106": "Objednávali ste si tovar s platbou vopred? Pokiaľ ste tovar ešte nezaplatili, my upravíme čiastku k úhrade, aby nezahrňovala Vami vrátený tovar.",
  "text107": "Vraciate:",
  "text108": "Číslo objednávky",
  "text109": "Vaša reklamácia bola zrušená",
  "text110": "Vaša reklamácia nebola schválená",
  "text111": "Dôvod",
  "text112": "Vašu reklamáciu spracovávame",
  "text113": "Vystavil",
  "text114": "Strana 1/1",
  "text115": "Zmena hesla",
  "text116": "Faktúra",
  "text117": "Dodávateľ",
  "text118": "Prevádzka",
  "text119": "Kupujúci",
  "text120": "Tel",
  "text121": "Dátum vystavenia",
  "text122": "Dátum dodania tovaru",
  "text123": "Dátum splatnosti",
  "text124": "Spôsob platby",
  "text125": "Spôsob dopravy",
  "text126": "SWIFT",
  "text127": "Poplatky za platbu",
  "text128": "Produkt / Kód",
  "text129": "Základná cena / Zľava",
  "text130": "Sadzba DPH",
  "text131": "Počet",
  "text132": "Celkom s DPH",
  "text133": "Jedn. cena s DPH",
  "text134": "Poplatky za dopravu",
  "text135": "Daňový doklad k prijatej platbe.",
  "text136": "Celkom bez DPH",
  "text137": "Celkom DPH",
  "text138": "Celkom",
  "text139": "Konštantný symbol",
  "text140": "Suma na úhradu",
  "text141": "Dobropis",
  "text142": "k faktúre",
  "text143": "Dodací list",
  "text144": "Dodací list č.",
  "text145": "Predal",
  "text146": "Prevzal",
  "text147": "Dátum",
  "text148": "Detaily DPH (EUR)",
  "text149": "Sadzba DPH",
  "text150": "Produkty",
  "text151": "Faktúra č.",
  "text152": "Detaily (EUR)",
  "text153": "Doprava",
  "text154": "Objednávky",
  "text155": "Číslo obj.",
  "text156": "Zákazník",
  "text157": "Adresa",
  "text158": "Platba",
  "text159": "Zálohová faktúra č.",
  "text160": "Domov",
  "text161": "Blog",
  "text162": "Hľadaný výraz...",
  "text163": "Nákupný košík ",
  "text164": "Cena",
  "text165": "Spolu",
  "text166": "Aktualizovať košík",
  "text167": "Zľavový kupón",
  "text168": "Odoslať objednávku",
  "text169": "Zhrnutie objednávky",
  "text170": "Cena tovaru",
  "text171": "Nákupný košík je prázdny",
  "text172": "Nakupovať",
  "text173": "produktov",
  "text174": "Filtrovať",
  "text175": "Výrobca",
  "text176": "Kategórie",
  "text177": "Najlacnejšie",
  "text178": "Najdrahšie",
  "text179": "Najnovšie",
  "text180": "Najstaršie",
  "text181": "Najpredávanejšie",
  "text182": "Odoberať",
  "text183": "Vaša emailová adresa",
  "text184": "Zaregistrujte sa na odber nášho Newslettera a využite exkluzívne výhody!",
  "text185": "Odoslať",
  "text186": "Kontakt",
  "text187": "Zmeniť heslo",
  "text188": "Zabudli ste heslo ?",
  "text189": "Prihlásiť sa",
  "text190": "Prihlásenie",
  "text191": "Heslo",
  "text192": "Registrovať sa",
  "text193": "Ešte nemáte účet?",
  "text194": "Oops... stránka ktorú hľadáte neexistuje.",
  "text195": "Výrobcovia",
  "text196": "Zobraziť viac produktov",
  "text197": "Môj účet",
  "text198": "Osobné údaje",
  "text199": "Firemné údaje",
  "text200": "Firma",
  "text201": "Uložiť",
  "text202": "Staré heslo",
  "text203": "Nové heslo",
  "text204": "Zmena hesla",
  "text205": "Celý článok",
  "text206": "Vaša objednávka bola prijatá, žiaľ platba neprebehla úspešne. Prosím skontrolujte Váš email pre viac informácií o stave objednávky.",
  "text207": "Zaplatiť objednávku",
  "text208": "Pokračovať v nákupe",
  "text209": "Mohlo by vás zaujímať",
  "text210": "Kúpiť",
  "text211": "Vyhľadávanie",
  "text212": "Položka/ky",
  "text213": "Vyhľadávanie",
  "text214": "Doručenie do druhého dňa",
  "text215": "V rámci Slovenskej republiky",
  "text216": "Darček zadarmo",
  "text217": "Ku každej objednávke",
  "text218": "Garancia doručenia",
  "text219": "nepoškodeného tovaru",
  "text220": "300 výdajných miest",
  "text221": "na území Slovenska a Česka",
  "text222": "Najnovšie produkty",
  "text223": "Top produkty",
  "text224": "Top články",
  "text225": "Cena s DPH",
  "text226": "Cena bez DPH",
  "text227": "Pridať do košíka",
  "text228": "Kód produktu:",
  "text229": "Zdieľať",
  "text230": "Kategória:",
  "text231": "Popis produktu",
  "text232": "Príslušenstvo",
  "text233": "Ďalšie informácie",
  "text234": "Newsletter už odoberáte",
  "text235": "Pokračovať v nakupovaní",
  "text236": "Úspešne ste sa prihlásili na odber newslettra",
  "text237": "Dostupnosť:",
  "text238": "Na sklade",
  "text239": "Na objednanie",
  "text240": "O nás",
  "text241": "Filter",
  "text242": "produktov",
  "text243": "Zoradiť od: ",
  "text244": "Vynulovať filter",
  "text245": "Stav objednávky",
  "text246": "Naspäť",
  "text247": "Veľkosť:",
  "text248": "ks",
  "text249": "EUR",
  "text250": "Zmeniť avatara",
  "text251": "Úspešne ste sa prihlásili",
  "text252": "Muž",
  "text253": "Žena",
  "text254": "Iné",
  "text255": "Pohlavie",
  "text256": "Ahoj",
  "text257": "Moje objednávky",
  "text258": "Odhlásiť sa",
  "text259": "Zadajte Váš email",
  "text260": "Trvalé prihlásenie",
  "text261": "Registrácia",
  "text262": "Registrácia nového účtu",
  "text263": "Zopakovať heslo",
  "text264": "Súhlasím s",
  "text265": "obchodnými podmienkami",
  "text266": "Už mám účet a chcem sa prihlásiť",
  "text267": "Informácie o cookies",
  "text268": "Kliknutím na tlačidlo Súhlasím so všetkým sa uložia technické, analytické a marketingové súbory cookie, aby sme vám mohli umožniť pohodlné používanie stránok, merať funkčnosť našich stránok a cieliť na vás reklamu. Svoje preferencie môžete jednoducho upraviť kliknutím na Nastavenie súborov cookie.",
  "text269": "Súhlasím so všetkým",
  "text270": "Nastavenie cookies",
  "text271": "Uložiť nastavenia",
  "text272": "Zavrieť",
  "text273": "Cookie",
  "text274": "Popis",
  "text275": "Používame cookies",
  "text276": "Súbory cookie používame na analýzu údajov o našich návštevníkoch, na zlepšenie našich webových stránok, zobrazenie personalizovaného obsahu a na to, aby sme vám poskytli skvelý zážitok z webu. Používaním tohto webu s týmto používaním súhlasíte.",
  "text277": "Technické cookies",
  "text278": "Tieto súbory cookie sú nevyhnutné pre fungovanie webových stránok, nie je teda možné ich zakázať. Obvykle sa nastavujú v reakcii na akciu, ktorú na webe sami vykonáte, ako je nastavenie zabezpečenia, prihlásenia a vyplňovania formulárov. Svoj prehliadač môžete nastaviť tak, aby blokoval súbory cookie alebo o nich zasielal upozornenia. Majte na pamäti, že niektoré stránky nebudú bez týchto súborov fungovať. Tieto súbory cookie neukladajú žiadne informácie, ktoré je možné priradiť konkrétnej osobe. Tieto súbory cookie môžeme nastaviť my alebo poskytovatelia tretích strán, ktorých služby na webe využívame. Tieto súbory cookie neukladajú žiadne informácie, ktoré je možné priradiť konkrétnej osobe.",
  "text279": "Vaše nastavenie cookies z tohto dialógu",
  "text280": "Analytické cookies",
  "text281": "Tieto súbory cookie sa používajú na zlepšenie fungovania webových stránok. Umožňujú nám rozpoznať a sledovať počet návštevníkov a sledovať, ako návštevníci web používajú. Pomáhajú nám zlepšovať spôsob, akým webové stránky fungujú, napríklad tým, že používateľom umožňujú ľahko nájsť to, čo hľadajú. Tieto súbory cookie nezhromažďujú informácie, ktoré by vás mohli identifikovať. Pomocou týchto nástrojov analyzujeme a pravidelne zlepšujeme funkčnosť našich webových stránok. Získané štatistiky môžeme využiť na zlepšenie užívateľského komfortu a na to, aby bola návšteva Webu pre vás ako používateľa zaujímavejšia.",
  "text282": "Google Analytics - ukladá a počíta počet zobrazení stránok a správania webu",
  "text283": "Google Tag Manager - prepojenie konverzií",
  "text284": "Incomaker - ukladá a počíta zobrazenie stránok a konverzie",
  "text285": "Marketingové cookies",
  "text286": "Používajú sa na sledovanie preferencií webu užívateľa za účelom zacielenia reklamy, tj zobrazovania marketingových a reklamných oznámení (aj na stránkach tretích strán), ktoré môžu návštevníka webu zaujímať, v súlade s týmito preferenciami. Marketingové cookies využívajú nástroje externých spoločností. Tieto marketingové súbory cookie budú použité iba s vaším súhlasom.",
  "text287": "Facebook Pixel - zobrazovanie reklám a odovzdávanie informácií do Facebooku",
  "text288": "Nahrať",
  "text289": "Výmena tovaru",
  "text290": "Vrátenie peňazí",
  "text291": "Údaje zákazníka",
  "text292": "Číslo faktúry",
  "text293": "Bankové údaje",
  "text294": "IBAN",
  "text295": "SWIFT",
  "text296": "Dôvod vrátenia",
  "text297": "Vyberte tovar zo zoznamu, ktorý chcete vrátiť",
  "text298": "E-shop",
  "text299": "Kamenný obchod",
  "text300": "E-shop + Kamenný obchod",
  "text301": "Dostali sme Vašu žiadosť na vrátenie. Môžete začať chystať balík.",
  "text302": "Peniaze Vám vrátime okamžite po obdržaní Vami vráteného tovaru, najneskôr do 14 dní.",
  "text303": "Objednávali ste si tovar s platbou vopred? Pokiaľ ste tovar ešte nezaplatili, my upravíme čiastku k úhrade, aby nezahrňovala Vami vrátený tovar.",
  "text304": "Vraciate:",
  "text305": "Číslo objednávky:",
  "text306": "Vami vrátený tovar sme prijali. Ďakujeme veľmi pekne. Peniaze už sú na ceste k Vám. Spôsob vrátenia peňazí bude závisieť na spôsobe platby, ktorú ste si v objednávke vybrali.",
  "text307": "Ak by sa Vaše údaje o produktoch, ktoré ste nahlásili zo svojho užívateľského účtu, líšili od vrátených produktov, potom si vyhradzujeme právo opäť zaťažiť Vašu kreditnú kartu už uhradenou čiastkou.",
  "text308": "Vezmite prosím na vedomie, že každý vrátený balík je spracovaný zvlášť. V prípade, že ste odoslali ďalšie produkty v inom balíku, obdržíte samostatné potvrdenie o prijatí.",
  "text309": "Vrátené produkty:",
  "text310": "Nová",
  "text311": "Schválená",
  "text312": "Zamietnutá",
  "text313": "Zrušená",
  "text314": "V procese",
  "text315": "Žiadosť o vrátenie",
  "text316": "Potvrdenie položiek",
  "text317": "Vaša reklamácia bola zrušená",
  "text318": "Vašu reklamáciu spracovávame",
  "text319": "Vaša reklamácia nebola schválená",
  "text320": "Vaša žiadosť nebola spracovaná",
  "text321": "Odber noviniek",
  "text322": "/vymena-a-vratenie-tovaru",
  "text323": "Výmena a vrátenie tovaru",
  "text324": "Údaje firmy",
  "text325": "Doména Vašeho eshopu",
  "text326": "Pridať ďalšiu doménu",
  "text327": "Ďalšie domény",
  "text328": "Názov firmy",
  "text329": "Pridať adresu prevádzky",
  "text330": "Adresa prevádzky",
  "text331": "Názov obchodu",
  "text332": "Prihlasovacie meno",
  "text333": "Prílohy",
  "text334": "Výpis z obchodného registra",
  "text335": "Vyberte prílohu",
  "text336": "Súhlasím s obchodnými podmienkami",
  "text337": "Podkategórie",
  "text338": "Zobraziť viac",
  "text339": "Dostupnosť",
  "text340": "Cena",
  "text341": "Filtrovať podľa",
  "text342": "Vami zvolený produkt bol pridaný do košíka.\n",
  "text343": "Košík",
  "text344": "Cena platby",
  "text345": "Cena dopravy",
  "text346": "Zvoľte spôsob dopravy",
  "text347": "Číslo kupónu",
  "text348": "Zvoľte spôsob platby",
  "text349": "Zdarma",
  "text350": "Zhrnutie objednávky",
  "text351": "Cena tovaru",
  "text352": "Objednávka bola odoslaná",
  "text353": "Vaša objednávka č.",
  "text354": "bola zaznamenaná a aktuálne ju vybavujeme. Prosím skontrolujte si Váš email",
  "text355": "pre viac informácií o objednávke",
  "text356": "Potvrdiť heslo",
  "text357": "Prihláste sa",
  "text358": "Máte účet?",
  "text359": "Dodacie údaje",
  "text360": "Kontaktné údaje",
  "text361": "Nákup na firmu",
  "text362": "Vytvorte si účet a využívajte výhody registrovaného zákazníka.",
  "text363": "Súhlasím s obchodnými podmienkami.",
  "text364": "Súhlasím s ochranou osobných údajov.",
  "text365": "Dodacia adresa je iná ako fakturačná",
  "text366": "Dropshipping",
  "text367": "Adresa prevádzky",
  "text368": "Nastavenia osobných údajov",
  "text369": "Zmeniť adresu dodania",
  "text370": "Pokračovať do pokladne",
  "text371": "Odoberať novinky a dostávať aktuálne informácie o akciách",
  "text372": "Vrátenie tovaru",
  "text373": "Vrátený tovar",
  "text374": "Čo si prajete vrátiť ?",
  "text375": "Za posledných 30 dní ste si nič neobjednali.",
  "text376": "Potvrdiť vrátenie produktov",
  "text377": "Zrušiť",
  "text378": "moj-ucet-vrateny-tovar",
  "text379": "moj-ucet-vratit-tovar-1",
  "text380": "moj-ucet-vratit-tovar-2",
  "text381": "moj-ucet-vratit-tovar-3",
  "text382": "Slovensko",
  "text383": "Česko",
  "text384": "Maďarsko",
  "text385": "Prihlasovacie údaje",
  "text386": "Čítať",
  "text387": "Vo Vašom košíku",
  "text388": "Pre obnovu zabudnutého hesla zadajte Váš email",
  "text389": "Dátum narodenia",
  "text390": "Použiť",
  "text391": "/vseobecne-obchodne-podmienky",
  "text392": "/ochrana-osobnych-udajov",
  "text393": "Dátum objednávky",
  "text394": "Číslo objednávky",
  "text395": "Vyberte dôvod",
  "text396": "Tovar nezodpovedá popisu",
  "text397": "Obdržal som nesprávny produkt",
  "text398": "Táto položka sa mi nepáči",
  "text399": "Položka je príliš veľká",
  "text400": "Produkt je poškodený",
  "text401": "Produkt prišiel neskoro",
  "text402": "Produkt je príliš malý",
  "text403": "Produkt je príliš drahý",
  "text404": "Žiadne podrobnosti",
  "text405": "Vrátiť",
  "text406": "predmet/y spoločnosti",
  "text407": "Predmety, ktoré vraciate spoločnosti",
  "text408": "Zaslali sme Vám prehľad Vami vrátených produktov na",
  "text409": "Vaše produkty sú pripravené k vráteniu",
  "text410": "Čo ďalej?",
  "text411": "Pripravte balík",
  "text412": "Teraz stačí balík odoslať",
  "text413": "Získajte späť svoje peniaze",
  "text414": "Zabaľte želané produkty, pribaľte štítok na vrátenie tovaru a na balík prilette spätnú adresu. A vedeli ste, že tovar, ktorý Vám prišiel v niekoľkých balíkoch, môžete vrátiť dohromady v jednom balení? Jednoducho pribaľte štítky o vrátení tovaru z každej objednávky",
  "text415": "Balík odneste do nejbližšího logistického centra, které jste zvolili ve formuláři ",
  "text416": "Peniaze Vám vrátime okamžite po obdržaní Vami vráteného tovaru, najneskôr do 14 dní po tom. Objednávali ste tovar s platbou vopred? Pokiaľ ste tovar ešte nezaplatili, my upravíme čiastku na úhradu, aby nezahŕňala Vami vrátený tovar",
  "text417": "Počet produktov",
  "text418": "Vrátiť spoločnosti",
  "text419": "Status",
  "text420": "Vytvorené dňa",
  "text421": "Nemáte žiadny vrátený tovar.",
  "text422": "Nastavte si IBAN aj SWIFT v nastavení účtu.",
  "text423": "Nemáte nastavené bankové údaje",
  "text424": "Nakúpte ešte za",
  "text425": "a dopravu máte",
  "text426": "ZADARMO",
  "text427": "Gratulujeme, dopravu máte",
  "text428": "Vaša správa bola úspešne odoslaná!",
  "text429": "Chyba, Vaša správa nebola odoslaná!",
  "text430": "",
  "text431": "Email existuje; použite prosím iný.",
  "text432": "Registrácia úspešná.",
  "text433": "Kód varianty",
  "text434": "moj-ucet-vratit-tovar-1",
  "text435": "Predajná jednotka",
  "text436": "a ochranou osobných údajov",
  "text437": "Štítky",
  "text438": "Číslo ulice",
  "text439": "Načítavam",
  "text440": "Vybrať odberné miesto",
  "text441": "Vyberte variantu",
  "text442": "Pridať medzi obľúbené",
  "text443": "bez DPH",
  "text444": "Cena je orientačná",
  "text445": "Žiadne položky",
  "text446": "Opýtať sa na produkt",
  "text447": "Recenzie",
  "text448": "Doplnkové služby",
  "text449": "Balíčky",
  "text450": "Odoslať",
  "text451": "Video",
  "text452": "Celý popis",
  "text453": "Ospravedlňujeme sa, tento produkt máme na sklade iba v množstve",
  "text454": "do košíka už nemôžete pridať kusy.",
  "text455": "Ok",
  "text456": "Prejsť do košíka",
  "text457": "",
  "text458": "Váš nákupný košík čaká",
  "text459": "Pri svojej poslednej návšteve ste nedokončili objednávku. Tovar, ktorý ste si vybrali na vás čaká vo vašom košíku. Nenechajte si ho ujsť a dokončite svoj nákup teraz.",
  "text460": "Vaša objednávka bola úspešne prijatá. Skontrolujte si emailovú schránku prosím.",
  "text461": "Vaša správa bola úspešne odoslaná!",
  "text462": "Email je povinný údaj.",
  "text463": "Zadaná emailová adresa nie je platná.",
  "text464": "Email môže mať max 255 znakov.",
  "text465": "Zadaný email je už zaregistrovaný.",
  "text466": "Heslo je povinný údaj.",
  "text467": "Heslo musí mať najmenej 6 znakov.",
  "text468": "Heslá sa nezhodujú.",
  "text469": "Súhlas s obchodnými podmienkami je povinný údaj.",
  "text470": "Skontrolujte formulár captcha.",
  "text471": "Prejsť do online poradne",
  "text472": "Zobraziť témy otázok a odpovedí",
  "text473": "Skryť témy otázok a odpovedí",
  "text474": "Prejsť do blogu",
  "text475": "Poradňa",
  "text476": "Spýtajte sa priamo nášho lekárnika",
  "text477": "Žiadne možnosti",
  "text478": "Vyberte kategórie",
  "text479": "na objednávku nad",
  "text480": "Späť do obchodu",
  "text481": "Cena / ks s DPH",
  "text482": "Cena spolu",
  "text483": "Cena / ks bez DPH",
  "text484": "",
  "text485": "Číslo domu",
  "text486": "Profil",
  "text487": "Zmeniť údaje",
  "text488": "Zabezpečenie",
  "text489": "Zmeniť miesto",
  "text490": "Načítať ďalšie",
  "text491": "Moje údaje",
  "text492": "Sledujte nás",
  "text493": "Najpredávanejšie",
  "text494": "Všetky produkty",
  "text495": "Nedostupné",
  "text496": "Vyberte si variant",
  "text497": "",
  "text498": "",
  "text499": "",
  "text500": "",
  "text501": "",
  "text502": "Celé meno",
  "text503": "Potvrďte nové heslo",
  "text504": "Prosím, potvrďte súhlas s podmienkami o ochrane osobných údajov.",
  "text505": "Zadaná e-mailová adresa je už prihlásená na odber noviniek.",
  "text506": "Prosím, skontrolujte si e-mailovú schránku.",
  "text507": "Výdajné miesto",
  "text508": "Opýtať sa na produkt",
  "text509": "Otázka na dostupnosť tovaru",
  "text510": "Špeciálna ponuka",
  "text511": "Šírka",
  "text512": "Dĺžka",
  "text513": "Výška",
  "text514": "Váha",
  "text515": "Hodnotené dňa ",
  "text516": "Obľúbené",
  "text517": "Vrátiť sa na hlavnú stránku",
  "text518": "Stav produktu",
  "text519": "Krajina",
  "text520": "Dodacie a fakturačné údaje",
  "text521": "Už ste u nás nakupovali?",
  "text522": "Späť do košíka",
  "text523": "Zľavový kupón",
  "text524": "Pridať k objednávke",
  "text525": "Obsah nákupného košíka",
  "text526": "Pokračovať v objednávke",
  "text527": "Zdieľať produkt",
  "text528": "Skryť popis",
  "text529": "Celý popis",
  "text530": "Došlo k chybe, skúste to za chvíľu znova.",
  "text531": "Pridať do obľúbených",
  "text532": "Odobrať z obľúbených",
  "text533": "Detail",
  "text534": "Nová rezervácia",
  "text535": "Rezervácia úspešne vytvorená",
  "text536": "Zľava pre platbu",
  "text537": "Odhlásiť sa z odberu",
  "text538": "Vybrať termín",
  "text539": "Odberné miesto",
  "text540": "Termín",
  "text541": "Zľava pre zákazníka",
  "text542": "Sumárna expedovaná objednávka č.",
  "text543": "Objednávka č.",
  "text544": "Neprihlásený používateľ",
  "text545": "Kupón je platný",
  "text546": "Kupón neexistuje, vypršala jeho platnosť alebo nie sú splnené podmienky na aplikovanie kupónu",
  "text547": "Kupón je neplatný",
  "text548": "Kupón bol pridaný",
  "text549": "Odpoveď",
  "text550": "Na otázku odpovedal",
  "text551": "Spýtať sa otázku",
  "text552": "Názov",
  "text553": "Pre napísanie vlastnej otázky do poradne musíte byť prihlásený",
  "text554": "Nenašli sme žiadne vyhovujúce záznamy",
  "text555": "Dnes má meniny",
  "text556": "Upozornenie",
  "text557": "Nesprávne prihlasovacie údaje",
  "text558": "Pôvodné heslo sa nezhoduje",
  "text559": "Záujem o prácu",
  "text560": "Nový uchádzač",
  "text561": "Ďakujeme za vašu objednávku, ktorú začneme spracovávať ihneď po jej zaplatení.",
  "text562": "Platba úspešná.",
  "text563": "Platba neúspešná.",
  "text564": "Overenie Captcha zlyhalo.",
  "text565": "Žiadne parametre",
  "text566": "Filter produktov",
  "text567": "Potrebujem poradiť",
  "text568": "Kontakt a podpora",
  "text569": "Napíšte nám",
  "text570": "Sledujte nás na sociálnych sieťach",
  "text571": "Doprava a platba",
  "text572": "Vernostný program",
  "text573": "Pri prihlasovaní do newslettera nastala chyba",
  "text574": "Odoberanie noviniek e-mailom",
  "text575": "Chcete byť informovaní o akciách a zľavách medzi prvými? Stačí zadať e-mailovú adresu.",
  "text576": "Ďakujeme za prihlásenie do newslettera. Na e-mailovú adresu vám bolo zaslané potvrdenie prihlásenia.",
  "text577": "Články",
  "text578": "Online chat",
  "text579": "Online poradňa",
  "text580": "Produktové poradenstvo",
  "text581": "Často kladené otázky",
  "text582": "Osobný odber",
  "text583": "Novinky",
  "text584": "Akcie",
  "text585": "Napísať recenziu",
  "text586": "Recenzia",
  "text587": "Hodnotenie",
  "text588": "Zobraziť viac článkov",
  "text589": "Témy",
  "text590": "Vyhľadajte článok",
  "text591": "Prečítať celý článok",
  "text592": "Uverejnené",
  "text593": "Aby ste mohli napísať recenziu musíte byť prihlásený.",
  "text594": "Niečo sa pokazilo",
  "text595": "Skúsiť znova",
  "text596": "Skryť odpoveď",
  "text597": "Zobraziť odpoveď",
  "text598": "Populárne články",
  "text599": "Filtrovať kategórie",
  "text600": "Späť na stránku blogov",
  "text601": "Nájdi svoju prácu snov!",
  "text602": "Krajina doručenia",
  "text603": "Krajinu doručenia viete zmenit v predchádzajúcom kroku",
  "text604": "Zobraziť menej",
  "text605": "",
  "text606": "maximálne",
  "text607": "Vybrali sme pre vás",
  "text608": "Žiadne recenzie",
  "text609": "Chcem dostávať e-maily s novinkami o aktuálnych trendoch, akciách a zľavových kupónoch. Z odberu sa môžeš kedykoľvek zdarma odhlásiť.",
  "text610": "Odber noviniek",
  "text611": "Potrebujete poradiť?",
  "text612": "Kontaktujte nás:",
  "text613": "Súhlasím so",
  "text614": "spracovaním osobných údajov",
  "text615": "Správa",
  "text616": "Obchodné údaje",
  "text617": "Údaje o prevádzke",
  "text618": "Obchodný register",
  "text619": "Názov banky",
  "text620": "Ak ste u nás ešte nenakupovali a nemáte svoj účet,",
  "text621": "vytvorte si ho tu",
  "text622": "Zabudol som heslo",
  "text623": "Máte už svoj účet?",
  "text624": "Prihláste sa.",
  "text625": "Registráciou účtu súhlasíte s našimi",
  "text626": "podmienkami používania.",
  "text627": "Prečítajte si naše",
  "text628": "Zásady ochrany osobných údajov.",
  "text629": "Áno, chcem dostávať príležitostné e-maily so špeciálnymi ponukami. Svoje prihlásenie môžem kedykoľvek zrušiť. (Nepovinné)",
  "text630": "Heslo musí obsahovať aspoň 8 znakov.",
  "text631": "Pridané do košíka",
  "text632": "Vyčistiť",
  "text633": "Všetky blogy",
  "text634": "Zobraziť výsledky",
  "text635": "Napísať otázku",
  "text636": "Zobraziť odpoveď od špecialistu",
  "text637": "V tejto kategórii sa zatiaľ nenachádzajú žiadne otázky",
  "text638": "Späť na hlavnú stránku poradne",
  "text639": "Projekt vytvoril",
  "text640": "Všetky práva vyhradené.",
  "text641": "Doprava a spôsob platby",
  "text642": "Vaša otázka sa zobrazí po schválení administrátorom",
  "text643": "Ďakujeme",
  "text644": "alebo napíšte na",
  "text645": "Aktivovať zľavový kód",
  "text646": "Kód kupónu",
  "text647": "Uplatniť zľavový kód",
  "text648": "Recenzia bola pridaná",
  "text649": "Heslo bolo úspešne zmenené",
  "text650": "Nepodarilo sa zmenit heslo",
  "text651": "Nastala chyba pri obnovení hesla",
  "text652": "Obdržali ste e-mail na obnovenie hesla",
  "text653": "Pri registrácii nastala chyba",
  "text654": "Úspešne ste sa registrovali",
  "text655": "Pri prihlásení nastala chyba",
  "text656": "Boli ste prihlásený",
  "text657": "Nastala chyba pri odosielaní kontaktného formulára",
  "text658": "Kontaktný formulár bol úspešne odoslaný",
  "text659": "Vaša otázka bola úspešne odoslaná",
  "text660": "Nastala chyba pri odosielaní otázky",
  "text661": "Nastala chyba pri vytvorení recenzie",
  "text662": "Cena / ks",
  "text663": "Spolu",
  "text664": "Darček",
  "text665": "Sledujte nás na instagrame",
  "text666": "Zobraziť instagram",
  "text667": "Farba je v nesprávnom formáte.",
  "text668": "viac..",
  "text669": "Kúpiť",
  "text670": "Zobraziť všetky produkty",
  "text671": "Blogy",
  "text672": "Žiadne štítky",
  "text673": "Žiadne blogy",
  "text674": "Žiadne kategórie",
  "text675": "Medzisúčet",
  "text676": "Už ste u nás nakupovali?",
  "text677": "Ak ste u nás už nakupovali, prihláste sa do svojho konta pre automatické doplnenie údajov k objednávke a zrýchlenie procesu dokončenia objednávky.",
  "text678": "Som nový zákazník",
  "text679": "Fakturačné údaje",
  "text680": "Poškodený produkt",
  "text681": "Nevhodný darček",
  "text682": "Nechcem uviesť",
  "text683": "Vyberte dôvod",
  "text684": "Kuriér",
  "text685": "Vrátených produktov: ",
  "text686": "Zrušiť vrátenie",
  "text687": "Potvrdiť vrátenie produktu",
  "text688": "Firemná adresa",
  "text689": "Údaje o firme",
  "text690": "Otváracie hodiny",
  "text691": "Overiť dostupnosť",
  "text692": "E-recept",
  "text693": "Rezervácia e-recept",
  "text694": "Vernostná karta",
  "text695": "Chcem kartu",
  "text696": "Mám kartu",
  "text697": "Rodné číslo",
  "text698": "Telefón je nevyhnutný pre informovanie o stave rezervácie",
  "text699": "Vaše rodné číslo potrebujeme pre overenie receptu",
  "text700": "Odoslať rezerváciu receptu",
  "text701": "Vyberte mesto",
  "text702": "Číslo vernostnej karty",
  "text703": "Názov produktu",
  "text704": "Zadajte názov produktu/číslo čiarového kódu",
  "text705": "Vyhľadávanie podľa názvu alebo čiarového kódu - číslice pod čiarovým kódom produktu",
  "text706": "Produkt na mieru",
  "text707": "Napíšte venovanie...",
  "text708": "Vyberte dátum doručenia",
  "text709": "Zobraziť viac podkategórií",
  "text710": "Skryť podkategórie",
  "text711": "Mám papierový recept",
  "text712": "Nastavte si IBAN aj SWIFT v nastavení účtu",
  "text713": "Vrátenie sme úspešne zaevidovali",
  "text714": "Vrátené objednávky",
  "text715": "Vrátenie tovaru",
  "text716": "Dátum vrátenia",
  "text717": "Stiahnúť",
  "text718": "Dodávatelia",
  "text719": "Informácie o produkte",
  "text720": "Cena produktu",
  "text721": "Prejsť do obchodu",
  "text722": "Zmena stavu reklamácie",
  "text723": "Môže obsahovať iba formát, kde sa nachádzajú maximálne 4 čísla pred desatinou čiarkou a 8 po desatinej čiarke.",
  "text724": "Kde všade sme už boli",
  "text725": "Pokračovať na hlavnú stránku",
  "text726": "Zadajte číslo objednávky a email",
  "text727": "Odkaz",
  "text728": "Lokalita dodávateľa",
  "text729": "Minimálny počet znakov je ",
  "text730": "Maximálny počet znakov je",
  "text731": "Toto pole nemôže byť prázdne",
  "text732": "Emailová adresa musí byť platná",
  "text733": "Telefónne číslo musí byť platné",
  "text734": "Toto pole je povinné",
  "text735": "Dátum musí byť platný",
  "text736": "Zadaný vstup musí byť číslo",
  "text737": "Zadaný vstup musí byť celé číslo",
  "text738": "Zadaný vstup musí byť desatinné číslo",
  "text739": "Heslá sa nezhodujú",
  "text740": "Musíte súhlasiť s GDPR",
  "text741": "Musíte súhlasiť s podmienkami používania",
  "text742": "Musíte vybrať aspoň jeden produkt",
  "text743": "Vyplnte údaje o benefitnej karte alebo svoje meno",
  "text744": "Súvisiace produkty",
  "text745": "Prihlásený ako",
  "text746": "Vyhľadávať",
  "text747": "Kľúčové slovo",
  "text748": "Vzdialenosť",
  "text749": "Kategória",
  "text750": "Povinné políčka",
  "text751": "Kontaktujte nás kedykoľvek, ak máte nejakú špeciálnu požiadavku alebo ak máte nejaké otázky.",
  "text752": "Žiadne výsledky",
  "text753": "Zvolené dni sú nedostupné",
  "text754": "Upraviť",
  "text755": "Vymazať účet",
  "text756": "Podnikanie",
  "text757": "V prípade, že by sme Vás potrebovali kontaktovať ohľadom Vašej objednávky.",
  "text758": "Vytvoriť účet",
  "text759": "Žiadny dodávatelia sa vo vybranej vzdialenosti nenachádzajú",
  "text760": "Vyberte dodávateľa",
  "text761": "Vyberte mesto",
  "text762": "Vyplňte svoju fakturačnú adresu, aby ste to nemuseli robiť pri každej objednávke.",
  "text763": "Pre vyplnenie veľkoobchodného formulára je potrebné byť prihlásený.",
  "text764": "Veľkoobchod",
  "text765": "Gratulujeme! Už ste registrovaný ako veľkoobchod.",
  "text766": "Typ firmy a dómeny",
  "text767": "Kontaktné informácie",
  "text768": "Maximálna veľkosť súboru 2MB",
  "text769": "Dropshipping",
  "text770": "Objednávka na sklad",
  "text771": "Adresa dropship doručenia",
  "text772": "Osobné a kontaktné údaje",
  "text773": "Adresa doručenia tovaru",
  "text774": "Váš formulár bol úspešne odoslaný. V čo najkratšej dobe Vás budeme kontaktovať ohľadom veľkoobchodných podmienok.",
  "text775": "Povoľte získavanie polohy",
  "text776": "Je potrebné vybrať dátum doručenia",
  "text777": "Je potrebné vybrať konkrétne výdajné miesto",
  "text778": "Cena balíčka je vyššia ako povolená hodnota.",
  "text779": "Balíček obsahuje",
  "text780": "Balíček nemá maximálnu cenu",
  "text781": "Zadajte PSČ",
  "text782": "Zadajte Mesto",
  "text783": "Vypočítať cenu",
  "text784": "Poslať do útulku",
  "text785": "Značka",
  "text786": "Otázka pre lekárnika",
  "text787": "Na otázku odpovedala",
  "text788": "Pracovné ponuky",
  "text789": "Online poradňa",
  "text790": "Skryť témy otázok a odpovedí",
  "text791": "Zobraziť témy otázok a odpovedí",
  "text792": "Zistiť viac",
  "text793": "Zobraziť všetky ponuky",
  "text794": "Detail ponuky",
  "text795": "Miesto výkonu práce",
  "text796": "Hrubá mzda",
  "text797": "Pracovný pomer",
  "text798": "Nástup",
  "text799": "Viac referencií",
  "text800": "Zavolajte nám",
  "text801": "Sme k dispozícií",
  "text802": "O spoločnosti",
  "text803": "Kontaktné údaje",
  "text804": "Dokumenty k objednávke",
  "text805": "Nie sú dostupné žiadne dokumenty pre túto objednávku",
  "text806": "Vyberte útulok",
  "text807": "Pozrieť detail",
  "text808": "Mám záujem o realizáciu",
  "text809": "z",
  "text810": "ponúk",
  "text811": "od",
  "text812": "v hrubom",
  "text813": "Mám záujem o pracovnú pozíciu",
  "text814": "Nahrať životopis",
  "text815": "Odoslať záujem",
  "text816": "Splátkova kalkulačka",
  "text817": "Pozrieť ponuku",
  "text818": "Konfigurátor",
  "text819": "Všetky realizácie",
  "text820": "Kde nás najdete",
  "text821": "Obchodné oddelenie",
  "text822": "Obchodní zástupcovia",
  "text823": "Právna poznámka",
  "text824": "Pozrieť technické parametre",
  "text825": "Prosím vyberte miesto doručenia",
  "text826": "Varianty",
  "text827": "Meniny má",
  "text828": "Na stiahnutie",
  "text829": "Nájsť prácu",
  "text830": "Populárne kategórie",
  "text831": "Nájdite typ práce, ktorý Vám vyhovuje! Práca začína ihneď po zakúpení a poskytnutí požiadaviek.",
  "text832": "otvorené pozície",
  "text833": "Vytvoriť životopis",
  "text834": "Vytvorte si svoj profil a nájdite tisíce pracovných miest, vybudujte si svoju kariéru a\n        zamestnanie!",
  "text835": "Najnovšie pracovné ponuky",
  "text836": "Nájdite typ práce, ktorý Vám vyhovuje! Práca začína ihneď po zakúpení a poskytnutí požiadaviek.",
  "text837": "Poslať životopis",
  "text838": "/ mesačne",
  "text839": "Je potrebné vybrať útulok",
  "text840": "Útulky, ktoré s nami môžete podporiť",
  "text841": "Mám viac ako 18 rokov",
  "text842": "Obsah tejto stránky nie je vhodný pre osoby",
  "text843": "mladšie ako 18 rokov.",
  "text844": "Všetko",
  "text845": "Iba nové",
  "text846": "Iba použité",
  "text847": "Typ",
  "text848": "Rok",
  "text849": "Model",
  "text850": "Moje životopisy",
  "text851": "Náhľad CV",
  "text852": "Vymazanie účtu",
  "text853": "Po vymazaní účtu nebude možné vaše údaje obnoviť.",
  "text854": "Vymazať účet",
  "text855": "Nastavenia",
  "text856": "Mám záujem o zasielanie pracovných ponúk e-mailom",
  "text857": "Preferovaný jazyk",
  "text858": "Prejsť na všetky pracovné ponuky",
  "text859": "Životopis",
  "text860": "Krok",
  "text861": "Základné údaje",
  "text862": "Fotografia",
  "text863": "Pracovné skúsenosti",
  "text864": "Vzdelanie",
  "text865": "Znalosti",
  "text866": "Jazyky",
  "text867": "Doplňujúce časti",
  "text868": "Záverečné nastavenia",
  "text869": "Vyhľadajte podľa kľúčoveho slova, názvu firmy",
  "text870": "Obec, okres, kraj",
  "text871": "Vyhľadať",
  "text872": "Ulica a číslo",
  "text873": "Nahrajte vašu fotografiu",
  "text874": "Fotografia nie je povinná, no životopis s fotkou pôsobí osobnejšie a personalistu zaujme\n        viac.",
  "text875": "Vedeli ste, že personalistovi stačí v priemere 7 sekúnd na prvé preskenovanie životopisu? Spomeňte preto len relevantné skúsenosti a popíšte ich v odrážkach alebo v krátkych odsekoch.",
  "text876": "Názov pozície, spoločnosť",
  "text877": "Mesto alebo PSČ",
  "text878": "Aké máte vzdelanie?",
  "text879": "Dajte zamestnávateľom vedieť, aké je vaše vzdelanie",
  "text880": "Pridať vzdelanie",
  "text881": "Ponuka práce",
  "text882": "Aktívne ponuky",
  "text883": "Zameranie",
  "text884": "Vysoká škola",
  "text885": "Stredná škola",
  "text886": "Kurz alebo certifikát",
  "text887": "Mám záujem o prácu",
  "text888": "Vaše zručnosti a znalosti",
  "text889": "Zadajte, aké zručnosti a znalosti ovládate, a na akej úrovni.",
  "text890": "Profesia",
  "text891": "Jazyk ktorý ovládate",
  "text892": "Uvádzať akademický titul pri mene",
  "text893": "Plat",
  "text894": "Druh pracovného pomeru",
  "text895": "Reakcia na pracovnú ponuku",
  "text896": "Informácie k profesii",
  "text897": "Ak už máte svoj účet,",
  "text898": "Nepovinné prílohy",
  "text899": "Životopis, Motivačný list, Vyhlášky, certifikáty, iné... (max. 10MB)",
  "text900": "Jazyk ktorý ovládate",
  "text901": "Vyberte jazyk",
  "text902": "Titul",
  "text903": "Kraj",
  "text904": "Vyberte krajinu",
  "text905": "Vyberte kraj",
  "text906": "Maximálna veľkosť súboru je 10MB",
  "text907": "Pridať prílohu",
  "text908": "Počet príloh",
  "text909": "Vodičský preukaz",
  "text910": "Aké vlastníte vodičské oprávnenia?",
  "text911": "Ako si radi vypĺňate voľný čas?",
  "text912": "Záujmy alebo koníčky",
  "text913": "Krátko a výstižne popíšte ako radi trávite voľný čas.",
  "text914": "Obsah životopisu máte hotový. Doplňte si ešte tieto údaje, ktoré Vám pomôžu pri hľadaní práce na pracaslovensko.sk",
  "text915": "Pracovná pozícia",
  "text916": "V akej oblasti alebo na akej konkrétnej pozícii by ste chceli pracovať?",
  "text917": "Pracovná oblasť",
  "text918": "Vyberte pracovnú oblasť",
  "text919": "Miesto práce",
  "text920": "V akej lokalite si hľadáte prácu?",
  "text921": "Druh pracovného pomeru",
  "text922": "Označte, aký typ pracovného úväzku by vám vyhovoval",
  "text923": "Termín nástupu",
  "text924": "Uveďte termín možného nástupu",
  "text925": "Očakávaný minimálny plat (v hrubom)",
  "text926": "Uveďte Vašu predstavu o minimálnom plate (v hrubom).",
  "text927": "Preferované pracovné zmeny",
  "text928": "Uveďte Vaše preferencie pre pracovné zmeny",
  "text929": "Zdravotné znevýhodnenie",
  "text930": "Ste pracovne znevýhodnený?",
  "text931": "Pracovné ponuky e-mailom?",
  "text932": "Chcete, aby sme vám vyhovujúce pracovné ponuky posielali na e-mail?",
  "text933": "Mesto/Obec",
  "text934": "Ihneď",
  "text935": "Dohodou",
  "text936": "Suma od (EUR)",
  "text937": "Mám záujem aj o zamestnanie, v ktorom by som pracoval aj počas víkendov",
  "text938": "Mám záujem aj o prácu v noci",
  "text939": "Mám pracovnú invaliditu",
  "text940": "41% - 70%",
  "text941": "Viac ako 70%",
  "text942": "Doplňujúce informácie",
  "text943": "Mám záujem o zasielanie pracovných ponúk e-mailom",
  "text944": "Osobné zhrnutie",
  "text945": "Napíšte o sebe krátke zhrnutie v 2 - 3 vetách.",
  "text946": "Doplňujúce informácie",
  "text947": "Chcete ešte niečo doplniť? Napíšte to sem.",
  "text948": "Vložte súbory alebo premiestnite sem",
  "text949": "PNG, JPG, GIF",
  "text950": "Vybrať súbor",
  "text951": "Pridať zamestnanie",
  "text952": "Časové odbobie",
  "text953": "Popis práce",
  "text954": "Krátko a výstižne popíšte vašu náplň práce.",
  "text955": "Pridanie zamestnania",
  "text956": "Názov pracovnej pozície",
  "text957": "Zamestnávateľ",
  "text958": "Mesto/obec",
  "text959": "Krajina",
  "text960": "Časové obdobie",
  "text961": "Aktuálne tu pracujem",
  "text962": "Od mesiaca",
  "text963": "Od roku",
  "text964": "Do mesiaca",
  "text965": "Do roku",
  "text966": "Popis práce",
  "text967": "Krátko a výstižne popíšte vašu náplň práce.",
  "text968": "Vysoká škola",
  "text969": "Fakulta",
  "text970": "Odbor",
  "text971": "Stredná škola",
  "text972": "Názov kurzu",
  "text973": "Popis štúdia",
  "text974": "Krátko a výstižne popíšte vaše štúdium",
  "text975": "Úplný začiatočník",
  "text976": "Základy",
  "text977": "Mierne pokročilý",
  "text978": "Pokročilý",
  "text979": "Expert",
  "text980": "Pridať jazyk",
  "text981": "Pridať znalosť",
  "text982": "Úplný začiatočník (A1)",
  "text983": "Začiatočník (A2)",
  "text984": "Mierne pokročilý (B1)",
  "text985": "Stredne pokročilý (B2)",
  "text986": "Pokročilý (C1)",
  "text987": "Expert (C2)",
  "text988": "Pridanie jazyka",
  "text989": "Jazyk",
  "text990": "Úroveň jazyka",
  "text991": "Nemáte pridané žiadne vzdelanie",
  "text992": "dnes",
  "text993": "Kurz alebo certifikát",
  "text994": "Táto webstránka používa súbory cookies",
  "text995": "Na prispôsobenie obsahu a reklám, poskytovanie funkcií sociálnych médií a analýzu návštevnosti používame súbory cookie. Informácie o tom, ako používate naše webové stránky, poskytujeme aj našim partnerom v oblasti sociálnych médií, inzercie a analýzy. Títo partneri môžu príslušné informácie skombinovať s ďalšími údajmi, ktoré ste im poskytli alebo ktoré od vás získali, keď ste používali ich služby.",
  "text996": "Povoliť všetko",
  "text997": "Odmietnuť",
  "text998": "Prispôsobiť",
  "text999": "Nastavenie cookies",
  "text1000": "Služby",
  "text1001": "Vaše možnosti ochrany súkromia",
  "text1002": "V tejto časti môžete vyjadriť niektoré preferencie týkajúce sa spracovania vašich osobných údajov. Možete kedykoľvek preskúmať a zmeniť vyjadrené voľby tým, že znovu zobrazíte tento panel prostredníctvom poskytnutého odkazu. Ak chcete odmietnuť svoj súhlas so špecifickými činnosťami spracovania opísanými nižšie, prepínače prepnite na vypnuté alebo použite tlačidlo „Odmietnuť všetko“ a potvrďte, že chcete uložiť svoje voľby.",
  "text1003": "Potrebné",
  "text1004": "Potrebné súbory cookie pomáhajú vytvárať použiteľné webové stránky tak, že umožňujú základné funkcie, ako je navigácia stránky a prístup k chráneným oblastiam webových stránok. Webové stránky nemôžu riadne fungovať bez týchto súborov cookies.",
  "text1005": "Štatistiky a analýzy",
  "text1006": "Štatistické súbory cookies pomáhajú majiteľom webových stránok, aby pochopili, ako komunikovať s návštevníkmi webových stránok prostredníctvom zberu a hlásenia informácií anonymne.",
  "text1007": "Tabuľka súborov cookies",
  "text1008": "Cookie",
  "text1009": "Doména",
  "text1010": "Marketing",
  "text1011": "Marketingové súbory cookies sa používajú na sledovanie návštevníkov na webových stránkach. Zámerom je zobrazovať reklamy, ktoré sú relevantné a pútavé pre jednotlivých užívateľov, a tým cennejšie pre vydavateľov a inzerentov tretích strán.",
  "text1012": "Chcem vedieť viac",
  "text1013": "Pre získanie informácií o spracovaní osobných údajov a vašich právach v súvislosti s ochranou osobných údajov, nás môžte kontaktovať",
  "text1014": "tu.",
  "text1015": "Funkčné",
  "text1016": "Funkčné súbory cookie pomáhajú vykonávať určité funkcie, ako je zdieľanie obsahu webovej stránky na platformách sociálnych médií, zbieranie spätnej väzby a ďalšie funkcie tretích strán.",
  "text1017": "Uložiť nastavenia",
  "text1018": "Nemáte pridané žiadne pracovné skúsenosti",
  "text1019": "Nemáte pridané žiadne znalosti",
  "text1020": "Typ zručnosti a znalosti",
  "text1021": "Úroveň zručnosti a znalosti",
  "text1022": "Pridanie znalosti a zručnosti",
  "text1023": "Aké jazyky ovládate?",
  "text1024": "Zadajte jazyky, ktoré ovládate a ich úroveň",
  "text1025": "Nemáte pridané žiadne jazyky",
  "text1026": "Späť",
  "text1027": "Pokračovať",
  "text1028": "Uložiť",
  "text1029": "Hodnota musí byť z rozsahu",
  "text1030": "Pridanie vzdelania",
  "text1031": "Stále študujem",
  "text1032": "Popis štúdia",
  "text1033": "Titul",
  "text1034": "Technické informácie",
  "text1035": "Technické vlastnosti",
  "text1036": "Máte dotaz k produktu? Zašlete nám jej a rádi Vám jej zodpovíme.",
  "text1037": "Názov produktu",
  "text1038": "Odoslať dotaz",
  "text1039": "Súhlasím so spracovaním osobných údajov",
  "text1040": "Váš dotaz",
  "text1041": "Odoslať",
  "text1042": "Vaša otázka bola úspešne odoslaná",
  "text1043": "Otázku sa nepodarilo odoslať",
  "text1044": "Vaše meno",
  "text1045": "Rezy",
  "text1046": "Tento produkt je dostupný vo viacerých variantoch",
  "text1047": "Zdieľať na Facebooku",
  "text1048": "Minimálna výška",
  "text1049": "Minimálna šírka",
  "text1050": "Maximálna výška",
  "text1051": "Maximálna šírka",
  "text1052": "Barevné provedení",
  "text1053": "Január",
  "text1054": "Február",
  "text1055": "Marec",
  "text1056": "Apríl",
  "text1057": "Máj",
  "text1058": "Jún",
  "text1059": "Júl",
  "text1060": "August",
  "text1061": "September",
  "text1062": "Október",
  "text1063": "November",
  "text1064": "December",
  "text1065": "Dĺžka kurzu",
  "text1066": "Počet kapitol",
  "text1067": "Zadajte originálny názov náhradnej súčiastky",
  "text1068": "Spôsob platby",
  "text1069": "Pomocou účtu môžete sledovať svoje objednávky a spravovať faktúry",
  "text1070": "Iba nové",
  "text1071": "Iba použité",
  "text1072": "Použité diely",
  "text1073": "Blogové články, rady a tipy",
  "text1074": "Zostante v obraze",
  "text1075": "Viac o projekte",
  "text1076": "Detail akcie",
  "text1077": "Do konca akcie zostáva",
  "text1078": "Do začiatku akcie zostáva",
  "text1079": "Predchádzajúca lekcia",
  "text1080": "Ukončené",
  "text1081": "Krokov",
  "text1082": "Úspešnosť kurzu",
  "text1083": "Otvoriť celú diskusiu",
  "text1084": "Zapojiť sa do diskusie",
  "text1085": "Dĺžka kurzu",
  "text1086": "Zoznam kapitol",
  "text1087": "Popis kurzu",
  "text1088": "Najčastejšie otázky",
  "text1089": "Diskusia",
  "text1090": "Kúpiť kurz",
  "text1091": "Referencie",
  "text1092": "Označiť za splnené",
  "text1093": "Začať kurz",
  "text1094": "Ukončiť kurz",
  "text1095": "Ďalšia lekcia",
  "text1096": "Gratulujeme",
  "text1097": "Úspešne ste dokončili kurz",
  "text1098": "Bez",
  "text1099": "Medzera",
  "text1100": "Bodka",
  "text1101": "Čiarka",
  "text1102": "Neznámy",
  "text1103": "Nové heslo sa musí líšiť od starého",
  "text1104": "Účet",
  "text1105": "Vytvorené dňa",
  "text1106": "Medzisúčet",
  "text1107": "Zákaznícky účet nie je platný.",
  "text1108": "Potvrdenie hesla",
  "text1109": "Zakúpené školenia",
  "text1110": "Otvoriť",
  "text1111": "Školiteľ",
  "text1112": "Mohlo by sa vám páčiť",
  "text1113": "Súkromná osoba",
  "text1114": "Pridať adresu",
  "text1115": "Do košíka",
  "text1116": "Späť na videonávody",
  "text1117": "Cenová ponuka",
  "text1118": "Odoslať dopyt",
  "text1119": "Doručiť kompletne",
  "text1120": "Externé číslo objednávky",
  "text1121": "Export produktov dokončený",
  "text1122": "s DPH",
  "text1123": "Nový používateľ",
  "text1124": "Nová objednávka",
  "text1125": "Nový komentár k úlohe",
  "text1126": "Zmena stavu úlohy",
  "text1127": "Doprava zdarma",
  "text1128": "Garancia ceny",
  "text1129": "Konzultácia zdarma",
  "text1130": "Zákaznícka podpora",
  "text1131": "2000+ produktov skladom",
  "text1132": "Doručenie do 4 dní",
  "text1133": "Značky",
  "text1134": "Môj profil",
  "text1135": "Zadajte názov spoločnosti",
  "text1136": "Zadajte IČO",
  "text1137": "Zadajte adresu spoločnosti",
  "text1138": "Miesto realizácie",
  "text1139": "Mám záujem o",
  "text1140": "V blízkosti potoka",
  "text1141": "Koľko ľudí bude čistiareň využívať?",
  "text1142": "Mám svahovitý pozemok?",
  "text1143": "",
  "text1144": "Navrhnite si produkt presne podľa svojich predstáv. S naším konfigurátorom je to vytvorenie dokonalého výrobku rýchle a jednoduché.",
  "text1145": "Vytvorte si ideálnu konfiguráciu",
  "text1146": "Zobraziť všetko v podkategórii",
  "text1147": "Fotonávod",
  "text1148": "Prečítať článok",
  "text1149": "Najčítanejšie články",
  "text1150": "Tagy",
  "text1151": "Plánujete projekt?\nStretneme sa a poradíme Vám.",
  "text1152": "zadarmo",
  "text1153": "Kontaktovať",
  "text1154": "Spočítať",
  "text1155": "Zdieľať článok",
  "text1156": "Odkaz bol skopírovaný do schránky",
  "text1157": "Rozpočet",
  "text1158": "Vernostné body sa nepodarilo uplatniť. Použiť je možné iba celé body (minimálne 1 bod).",
  "text1159": "Vaše vernostné body",
  "text1160": "Každý vernostný má hodnotu",
  "text1161": ", čo vám dáva celkovú zľavu",
  "text1162": "na váš nákup.",
  "text1163": "Nemáte žiadne vernostné body",
  "text1164": "Uplatniť vernostné body",
  "text1165": "Počet bodov na uplatnenie",
  "text1166": "Počet uplatnených vernostných bodov",
  "text1167": "Uplatnená zľava",
  "text1168": "Maximálny počet bodov, ktoré je možné uplatniť na jednu objednávku je",
  "text1169": "Sídlo",
  "text1170": "Viac o tejto službe",
  "text1171": "Ozvite sa nám",
  "text1172": "Kancelária",
  "text1173": "Sídlo firmy",
  "text1174": "Pokračuj ďalej",
  "text1175": "Proces a postup realizácie",
  "text1176": "Náhľad obrazoviek univerzálneho e-shopu",
  "text1177": "Zvolený čas nie je možné rezervovať",
  "text1178": "Zvolená možnosť",
  "text1179": "Miestnosti",
  "text1180": "Rozloha",
  "text1181": "Vyhotovenie výkresov nábytku",
  "text1182": "Zoznam zariaďovacích prvkov",
  "text1183": "Celé meno zákazníka",
  "text1184": "Názov stavu reklamácie",
  "text1185": "Meno osoby, ktorá obslúži rezerváciu",
  "text1186": "Rezervované na deň",
  "text1187": "Ak už máte u nás založený účet, prosím",
  "text1188": "Názov spoločnosti",
  "text1189": "Adresa sídla spločnosti",
  "text1190": "Vyberte štát",
  "text1191": "Priradené taby nepatria danej sekcii",
  "text1192": "Vodorovne",
  "text1193": "Zvislo",
  "text1194": "Vnútorné",
  "text1195": "Vonkajšie",
  "text1196": "          Práca, zamestnanie a kariérne možnosti",
  "text1197": "Populárne pozície",
  "text1198": "Aktualizovať košík",
  "text1199": "Upraviť položku",
  "text1200": "Číslo zmluvy",
  "text1201": "Pozáručný servis",
  "text1202": "Prihlásiť sa do formulára",
  "text1203": "Prihlasovacie meno (email)",
  "text1204": "Prihlásiť",
  "text1205": "Nesprávne heslo",
  "text1206": "Zadajte heslo pre virtuálny produkt, ktoré ste obdržali po zaplatení objednávky.",
  "text1207": "Heslo nájdete na vašej emailovej adrese.",
  "text1208": "Položka v košíku bola upravená.",
  "text1209": "API kľúč nie je správny",
  "text1210": "Podpis zmluvy a úhrada faktúry",
  "text1211": "Kontaktné údaje a špecifikácia diela",
  "text1212": "Kontrola údajov a prístupov",
  "text1213": "Grafický design",
  "text1214": "Podpis akceptačného protokolu - Design",
  "text1215": "Inštalácia systému na doménu - server",
  "text1216": "Implementácia vizuálu a napojenie na systém",
  "text1217": "Akceptačný protokol - Implementácia designu a napojenie na systém",
  "text1218": "Obsahová stránka projektu",
  "text1219": "Migrácia na produkciu",
  "text1220": "Finálne potvrdenie projektu",
  "text1221": "Zmluva o dielo nebola podpísaná.",
  "text1222": "Faktúra nebola uhradená.",
  "text1223": "Zmluva bola úspešne podpísaná.",
  "text1224": "Faktúra bola uhradená.",
  "text1225": "Súbory na stiahnutie",
  "text1226": "Do obchodu",
  "text1227": "Stiahnuť doklad",
  "text1228": "Moje faktúry",
  "text1229": "Doklad",
  "text1230": "Fakturovaná čiastka",
  "text1231": "Uhradená čiastka",
  "text1232": "Ostáva doplatiť",
  "text1233": "Mena",
  "text1234": "Dátum vystavenia",
  "text1235": "Odsúhlasené",
  "text1236": "Vybavené klientom",
  "text1237": "Typ dokladu",
  "text1238": "Dátum zdaniteľného plnenia",
  "text1239": "Môj dopyt",
  "text1240": "Zadajte Váš e-mail prostredníctvom ktorého budeme spolu komunikovať",
  "text1241": "Dátum prijatia",
  "text1242": "Viac o nás",
  "text1243": "Mám záujem",
  "text1244": "Izolácie",
  "text1245": "Podľa použitia",
  "text1246": "Podľa materiálu",
  "text1247": "Všetky referencie",
  "text1248": "Vybrané projekty",
  "text1249": "Máte záujem zrealizovať projekt alebo máte otázky? Ozvite sa nám",
  "text1250": "Meno a priezvisko",
  "text1251": "Projekt podporila Európska únia",
  "text1252": "Ochrana osobných údajov",
  "text1253": "Prehľad produktov",
  "text1254": "Pozrieť produkt",
  "text1255": "Technické údaje",
  "text1256": "Konzultácia",
  "text1257": "Číslo účtu",
  "text1258": "Telefónne číslo",
  "text1259": "Pri našej komunikácii s klientom preferujeme komunikáciu prostredníctvom projektovej skupiny na aplikácií “Whatsapp”. Zadajte číslo cez ktoré Vás pridáme do projektovej skupiny.",
  "text1260": "Whatsapp telefónne číslo (+421 ... ...)",
  "text1261": "Whatsapp",
  "text1262": "Špecifikácia diela",
  "text1263": "Druh diela (podľa dohody a zmluvy)",
  "text1264": "Eshop",
  "text1265": "Prezentačný web",
  "text1266": "Webová aplikácia",
  "text1267": "Mobilná aplikácia",
  "text1268": "CRM systém",
  "text1269": "PPC kampane (Google, Facebook)",
  "text1270": "SEO optimalizácia",
  "text1271": "Typ dizajnu",
  "text1272": "E-shop dizajn - Eliadmin univerzál",
  "text1273": "E-shop dizajn - dizajn na mieru",
  "text1274": "Webdizajn / dizajn aplikácie / dizajn systému",
  "text1275": "Preferovaný kód farby (v HEX formáte)",
  "text1276": "Namiešať si ju viete na tomto odkaze.",
  "text1277": "Grafické a obsahové podklady",
  "text1278": "Grafické podklady",
  "text1279": "Mám (napr. dizajn manuál, logo, banner...)",
  "text1280": "Nemám",
  "text1281": "Podkladové obsahové materiály na web (popisy, názvy kategórií, fotografie, atď...)",
  "text1282": "Priložte podkladové súbory (dizajn manuál, logo, bannery, ...) ",
  "text1283": "V prípade loga vektorový použite vektorový formát svg, ai alebo pdf.",
  "text1284": "Nahrajte najviac 10 podporovaných súborov. Maximálna veľkosť 100 MB / súbor.",
  "text1285": "NAHRAŤ SÚBOR",
  "text1286": "Doména a hosting",
  "text1287": "Mám zakúpenú",
  "text1288": "Názov domény (www.vasadomena.sk)",
  "text1289": "Názov domény",
  "text1290": "Názov providera domény",
  "text1291": "Názov providera",
  "text1292": "Vaše prihlasovacie meno",
  "text1293": "Vaše prihlasovacie heslo",
  "text1294": "Pozn. nutné pre inštaláciu systému (zrýchli to práce a samotne odovzdanie produktu, ak nemáte vieme zabezpečiť)",
  "text1295": "Rezervačný formulár",
  "text1296": "Výber služby",
  "text1297": "Zvolte barbera",
  "text1298": "Vyberte termín",
  "text1299": "Zadajte svoj kontakt",
  "text1300": "Aktuálne voľné termíny",
  "text1301": "Nerozhoduje",
  "text1302": "Pondelok",
  "text1303": "Utorok",
  "text1304": "Streda",
  "text1305": "Štvrtok",
  "text1306": "Piatok",
  "text1307": "Sobota",
  "text1308": "Nedeľa",
  "text1309": "Týždeň",
  "text1310": "Žiadne termíny k dispozícii",
  "text1311": "Zhrnutie",
  "text1312": "Meno barbera",
  "text1313": "Služba",
  "text1314": "Trvanie",
  "text1315": "minút",
  "text1316": "Odoslať rezerváciu",
  "text1317": "Rezervácia bola úspešná",
  "text1318": "Je potrebné si vybrať termín",
  "text1319": "Rezerváciu sa nepodarilo vytvoriť. Skontrolujte, či je formulár vyplnení správne a skúste rezerváciu vytvoriť znovu.",
  "text1320": "Nastala neočakávaná chyba.",
  "text1321": "Viac info",
  "text1322": "Pozrieť viac projektov",
  "text1323": "Detail projektu",
  "text1324": "Kontaktujte nás ak máte záujem\no profesionálov vo svojom odbore!",
  "text1325": "Projekty",
  "text1326": "Pozrieť projekty",
  "text1327": "Názov projektu",
  "text1328": "Rok realizácie",
  "text1329": "Lokalita",
  "text1330": "Referenčný list",
  "text1331": "Údaje spoločnosti",
  "text1332": "Banka",
  "text1333": "Zavolať",
  "text1334": "Vložte token",
  "text1335": "Rezervácia",
  "text1336": "Prejsť do kategórie",
  "text1337": "Navigovať",
  "text1338": "Zostaňte v obraze vďaka odberu noviniek!",
  "text1339": "Zadaním emailovej adresy potvrdzujete súhlas so spracovaním osobných údajov a zároveň sa prihlasujete na odber noviniek od Spaceplan.",
  "text1340": "Rezervovať",
  "text1341": "Mám vernostnú kartu",
  "text1342": "Chyba pri zaznamenaní rezervácie",
  "text1343": "Rezervovať vybrané produkty",
  "text1344": "Viac o našej spoločnosti",
  "text1345": "Naše služby",
  "text1346": "Spojte sa s nami",
  "text1347": "Úspešne ste sa odhlásili z odberu newslettra",
  "text1348": "Vytvoriť nový",
  "text1349": "Zrušiť a zahodiť",
  "text1350": "Chcete zrušiť vytváranie životopisu? Všetky údaje budú stratené.",
  "text1351": "Zahoďit životopis",
  "text1352": "Pokračovať vo vytváraní",
  "text1353": "Chyba pri voľbe atribútov.",
  "text1354": "Kontaktovať najneskôr do",
  "text1355": "Online kalkulácia cien",
  "text1356": "Vyberte produkty ktoré máte záujem naceniť:",
  "text1357": "Zobraziť cenovú ponuku",
  "text1358": "Vybrané produkty do kalkulácie:",
  "text1359": "Pridať produkt",
  "text1360": "Čítať viac",
  "text1361": "Mám záujem o produkt",
  "text1362": "Máte záujem o tento produkt? Vyplňte formulár a my Vás čo najskôr kontaktujeme s cenovou ponukou.",
  "text1363": "Je potrebné si vybrať produkt v predcházajúcom kroku",
  "text1364": "Bez konfigurácie",
  "text1365": "Vyplňte priložený formulár a my sa Vám ozveme čo najskôr.  Aj v tomto kroku ide stále o nezáväznú cenovú ponuku pre Vás",
  "text1366": "Projekt",
  "text1367": "Kontaktovať najneskôr do",
  "text1368": "Odoslať nezáväzný dopyt pre individuálnu ponuku",
  "text1369": "Stiahnúť cenovú ponuku",
  "text1370": "Prezerať",
  "text1371": "Tento produkt nemá žiadne nastavenia.",
  "text1372": "Nezáväzný dopyt pre individuálnu ponuku bol úspešne odoslaný",
  "text1373": "Konateľ",
  "text1374": "Obchod a služby",
  "text1375": "Máte otázku? Napíšte nám",
  "text1376": "Ak máte nejakú otázku a potrebujete sa s nami spojiť, skúste nám zavolať alebo napísať, prípadne môžete vyplniť kontaktný formulár.",
  "text1377": "Pozrieť projekt",
  "text1378": "Máte záujem o produkty a služby?",
  "text1379": "Dizajnér",
  "text1380": "Použiť filter",
  "text1381": "Nemáte žiadne obľúbené produkty",
  "text1382": "Vymazať wishlist",
  "text1383": "Naozaj si želáte vymazať zoznam prianí?",
  "text1384": "Áno, vymazať",
  "text1385": "Nie, nevymazať",
  "text1386": "Neplatné telefónne číslo",
  "text1387": "Neplatná telefónna predvoľba",
  "text1388": "Všetky nehnuteľnosti",
  "text1389": "Predaj",
  "text1390": "Prenájom",
  "text1391": "Kúpa",
  "text1392": "Zobraziť ponuku",
  "text1393": "Umelci",
  "text1394": "Odoslať objednávku s povinnosťou platby",
  "text1395": "Chcem predať",
  "text1396": "Chcem kúpiť",
  "text1397": "Chcem prenajať",
  "text1398": "Nie sú dostupné žiadne miesta na doručenie",
  "text1399": "Vybavenie",
  "text1400": "Späť na nehnutelnosti",
  "text1401": "Zobraziť všetky fotky",
  "text1402": "Vidíme, že ste si pridali produkty k obľúbeným, keď ste neboli prihlásený. Prajete si pridané produkty doplniť k obľúbeným?",
  "text1403": "Pridať",
  "text1404": "Nepridať",
  "text1405": "Zákazníka nie je možné priradiť.",
  "text1406": "Vyhľadajte produkt",
  "text1407": "Lokalita",
  "text1408": "Lokalita nehnuteľnosti",
  "text1409": "Druh nehnuteľnosti",
  "text1410": "Vyberte",
  "text1411": "Zadajte kľúčové slovo",
  "text1412": "Vyberte cenové rozpätie",
  "text1413": "Nehnuteľností",
  "text1414": "Rozpočty",
  "text1415": "Sídlo spoločnosti",
  "text1416": "Mám záujem o",
  "text1417": "Áno",
  "text1418": "Len novostavby",
  "text1419": "Žiadne nehnuteľnosti",
  "text1420": "nehnuteľností v ponuke",
  "text1421": "Zoradiť od",
  "text1422": "Chcem predať",
  "text1423": "Nehnuteľnosť",
  "text1424": "Nehnuteľnosti",
  "text1425": "nehnuteľnosť v ponuke",
  "text1426": "nehnuteľnosti v ponuke",
  "text1427": "od",
  "text1428": "Kontaktovať",
  "text1429": "Vyber si, aký typ účtu si u nás praješ vytvoriť",
  "text1430": "Používateľ",
  "text1431": "Študent",
  "text1432": "Spoločnosť",
  "text1433": "Škola",
  "text1434": "www stránka spoločnosti",
  "text1435": "Adresa sídla spoločnosti",
  "text1436": "Registrácia firmy",
  "text1437": "Ak už máte u nás založený účet, prosím",
  "text1438": "prihláste sa.",
  "text1439": "Prevádzka spoločnosti je rozdielna so sídlom spoločnosti",
  "text1440": "Kontaktné údaje zodpovednej osoby",
  "text1441": "Heslo musí obsahovať minimálne 8 znakov.",
  "text1442": "pre účely vytvorenia účtu a možnosti kontaktovania.",
  "text1443": "Všetky projekty",
  "text1444": "Novinka",
  "text1445": "Dozvedieť sa viac o produkte",
  "text1446": "Kúpiť produkt",
  "text1447": "Prílohy na stiahnutie",
  "text1448": "Cena celkom bez DPH",
  "text1449": "Cena za kus bez DPH",
  "text1450": "Cena tovaru bez DPH",
  "text1451": "Celkom bez DPH",
  "text1452": "Náhľad konfigurácie",
  "text1453": "Rozbalit všetko",
  "text1454": "Konfigurácia produktu",
  "text1455": "Povrchové úpravy",
  "text1456": "Povrchové úpravy zad",
  "text1457": "Dizajn dverí",
  "text1458": "Hrany",
  "text1459": "Úchytky",
  "text1460": "Pánty",
  "text1461": "Ornamenty",
  "text1462": "Rozmery",
  "text1463": "Doplňujúce údaje",
  "text1464": "Zadajte počet kusov",
  "text1465": "Počet kusov",
  "text1466": "Vyčistiť konfiguráciu",
  "text1467": "Zavrieť konfigurátor",
  "text1468": "Konfigurátor",
  "text1469": "Náhľad",
  "text1470": "Konfigurovať",
  "text1471": "Neplatná konfigurácia",
  "text1472": "Nastala chyba",
  "text1473": "Nastavte počet kusov",
  "text1474": "Pre pridanie do košíka musíte nastaviť počet kusov",
  "text1475": "Moje adresy",
  "text1476": "Registrácia používateľa",
  "text1477": "Registrácia študenta",
  "text1478": "Registrácia školy",
  "text1479": "Názov školy",
  "text1480": "www stránka školy",
  "text1481": "Adresa školy",
  "text1482": "Študijné odbory na škole",
  "text1483": "Email zamestnanca školy",
  "text1484": "Oficiálny email školy",
  "text1485": "Pridať odbor",
  "text1486": "Vyplňte odbor",
  "text1487": "Nie je vyplnená API konfigurácia pre Google Analytics.",
  "text1488": "Generovanie exportu spustené",
  "text1489": "Generovanie exportu dokončené",
  "text1490": "Hľadáte prácu? Vyplňte kontaktný formulár",
  "text1491": "Nenašli ste ponuku v aktuálne dostupných pracovných pozíciach? Nevadí, vyplňte kontaktný formulár, nahrajte životopis a my sa Vám v prípade voľnej pracovnej pozície ozveme.",
  "text1492": "Kariéra",
  "text1493": "V krátkosti popíšte o akú pozíciu by ste mali záujem...",
  "text1494": "Dôležité kontakty",
  "text1495": "Obľúbené ponuky",
  "text1496": "Oblasť pôsobenia",
  "text1497": "Veľkosť podniku",
  "text1498": "Zaujímavosti o firme",
  "text1499": "Opis spoločnosti",
  "text1500": "Prehľad ponúk",
  "text1501": "Opis školy",
  "text1502": "Prehľad študijných odborov",
  "text1503": "Dátum prijímacích skúšok",
  "text1504": "Deň otvorených dverí",
  "text1505": "Spolupráce / Odborná prax",
  "text1506": "Záznam neexistuje.",
  "text1507": "Kurzy",
  "text1508": "Upraviť profil",
  "text1509": "Predošlé pracovné skúsenosti",
  "text1510": "Vzdelanie a kvalifikácia",
  "text1511": "Osobné zručnosti",
  "text1512": "Ďalšie zručnosti",
  "text1513": "Národnosť",
  "text1514": "Miesto výkonu práce",
  "text1515": "Akú školu študujete?",
  "text1516": "Aký typ práce hľadáte?",
  "text1517": "Nie je vyplnené",
  "text1518": "Profil firmy",
  "text1519": "Odstrániť všetky",
  "text1520": "Inzeráty",
  "text1521": "Profil školy",
  "text1522": "Vyhľadané firmy",
  "text1523": "Pozrieť profil",
  "text1524": "Pracovné ponuky v",
  "text1525": "Vyčistiť filter",
  "text1526": "Informácie o pracovnej ponuke",
  "text1527": "Mzda",
  "text1528": "Oddelenie",
  "text1529": "Pozícia",
  "text1530": "Počet voľných miest",
  "text1531": "Platnosť pracovnej ponuky",
  "text1532": "Požadované zručnosti",
  "text1533": "Ostatné informácie",
  "text1534": "Vytvoriť profil",
  "text1535": "Predošlé pracovné skúsenosti",
  "text1536": "Vzdelanie a kvalifikácie",
  "text1537": "Uložiť a pokračovať neskôr",
  "text1538": "Vyber pohlavie",
  "text1539": "Akému odboru sa venuješ?",
  "text1540": "Základné údaje firmy",
  "text1541": "Logo",
  "text1542": "Zaujímavosť o firme",
  "text1543": "Slogan firmy",
  "text1544": "V stručnosti opíšte vašu firmu a čím sa zaoberá...",
  "text1545": "Sem napíšte zaujímavosť o vašej firme...",
  "text1546": "Napíšte váš firemný slogan...",
  "text1547": "Kontaktné údaje firmy",
  "text1548": "Poskytujete prax študentom?",
  "text1549": "Uvítali by ste spoluprácu s školami?",
  "text1550": "Áno",
  "text1551": "Nie",
  "text1552": "Facebook link",
  "text1553": "Instagram link",
  "text1554": "Linkedin link",
  "text1555": "Oblasť pôsobenia",
  "text1556": "Veľkosť spoločnosti",
  "text1557": "Vyberte veľkosť spoločnosti",
  "text1558": "Zoznam referencií",
  "text1559": "Profil školy",
  "text1560": "Základné údaje školy",
  "text1561": "Projekty školy",
  "text1562": "Adresa ma nesprávny formát",
  "text1563": "Vytvorenie profilu firmy vám bude slúžiť ako vizitka firmy.",
  "text1564": "Študijné odbory na škole ",
  "text1565": "Školy",
  "text1566": "Firmy",
  "text1567": "Vyskúšajte efektívne vyhľadávanie uchádzačov",
  "text1568": "Vhodného uchádzača Vám odporučí Jobiis Matching.",
  "text1569": "Pridať ponuku",
  "text1570": "Kontaktné údaje školy",
  "text1571": "Študijné odbory na škole",
  "text1572": "Krátky opis školy",
  "text1573": "Zaujímavosti o škole",
  "text1574": "V krátkosti opíšte vašu školu...",
  "text1575": "Zverejnite vašu pracovnú ponuku a nájdite vhodného kandidáta",
  "text1576": "Využite náš portál na zverejnenie pracovnej ponuky a v krátkom čase nájdite svojho kandidáta ktorý spĺňa vaše pracovné kritéria.",
  "text1577": "Prepojte sa s firmami a nájdite si partnera pre odbornú prax či stáž pre vašich študentov.",
  "text1578": "Jobiis vám uľahčí prístup k možnostiam odbornej praxe či stáži pre vašich študentov.",
  "text1579": "Mali by ste záujem zorganizovať prednášku s odborníkom na Vašej škole?",
  "text1580": "Pomôžeme Vám zorganizovať prednášku s odborníkom z Vášho zamerania bez poplatku!",
  "text1581": "Vyhľadaj si svojho match.",
  "text1582": "Pridať odbor",
  "text1583": "Objednať",
  "text1584": "Nahrať logo",
  "text1585": "Spolupráce školy",
  "text1586": "Projekty do ktorých sa škola zapája",
  "text1587": "Dátum otvorených dverí",
  "text1588": "Dátum príjmacích skúšok",
  "text1589": "Vyberte dátum",
  "text1590": "Vyberte typ členstva",
  "text1591": "Ak by ste si u nás chceli objednať do inej krajiny, napíšte nám na",
  "text1592": "a vašu objednávku spracujeme individuálne.",
  "text1593": "Pridať projekt",
  "text1594": "Pridať spoluprácu",
  "text1595": "Opis firmy",
  "text1596": "Vaša oblasť pôsobenia",
  "text1597": "Sociálne siete",
  "text1598": "V akom okruhu chceš pracovať",
  "text1599": "Akému odboru sa venuješ?",
  "text1600": "Aký typ práce hľadáš?",
  "text1601": "Očakávaný plat v € (mesačne)",
  "text1602": "Nástup ihneď",
  "text1603": "Pracovné časy",
  "text1604": "Názov pozície",
  "text1605": "Ešte pretrváva",
  "text1606": "Pridať ďalšie",
  "text1607": "Titul kvalifikácie",
  "text1608": "Organizácia poskytujúca vzdelanie",
  "text1609": "Trvalá edukácia",
  "text1610": "webová stránka organizácie",
  "text1611": "Vymazať",
  "text1612": "Jazykové znalosti",
  "text1613": "Materinský jazyk",
  "text1614": "Ostatné jazyky",
  "text1615": "Digitálne zručnosti",
  "text1616": "Ktoré digitálne zručnosti ovládate?",
  "text1617": "Pre akú kategóriu vlastníš vodičský preukaz?",
  "text1618": "Druh pracovnej pozície",
  "text1619": "Náplň práce",
  "text1620": "Pozícia vhodná pre",
  "text1621": "Spodná hranica mzdy v €",
  "text1622": "Horná hranica mzdy v €",
  "text1623": "Odvetvie",
  "text1624": "Zamestnanecké výhody",
  "text1625": "Pracovný čas",
  "text1626": "Požadovaný minimálny vek",
  "text1627": "Ukončené vzdelanie",
  "text1628": "Požadované vzdelanie v odbore",
  "text1629": "Jazykové zručnosti",
  "text1630": "Požadovaná predošlá prax",
  "text1631": "Potrebné kvalifikácie",
  "text1632": "Osobnostné predpoklady",
  "text1633": "Informácie pre uchádzača",
  "text1634": "Diplom",
  "text1635": "Vyber typ práce",
  "text1636": "Akú školu študuješ",
  "text1637": "Vyber vyhovujúce pracovné časy",
  "text1638": "Pridať zručnosť",
  "text1639": "Vyberte odbory",
  "text1640": "Vyber typ práce",
  "text1641": "Kreatívne práce",
  "text1642": "Konferencie a semináre",
  "text1643": "Záľuby a záujmy",
  "text1644": "Vyznamenania a ocenenia",
  "text1645": "Siete a členstvá",
  "text1646": "Projekty",
  "text1647": "Publikácie",
  "text1648": "Referencie",
  "text1649": "Dobrovolnícke aktivity",
  "text1650": "Vyber typ zručnosti",
  "text1651": "Úroveň zručnosti",
  "text1652": "Názov kreatívneho diela",
  "text1653": "Popis kreatívneho diela",
  "text1654": "Nahraj súbor",
  "text1655": "Názov konferencie",
  "text1656": "Odkaz na seminár/konferenciu",
  "text1657": "Popis semináru/konferencie",
  "text1658": "Názov záľuby/záujmu",
  "text1659": "Popis záľuby/záujmu",
  "text1660": "Názov vyznamenania/ocenenia",
  "text1661": "Popis vyznamenania/ocenenia",
  "text1662": "Odovzdávajúca inštitúcia",
  "text1663": "Dátum odovzdania",
  "text1664": "Názov členstva",
  "text1665": "Popis členstva",
  "text1666": "Názov projektu",
  "text1667": "Popis projektu",
  "text1668": "Názov publikácie",
  "text1669": "Dátum publikácie",
  "text1670": "Popis publikácie",
  "text1671": "Názov referencie",
  "text1672": "Nahrať referenčný list",
  "text1673": "Pozícia (referenda)",
  "text1674": "Email (referenda)",
  "text1675": "Telefónne číslo (referenda)",
  "text1676": "Lokácia",
  "text1677": "Názov dobrovľníckej aktivity",
  "text1678": "Popis dobrovľníckej aktivity",
  "text1679": "Odkaz na súbor/video",
  "text1680": "Iné",
  "text1681": "Nemáte pridané žiadne zručnosti",
  "text1682": "Váš profil bol úspešne aktualizovaný",
  "text1683": "Nahrať profilový obrázok",
  "text1684": "Pridať inzerát",
  "text1685": "Vytvoriť inzerát",
  "text1686": "Typ mzdy",
  "text1687": "Poloha",
  "text1688": "Moje správy",
  "text1689": "Nesprávny token, skúste znovu",
  "text1690": "Vyhľadanie podľa názvu ponuky, odvetia, lokality",
  "text1691": "Dnes je",
  "text1692": "Kontakty",
  "text1693": "Príhovor",
  "text1694": "Ako vybrať aktívne sedenie",
  "text1695": "Stiahnuteľný dokument a prístupové heslo budú dostupné až po potvrdení platby.",
  "text1696": "Obnovenie hesla",
  "text1697": "Zobraziť detail realizácie",
  "text1698": "Realizácia",
  "text1699": "Miesto",
  "text1700": "Všetky vizualizácie realizácie",
  "text1701": "Späť na všetky realizácie",
  "text1702": "Detail produktu",
  "text1703": "Žiadny používatelia",
  "text1704": "Vyhľadaj používateľov",
  "text1705": "Komu",
  "text1706": "Kontaktný formulár z webu",
  "text1707": "Registrácia študenta",
  "text1708": "Navigovať do predajne",
  "text1709": "Pokiaľ chcete byť informovaní o najnovších správach, termínoch dokončenia a možnostiach prihláste sa na odber nášho newslettera a dostávajte aktuálne informácie priamo do vašej schránky.",
  "text1710": "Pon - Sob: 8:00 - 19:00 hod.",
  "text1711": "Odpovieme Vám do 24 hod. počas pracovnej doby.",
  "text1712": "Vzorková predajňa",
  "text1713": "Osobné stretnutie je potrebné vopred dohodnúť.",
  "text1714": "Vyplňte formulár a my vám v čo najkratšej dobe odpovieme na vašu otázku.",
  "text1715": "Zobraziť ďalšie",
  "text1716": "Zoradenie",
  "text1717": "Prax pre študentov",
  "text1718": "Spolupráca so školami",
  "text1719": "Vek",
  "text1720": "Vymazať chat",
  "text1721": "Žiadne správy",
  "text1722": "Tento produkt pre Vás pripravujeme",
  "text1723": "Adresa spoločnosti",
  "text1724": "Kontaktná osoba",
  "text1725": "www adresa",
  "text1726": "Titul pred menom",
  "text1727": "Charakteristika spoločnosti",
  "text1728": "Vyberte oblasť",
  "text1729": "Dokončiť ponuku",
  "text1730": "Požadovaná znalosť jazykov",
  "text1731": "Požadované vzdelanie",
  "text1732": "Požadované pracovné skúsenosti",
  "text1733": "Typ pracovnej ponuky",
  "text1734": "Moje konto",
  "text1735": "Môj životopis",
  "text1736": "Moje pracovné ponuky",
  "text1737": "Moje kurzy",
  "text1738": "Moja firma",
  "text1739": "Životopisy",
  "text1740": "Životopis a certifikáty",
  "text1741": "Fotografia a video",
  "text1742": "Zručnosti a znalosti",
  "text1743": "Kategórie odvetví",
  "text1744": "Nahrajte svoj životopis na stiahnutie pre zamestnávateľa.",
  "text1745": "Certifikát",
  "text1746": "Nahrajte certifikáty ktoré máte k dispozícií.",
  "text1747": "Motivačný list",
  "text1748": "Nahrajte motivačný list.",
  "text1749": "Fotografia nie je povinná, no životopis s fotkou pôsobí osobnejšie a personalistu zaujme viac.",
  "text1750": "Nahrajte svoj video životopis ktorý vás posunie o krok bližšie k vytúženej pracovnej pozícií.",
  "text1751": "Vedeli ste, že personalistovi stačí v priemere 7 sekúnd na prvé preskenovanie životopisu? Spomeňte preto len relevantné skúsenosti a popíšte ich v odrážkach alebo v krátkych odsekoch.",
  "text1752": "Dajte zamestnávateľom vedieť, aké je vaše vzdelanie.",
  "text1753": "Zadajte, aké zručnosti a znalosti ovládate, a na akej úrovni.",
  "text1754": "Pridajte si do životopisu ďalšie sekcie, ktoré sú pre vás dôležité.",
  "text1755": "Titul za menom",
  "text1756": "Zo zoznamu vyberte kategórie odvetví o ktoré sa chcete uchádzať",
  "text1757": "Naše sociálne siete",
  "text1758": "Naše referencie",
  "text1759": "Ďalšie referencie",
  "text1760": "Náš tím",
  "text1761": "Aktuálna ponuka",
  "text1762": "Neplatný kľúč",
  "text1763": "Realizovali sme",
  "text1764": "Ekologicky šetrné priemyselné chemikálie",
  "text1765": "Ako vyrábame produkty?",
  "text1766": "Možnosť pracovať z domu?",
  "text1767": "Deň nástupu",
  "text1768": "Popis pracovnej ponuky",
  "text1769": "Kontaktné údaje pre reakciu na ponuku",
  "text1770": "Pridajte požadované pracovné skúsenosti a ich úroveň, ktoré sa vyžadujú od uchádzača.",
  "text1771": "Pridajte požadované vzdelanie, ktoré sa vyžadujú od uchádzača.",
  "text1772": "Pridajte požadovanú znalosť jazykov pre túto pracovnú pozíciu",
  "text1773": "Pridajte si do ponuky ďalšie časti, ktoré sú od uchádzača požadované.",
  "text1774": "Názov pracovnej skúsenosti ",
  "text1775": "Úroveň pracovnej skúsenosti",
  "text1776": "Pridať novú",
  "text1777": "Stredoškolské vzdelanie",
  "text1778": "Vysokoškolské vzdelanie I. stupňa",
  "text1779": "Vysokoškolské vzdelanie II. stupňa",
  "text1780": "Vysokoškolské vzdelanie III. stupňa",
  "text1781": "Úroveň",
  "text1782": "Vyberte kategórie vodičského preukazu ktoré vyžadujete od uchádzača.",
  "text1783": "Váš životopis bol úspešne aktualizovaný",
  "text1784": "Dokončiť životopis",
  "text1785": "Nová odpoveď v poradni",
  "text1786": "Pribudla vám nová odpoveď v poradni",
  "text1787": "Otázka bola úspešne pridaná",
  "text1788": "Pridané",
  "text1789": "Reakcie na inzerát",
  "text1790": "Rokov",
  "text1791": "Stiahnúť CV",
  "text1792": "Balenie",
  "text1793": "Nájdite svoj lokálny obchod",
  "text1794": "Katalógové číslo",
  "text1795": "Dodanie 7 - 10 dní",
  "text1796": "Zaregistrovať",
  "text1797": "Nemáte žiadne pracovné ponuky",
  "text1798": "Vyhľadané životopisy",
  "text1799": "Nezáleží",
  "text1800": "Hľadajte výrobcu, názov, sériu, kód výrobku...",
  "text1801": "Vyberte si kvalitu a krásu - nakupujte u nás!",
  "text1802": "Sme priamym dovozcom týchto výrobcov",
  "text1803": "Bežná cena za",
  "text1804": "Naša cena za",
  "text1805": "Cena za 1 balenie",
  "text1806": "Zadajte obsah plochy pre výpočet množstva balení",
  "text1807": "Zadajte obsah plochy",
  "text1808": "balení",
  "text1809": "Vyberte softskill",
  "text1810": "Vyberte úroveň",
  "text1811": "Sledovať video",
  "text1812": "Žiadne nové notifikácie",
  "text1813": "Predávajte s nami",
  "text1814": "Spolupracujeme s týmito prepravcami",
  "text1815": "Upraviť inzerát",
  "text1816": "Odporúčané pracovné pozície",
  "text1817": "Otvorená pozícia",
  "text1818": "Obráťte sa na nás",
  "text1819": "Podobné pozície",
  "text1820": "Vyhradzujeme si právo neodpovedať uchádzačom, ktorí nespĺňajú uvedené požiadavky.",
  "text1821": "O firme",
  "text1822": "Portfólio firiem",
  "text1823": "Zamietnuť všetky",
  "text1824": "Webová stránka",
  "text1825": "Koľko máte položiek?",
  "text1826": "Koľko máte objednávok za mesiac?",
  "text1827": "zhoda",
  "text1828": "Prijatý",
  "text1829": "\nÁno, chcem dostávať príležitostné novinky a tipy na e-commerce služby.",
  "text1830": "Zamietnuté",
  "text1831": "Čaká",
  "text1832": "Reagoval",
  "text1833": "Mäkké zručnosti",
  "text1834": "Vyberte si z viac ako 60 značiek v našom portfóliu a nájdite presne to, čo hľadáte! Všetko je plne prispôsobiteľné - od čalúnenia až po farby. Kontaktujte nás a spoločne vytvoríme dizajn na mieru podľa vašich predstáv.",
  "text1835": "Zobraziť produkty",
  "text1836": "Kam to bude?",
  "text1837": "dieťa",
  "text1838": "deti",
  "text1839": "detí",
  "text1840": "dospelý",
  "text1841": "dospelí",
  "text1842": "dospelích",
  "text1843": "1 až 3 noci",
  "text1844": "4 až 6 nocí",
  "text1845": "7 až 15 nocí",
  "text1846": "16+ nocí",
  "text1847": "Vyberte počet nocí",
  "text1848": "Viac možností",
  "text1849": "Nová otázka",
  "text1850": "Miesto, lokalita, hotel",
  "text1851": "Dátum od - do",
  "text1852": "Počet cestujúcich",
  "text1853": "Dĺžka pobytu",
  "text1854": "Strava",
  "text1855": "Zatvoriť",
  "text1856": "Ukázať ďalšie možnosti",
  "text1857": "Maximálna cena za osobu",
  "text1858": "Viac",
  "text1859": "Typ kvalifikácie",
  "text1860": "Žiadne zájazdy nevyhovujú zadaným kritériám.",
  "text1861": "Dozvedieť sa viac",
  "text1862": "Ďalšie články z posledného týždňa",
  "text1863": "Predajca",
  "text1864": "Cenník životopisov",
  "text1865": "Nová registrácia veľkoobchodu",
  "text1866": "Vôbec",
  "text1867": "Málo",
  "text1868": "Neutrálne",
  "text1869": "Trochu viac",
  "text1870": "Veľmi",
  "text1871": "Zdá sa ti to zaujímavé?",
  "text1872": "Úspešne si dokončil test",
  "text1873": "Hotovo",
  "text1874": "Najviac sa hodíš na",
  "text1875": "Ukázať voľné pozície",
  "text1876": "Nie som platca DPH",
  "text1877": "Zobraziť všetky notifikácie",
  "text1878": "Notifikácie",
  "text1879": "Neprečítané",
  "text1880": "Označiť všetky ako prečítané",
  "text1881": "Žiadne notifikácie",
  "text1882": "Počet záznamov na zobrazenie",
  "text1883": "Máte",
  "text1884": "novú správu",
  "text1885": "nové správy",
  "text1886": "nových správ",
  "text1887": "Odpoveď na prihlášku na inzerát",
  "text1888": "Reakcia na inzerát",
  "text1889": "Dokončite svoj profil",
  "text1890": "Nová pracovná ponuka",
  "text1891": "Ponuka čoskoro expiruje",
  "text1892": "Firma prejavila záujem",
  "text1893": "Nový záujemca",
  "text1894": "Aktualizujte svoj profil",
  "text1895": "Systémové oznámenie",
  "text1896": "Máte nového kandidáta pre pracovnú ponuku",
  "text1897": "pridala novú pracovnú ponuku",
  "text1898": "o teba prejavila záujem",
  "text1899": "zľava",
  "text1900": "Najnovšie blogy",
  "text1901": "Odporúčané produkty",
  "text1902": "Novinky a zľavy",
  "text1903": "Detail kategórie",
  "text1904": "Pre pokračovanie vyplnte všetky otázky",
  "text1905": "Odoslať test",
  "text1906": "Špeciálna akcia",
  "text1907": "Chcem predávať cez Loft.cz",
  "text1908": "Zadajte email a nezmeškajte jedinečné ponuky",
  "text1909": "Servis",
  "text1910": "Infolinka",
  "text1911": "Vhodné pracovné oblasti",
  "text1912": "Vhodné pracovné prostredie",
  "text1913": "Pridajte sa k nám",
  "text1914": "Očakávaný plat",
  "text1915": "Obľúbené firmy",
  "text1916": "Prejsť na všetky školy",
  "text1917": "Predplatné",
  "text1918": "Naposledy videné",
  "text1919": "Moje udalosti",
  "text1920": "Ďalší článok",
  "text1921": "Predchádzajúci článok",
  "text1922": "Pokračujte na nákup predplatného.",
  "text1923": "Krajina doručenia",
  "text1924": "Potrebujete nás kontaktovať? Napíšte nám na",
  "text1925": "VOC",
  "text1926": "MOC",
  "text1927": "Aktívne predplatné",
  "text1928": "V prípade zrušenia predplatného zostáva Vaše predplatné aktívne do uplynutia predplateného obdobia.",
  "text1929": "História predplatného",
  "text1930": "Stiahnuť faktúru",
  "text1931": "Predplatné aktivované",
  "text1932": "Zručnosti",
  "text1933": "Máte už zakúpené predplatné?",
  "text1934": "Prihláste sa do svojho účtu.",
  "text1935": "Predplatné obsahuje prístup ku všetkým dance classes, Workouts a ďalším informáciám, 10% zľavu na všetky eventy Danceana OZ pre zaregistrovaných.",
  "text1936": "Vytvorte si prihlasovacie údaje.",
  "text1937": "Začiatok",
  "text1938": "Koniec",
  "text1939": "Partneri",
  "text1940": "Kúpiť predplatné",
  "text1941": "Všetky udalosti",
  "text1942": "Menej",
  "text1943": "Všetky albumy",
  "text1944": "Pozrieť galériu",
  "text1945": "Čo získate?",
  "text1946": "Chcem sa stať partnerom",
  "text1947": "Všetky",
  "text1948": "Lektori",
  "text1949": "Ďalšie kurzy ktoré by Vás mohli zaujímať",
  "text1950": "Obchodné podmienky",
  "text1951": "V tejto kategórii nemáme k dispozícii žiadne kurzy.",
  "text1952": "Uložiť zmenu údajov",
  "text1953": "Prosíme o overenie vašej emailovej adresy",
  "text1954": "Overiť",
  "text1955": "O mne",
  "text1956": "Doteraz",
  "text1957": "Hodnoty",
  "text1958": "K dokončeniu registrácie je potrebné potvrdiť emailovú adresu",
  "text1959": "Znovu poslať potvrdzovací email",
  "text1960": "Potvrdzovací email bol znovu odoslaný",
  "text1961": "Pri odosielaní potvrdzovacieho emailu nastala chyba",
  "text1962": "Emailová adresa bola úspešne overená",
  "text1963": "Vyhľadaj školy",
  "text1964": "Žiadne školy",
  "text1965": "Vyberte lokalitu",
  "text1966": "Prihláste sa na obder noviniek a dostávajte vždy tie najaktuálnejšie informácie z našej ponuky",
  "text1967": "Klienti o nás povedali",
  "text1968": "Zvolenému filtru nevyhovujú žiadne nehnuteľnosti",
  "text1969": "Najviac by ste sa hodili na pozície",
  "text1970": "Vhodné pracovné pozície",
  "text1971": "Pracovné benefity",
  "text1972": "Kvalifikácie",
  "text1973": "Emailovú adresu sa nepodarilo overiť",
  "text1974": "Spustiť test",
  "text1975": "Naozaj chcete vymazať inzerát",
  "text1976": "deň",
  "text1977": "dni",
  "text1978": "dní",
  "text1979": "Skryť zoznam dodávateľov",
  "text1980": "Zobraziť zoznam dodávateľov",
  "text1981": "Overiť dostupnosť u predajcu",
  "text1982": "Vybrať predajcu",
  "text1983": "Vyberte predajcu",
  "text1984": "Skryť zoznam predajcov",
  "text1985": "Zobraziť zoznam predajcov",
  "text1986": "Ďakujeme, Váš dopyt sme zaevidovali, do pár hodín Vás budeme kontaktovať",
  "text1987": "Obľúbené školy",
  "text1988": "Ak u nás ešte nemáte účet",
  "text1989": "Táto škola zatiaľ nemá overený profil",
  "text1990": "Uložiť životopis PDF",
  "text1991": "Kontaktovať záujemcu",
  "text1992": "Vodičské oprávnenia",
  "text1993": "Prezerať produkty",
  "text1994": "Hodnota musí byť z intervalu ",
  "text1995": "Zadajte",
  "text1996": "Základná úroveň",
  "text1997": "Vyberte dĺžku členstva",
  "text1998": "Cena za 1 mesiac predplatného",
  "text1999": "Vyberte počet životopisov",
  "text2000": "Všetky články",
  "text2001": "Prihláste sa na odber noviniek a dostávajte ako prví tie najhorúcejšie informácie o zľavách, novinkách a udalostiach.",
  "text2002": "Odoslaním prihlásenia do newslletera súhlasíte so",
  "text2003": "Nenašli ste odpoveď\nna otázku?",
  "text2004": "Ozvite sa nám a spýtajte sa",
  "text2005": "Naša predajňa s požičovňou",
  "text2006": "Požičovňa",
  "text2007": "Potrebujete poradiť alebo máte otázku ohľadom produktu? Kontakujte nás a my sa Vám ozveme.",
  "text2008": "Napíšte nám",
  "text2009": "Požadované vzdelanie/prax v odbore",
  "text2010": "Zaslať záujem o pracovnú ponuku",
  "text2011": "Záujem o pracovnú ponuku bol zaslaný",
  "text2012": "Pozrieť firmy",
  "text2013": "Potrebujete poradiť? Ozvite sa nám",
  "text2014": "Ukázať všetky",
  "text2015": "Nesúhlasím so zaslaním dotazníka spokojnosti v rámci programu Heureka Overené zákazníkmi.",
  "text2016": "Pridať sociálne siete",
  "text2017": "Cena vrátane 23% DPH",
  "text2018": "Podmienky požičovne TU",
  "text2019": "Zaregistrujte sa",
  "text2020": "Už máte svoj účet?",
  "text2021": "Vyberte si motocykel",
  "text2022": "Vyhľadajte podľa názvu motocykla...",
  "text2023": "Neboli nájdené žiadne produkty pre",
  "text2024": "V tejto kategórii nie sú dostupné žiadne produkty",
  "text2025": "Vymazať všetky",
  "text2026": "Smie obsahovať iba čísla",
  "text2027": "Typ školy",
  "text2028": "Späť na výber motocykla",
  "text2029": "Ďakujeme, záujem o testovaciu\njazdu bol odoslaný.",
  "text2030": "V čo najkratšom čase Vás budeme kontaktovať a dohodneme termín Vašej testovacej jazdy",
  "text2031": "Späť na hlavnú stránku",
  "text2032": "Odborové zameranie",
  "text2033": "Najvyššie ukončené vzdelanie",
  "text2034": "Adresa miesta výkonu práce",
  "text2035": "Mám vlastný vzor",
  "text2036": "Prostredníctvom tohto formuláru nám zašlite vlastný dizajn / vzor a my Vám naceníme\n              výrobu.",
  "text2037": "Termíny kurzov",
  "text2038": "Pridať softskill",
  "text2039": "Záujem bol úspešne odoslaný",
  "text2040": "Záujem o pracovnú ponuku už bol realizovany.",
  "text2041": "Naozaj chcete zaslať záujem o túto pracovnú ponuku?",
  "text2042": "Potvrdiť záujem",
  "text2043": "Potvrdiť nákup",
  "text2044": "Naozaj chcete zakúpiť predplatné?",
  "text2045": "Obdobie",
  "text2046": "mesiacov",
  "text2047": "Zapnúť notifikácie",
  "text2048": "Nová ponuka u zamestnávateľa",
  "text2049": "Nová odpoveď na záujem o ponuku",
  "text2050": "Upozornenie na vypršanie platnosti obľúbeného inzerátu",
  "text2051": "Nový záujem firmy",
  "text2052": "škôl",
  "text2053": "Zobrazených",
  "text2054": "Odbory",
  "text2055": "Miesto hľadanej práce",
  "text2056": "Očakávaná mzda",
  "text2057": "Vzdialenosť do práce",
  "text2058": "Pracovné hodiny",
  "text2059": "Dátum vytvorenia profilu",
  "text2060": "Odporúčané rozlíšenia",
  "text2061": "Produkt bude stiahnuteľný po zaplatení objednávky",
  "text2062": "Nemáte plne vyplnený profil",
  "text2063": "Je potrebné mať vyplnené meno, priezvisko a aspoň 1 mäkkú zručnosť",
  "text2064": "Aspoň 1 mäkká zručnosť",
  "text2065": "Vytvorenie profilu bude slúžiť aj ako tvoj životopis. Vyplň prosím jednotlivé kroky a odpovedz na nasledovné otázky.",
  "text2066": "Zrušiť prijatie uchádzača",
  "text2067": "Chcete potvrdiť záujem uchádzača",
  "text2068": "Prijať uchádzača",
  "text2069": "Prebieha potvrdzovanie záujmu uchádzača",
  "text2070": "Potvrdiť",
  "text2071": "Prijať záujem",
  "text2072": "Odmietnuť záujem",
  "text2073": "Kandidát obdrží správu o tom, že ste ho prijali",
  "text2074": "Prax pre študentov",
  "text2075": "Žiadne ponuky",
  "text2076": "Zobraziť",
  "text2077": "ponuku",
  "text2078": "ponuky",
  "text2079": "Prijať všetky",
  "text2080": "Potvrdiť všetky ponuky",
  "text2081": "Táto akcia potvrdí záujem o prácu všetkých kandidátov, ktorých žiadosť má status \"Čaká\"",
  "text2082": "Kandidáti obdržia správu o tom, že ste ich prijali",
  "text2083": "Potvrdzujú sa všetky ponuky...",
  "text2084": "Koncept",
  "text2085": "Aktívne",
  "text2086": "Archivované",
  "text2087": "Uložiť koncept",
  "text2088": "Pridať mäkkú zručnost",
  "text2089": "Účet sa vymaže za",
  "text2090": "Naozaj chcete vymazať účet?",
  "text2091": "Zobraziť môj životopis v databáze životopisov",
  "text2092": "odomknutie životopisu",
  "text2093": "Nie ste Jobiis Partner",
  "text2094": "Ak chcete nakupovať odomknutie životopisov za zvýhodnenú cenu, najprv je potreba aktivovať \"Jobiis Partner\" predplatné",
  "text2095": "Formulár nie je vyplnený",
  "text2096": "Zobraziť reakcie",
  "text2097": "Odstrániť inzerát",
  "text2098": "Archivovať",
  "text2099": "Aktivovať",
  "text2100": "Archivovaná",
  "text2101": "Aktívna",
  "text2102": "Chybne vyplnený formulár",
  "text2103": "Formulár nie je vyplnený správne. Skontrolujte formulára pošlite znova.",
  "text2104": "Tento životopis nemáte odomknutý",
  "text2105": "Odomknúť životopis",
  "text2106": "Ak chcete sprístupniť informácie na tomto životopise, je potrebné životopis odomknúť.",
  "text2107": "Odomknúť",
  "text2108": "Zostávajúce voľné odomknutia",
  "text2109": "Zostávajúce zakúpené odomknutia",
  "text2110": "Životopis bol odomknutý",
  "text2111": "Zobraziť životopis",
  "text2112": "Nezaplatená",
  "text2113": "Zaplatiť",
  "text2114": "Topovať",
  "text2115": "Žiadne produkty v košíku",
  "text2116": "Nemáte dostatok kreditu",
  "text2117": "Firemné benefity",
  "text2118": "Ponuka vhodná pre cudzinca",
  "text2119": "Ponuka vhodná pre absolventa",
  "text2120": "Vzdelávacie kurzy",
  "text2121": "Vytvor spojenie so svojím budúcim zamestnaním",
  "text2122": "Som zamestnávateľ",
  "text2123": "Som uchádzač",
  "text2124": "Zaplatiť ponuku",
  "text2125": "Odomknúť ponuku zadarmo",
  "text2126": "Voľné ponuky",
  "text2127": "odomknutie ponuky",
  "text2128": "Člen",
  "text2129": "Partner",
  "text2130": "Využiť voľnú ponuku",
  "text2131": "ostáva",
  "text2132": "Využiť voľné topovanie",
  "text2133": "Moje životopisy",
  "text2134": "Topovaná",
  "text2135": "Celkovo na úhradu",
  "text2136": "Zhrnutie objednávky",
  "text2137": "Pokračovať na zhrnutie",
  "text2138": "Produkty k nákupu",
  "text2139": "Doručovacia adresa",
  "text2140": "Späť na dodacie a fakturačné údaje",
  "text2141": "pre účely spracovania objednávok a marketingové účely.",
  "text2142": "Súhlasím so zasielaním informácií o novinkách, zľavách a cenových akciách.",
  "text2143": "maximálne 600 znakov",
  "text2144": "Doplniť údaje firmy podľa IČO",
  "text2145": "Doplniť údaje",
  "text2146": "Nemáte vyplnené údaje",
  "text2147": "Váš profil nemá kompletne vyplnené fakturačné údaje.",
  "text2148": "Platí do",
  "text2149": "maximálne 600 znakov",
  "text2150": "Povinné",
  "text2151": "Chcete uložiť zmeny ktoré ste vykonali?",
  "text2152": "Neuložiť",
  "text2153": "Topovaná do",
  "text2154": "Žiadne reakcie na ponuku",
  "text2155": "Kúpiť životopisy",
  "text2156": "Vyhľadávanie podľa mesta",
  "text2157": "mesiace",
  "text2158": "Odborná prax pre študentov",
  "text2159": "Titul kvalifikácie/vzdelania",
  "text2160": "Dosiahnuté vzdelanie",
  "text2161": "Organizácia poskytujúca vzdelanie/kvalifikáciu",
  "text2162": "Zadaný email už existuje",
  "text2163": "Veľkosť podniku",
  "text2164": "Vyberte veľkosť podniku",
  "text2165": "Zobraziť výhody",
  "text2166": "Základné",
  "text2167": "Obsah nie je platné XML",
  "text2168": "Obsah nie je platný JSON",
  "text2169": "Nákup na splátky",
  "text2170": "Mesiac",
  "text2171": "Nemáte pridané žiadne vzdelanie/kvalifikáciu",
  "text2172": "Nahlásiť chybu",
  "text2173": "Odomknutia životopisov",
  "text2174": "Odomknutia ponúk",
  "text2175": "Topovanie",
  "text2176": "Popis chyby",
  "text2177": "Chyba bola nahlásená",
  "text2178": "Nahlásiť ďalšiu chybu",
  "text2179": "Chyba sa odosiela",
  "text2180": "Ponuka uložená ako koncept musí mať meno",
  "text2181": "Overenie dostupnosti tovaru",
  "text2182": "Adresa predajcu",
  "text2183": "Dobrý deň, v eshope",
  "text2184": "sme zaevidovali dopyt zákazníka na nasledovný tovar:",
  "text2185": "Prosím informujte nás, či dopytovaný tovar máte na predajni, aby sme mohli informovať zákazníka.",
  "text2186": " S pozdravom obchodné oddelenie",
  "text2187": "Váš profil zatiaľ nie je vyplnený",
  "text2188": "Aby firmy mohli vidieť Váš profil, je potrebné ešte vyplniť nasledujúce údaje",
  "text2189": "Vyplniť profil",
  "text2190": "Ak chcete, aby firmy videli váš profil v databáze životopisov, je potrebné vyplniť ešte nasledujúce údaje:",
  "text2191": "Dokončiť profil",
  "text2192": "Admin",
  "text2193": "Aktualizovať",
  "text2194": "Profil záujemcu",
  "text2195": "Vybrať lektora",
  "text2196": "Ďalšie classes lektora",
  "text2197": "Priebeh campu",
  "text2198": "Lektorský tím",
  "text2199": "Jednotlivé kurzy",
  "text2200": "Prihlásení",
  "text2201": "Všetky sály",
  "text2202": "Celý rozvrh",
  "text2203": "Galéria udalosti",
  "text2204": "Média",
  "text2205": "Nenašli ste odpoveď na Vašu otázku? Kontaktujte nás.",
  "text2206": "Inštruktor",
  "text2207": "O lektorovi",
  "text2208": "Aké typy tanca vyučujem?",
  "text2209": "Úrovne tanečných skúseností",
  "text2210": "Galéria lektora",
  "text2211": "Tanečník",
  "text2212": "Pedagóg",
  "text2213": "Zaradenie (vyberte z možností) *",
  "text2214": "Zadajte názov tanečnej skupiny / ZUŠ a kde pôsobí",
  "text2215": "Vyberte školu",
  "text2216": "V prípade problémov nás kontaktujte",
  "text2217": "Tento e-mail bude slúžiť ako prihlasovacie meno.",
  "text2218": "Po registrácii obdržíte overovací e-mail.",
  "text2219": "podmienkami predplatného",
  "text2220": "Podmienky predplatného",
  "text2221": "Ponuka nie je plne vyplnená. Ak chcete ponuku zverejniť, upravte ponuku tak, aby boli vyplnené všetky povinné polia.",
  "text2222": "Ak chcete uložiť ponuku ako koncept, je potrebné vyplniť názov ponuky.",
  "text2223": "Zaplatenie ponuky",
  "text2224": "Ponuka bude zverejnená až po zaplatení",
  "text2225": "Zaplatiť ponuku môžete na profile v sekcii",
  "text2226": "Pracovná ponuka",
  "text2227": "Súhlasím s opakovanými platbami",
  "text2228": "Cenník",
  "text2229": "Vytvorenie profilu školy vám bude slúžiť ako vizitka školy.",
  "text2230": "Gratulujeme! Vaša prihláška na inzerát bola schválená. Kliknutím otvoríte chat s firmou.",
  "text2231": "Bohužiaľ, vaša prihláška na inzerát bola zamietnutá.",
  "text2232": "Kurz bol úspešne pridaný do košíka",
  "text2233": "Položky v košíku",
  "text2234": "Fyzická osoba",
  "text2235": "Právnícká osoba (firma)",
  "text2236": "Zaradenie",
  "text2237": "Vyberte z možností",
  "text2238": "Zadajte email",
  "text2239": "Zadajte telefónne číslo",
  "text2240": "Zadajte meno",
  "text2241": "Zadajte priezvisko",
  "text2242": "Upraviť ponuku",
  "text2243": "Pred zakúpením predplatného je potrebné byť prihlásený",
  "text2244": "Ešte nemáte účet?",
  "text2245": "Vytvorte si ho tu",
  "text2246": "Galéria",
  "text2247": "Zaujmite",
  "text2248": "s profesijným",
  "text2249": "videoživotopisom",
  "text2250": "Recept",
  "text2251": "Vytvoriť profesijný životopis",
  "text2252": "Číslo karty",
  "text2253": "Platnosť karty",
  "text2254": "CVV",
  "text2255": "MM / RR",
  "text2256": "Lektor",
  "text2257": "Sprístupnite si obsah kurzu prostredníctvom",
  "text2258": "predplatného.",
  "text2259": "Pokial máte predplatné zakúpené,",
  "text2260": "prihláste sa.",
  "text2261": "Nemáte žiadne obľúbené kurzy",
  "text2262": "Odobrať kartu",
  "text2263": "Servis bicyklov",
  "text2264": "Zaplatiť a uverejniť",
  "text2265": "Zaplatiť neskôr",
  "text2266": "Odkaz pre reakciu na ponuku",
  "text2267": "Pole nechajte prázdne ak reakcie na ponuku chcete spravovať v našom systéme",
  "text2268": "Zaslať záujem priamo",
  "text2269": "Zaplatená",
  "text2270": "Zrušiť odber",
  "text2271": "Pokiaľ si neželáte dostávať emaily, kliknite na odkaz",
  "text2272": "Naša adresa",
  "text2273": "Navštívte nás",
  "text2274": "Meno držiteľa karty",
  "text2275": "Nesprávny formát privátneho kľúča",
  "text2276": "Odporúčame objednať",
  "text2277": "Pridajte k správe DXF súbor, v prípade viacerých súborov ich zabaľte do .rar alebo .zip",
  "text2278": "Opýtať sa na cenu",
  "text2279": "Zadajte množstvo",
  "text2280": "Váš dopyt na cenu bol odoslaný. Budeme Vás kontaktovať prostredníctvom vašej e-mailovej adresy.",
  "text2281": "Nemám záujem",
  "text2282": "Nakúpili u nás",
  "text2283": "Viac než 2,789 spokojných zákazníkov",
  "text2284": "Vybrané kategórie",
  "text2285": "300m2 predajňa",
  "text2286": "Po-Pia: 8:30 - 17:00",
  "text2287": "Bonus klub",
  "text2288": "Naozaj sa chcete odhlásiť?",
  "text2289": "Áno, odhlásiť sa",
  "text2290": "Uložiť zmeny",
  "text2291": "vytvorte si ho tu.",
  "text2292": "Ak ešte nemáte svoj účet,",
  "text2293": "Nie, zrušiť",
  "text2294": "Spokojný zákazník",
  "text2295": "Osoba",
  "text2296": "Firma",
  "text2297": "Skladom",
  "text2298": "na vašej adrese",
  "text2299": "Preskúmať",
  "text2300": "Najpredávanejšie produkty",
  "text2301": "Načítať viac",
  "text2302": "Zoradiť",
  "text2303": "Posielame ihneď",
  "text2304": "Porovnať",
  "text2305": "Technické parametre",
  "text2306": "Pridať hodnotenie",
  "text2307": "Nastala chyba pri aktualizovaní vašeho profilu.",
  "text2308": "Všeobecné ustanovenia",
  "text2309": "Hlavná ponuka",
  "text2310": "Informácie o Vašej objednávke",
  "text2311": "Objednávka bola zaplatená",
  "text2312": "Objednávka zatiaľ nebola zaplatená",
  "text2313": "Pokračujte nadol",
  "text2314": "TOP výber",
  "text2315": "Preskúmajte TOP výbery pre každú záhradu",
  "text2316": "Milované majiteľmi domov\npo celom Slovensku",
  "text2317": "Najobľúbenejšie drevené konštrukcie a doplnky pre vašu záhradu",
  "text2318": "Preskúmajte naše najpredávanejšie kategórie drevených altánkov, domčekov, prístreškov a doplnkov. Kvalita a rýchle doručenie po celom Slovensku.",
  "text2319": "Všetky kategórie",
  "text2320": "Čím sa vyznačujú naše produkty?",
  "text2321": "Technické detaily",
  "text2322": "Naše posledné referencie",
  "text2323": "Kvalifikácia",
  "text2324": "Prečo si vybrať drevené altánky a domčeky?",
  "text2325": "Chcete aj vy svoj vysnívaný záhradný domček alebo altánok?",
  "text2326": "Objavte ponuku",
  "text2327": "Benefity",
  "text2328": "Čo získate s našimi produktmi?",
  "text2329": "Mám záujem o konzultáciu",
  "text2330": "Realizácie",
  "text2331": "Príbehy spokojných zákazníkov",
  "text2332": "Viac realizácií",
  "text2333": "Zaujímavé články na prečítanie",
  "text2334": "Nenašli ste odpoveď na otázku? Neváhajte nás kontaktovať.",
  "text2335": "Prehrať video",
  "text2336": "Ste pripravení premeniť svoju záhradu?",
  "text2337": "Potrebujete poradiť? Neváhajte nás kontaktovať či už cez kontaktný formulár alebo priamo cez kontaktné údaje nižšie.",
  "text2338": "Vyplňte formulár.",
  "text2339": "O čo máte záujem?",
  "text2340": "Vaša správa",
  "text2341": "Odoslaním formuláru súhlasíte so",
  "text2342": "spracovaním osobných údajov.",
  "text2343": "Odoslať správu",
  "text2344": "Prihláste sa na odber newsletteru a získavajte tie najaktuálnejšie informácie o našej ponuke.",
  "text2345": "Nepamätáte si svoje heslo?",
  "text2346": "Prosím vyplňte číslo objednávky a e-mail.",
  "text2347": "Objednávka pre zadanú kombináciu čísla objednávky a emailu neexistuje.",
  "text2348": "Ste prihlásený. Všetky Vaše objednávky viete nájsť vo svojom profile.",
  "text2349": "Heslo musí obsahovať minimálne 6 až 64 znakov, jedno veľké písmeno a jedno číslo.",
  "text2350": "Osobné / firemné údaje",
  "text2351": "Súpisné číslo",
  "text2352": "Vaša registrácia prebehla úspešne. Do Vašej e-mailovej schránky sme Vám zaslali potvrdzovací link pre aktiváciu účtu.",
  "text2353": "Vyberte si kategóriu podľa preferencie a nájdite produkt ktorý hľadáte.",
  "text2354": "Zobraziť viac kategórii",
  "text2355": "Zoradiť podľa",
  "text2356": "O kategórii",
  "text2357": "Kalkulačka",
  "text2358": "Kontaktujte nás a radi vám pomôžeme.",
  "text2359": "Tento produkt zatiaľ nemá žiadne recenzie. Budte prvý, a podelte sa o Vašu skúsenosť!",
  "text2360": "recenzií",
  "text2361": "História objednávok",
  "text2362": "Nakupujem na firmu",
  "text2363": "Potvrdiť zmenu hesla",
  "text2364": "Vyskytla sa chyba.",
  "text2365": "Miesto referencie",
  "text2366": "O projekte",
  "text2367": "Galéria projektu",
  "text2368": "Skúsenosť klienta",
  "text2369": "Podobné realizácie",
  "text2370": "Pokračujte na článok",
  "text2371": "Obsah článku",
  "text2372": "Po - Pia",
  "text2373": "So - Ne",
  "text2374": "Zatvorené",
  "text2375": "Navigovať na prevádzku",
  "text2376": "Nenašli sme obsah ktorý vyhovuje hľadaným požiadavkám",
  "text2377": "Ďakujeme za Váš záujem",
  "text2378": "Čo najskôr Vás budeme kontaktovať naspäť.",
  "text2379": "Domovská stránka",
  "text2380": "Inšpirácie",
  "text2381": "Inšpirácie pre vašu záhradu",
  "text2382": "Pozrite si proces výroby záhradného domčeka a altánku",
  "text2383": "My vs konkurencia",
  "text2384": "V čom sme lepší ako konkurencia?",
  "text2385": "Konkurencia",
  "text2386": "Drevené záhradne altánky a domčeky pre vašu záhradu",
  "text2387": "Kvalita a dostupné ceny s doručením po Slovensku",
  "text2388": "Vytvorte si dokonalý priestor na relax, skladovanie alebo ochranu auta s našimi drevenými altánkami, domčekmi, pergolami a prístreškami. Objednajte ešte dnes!",
  "text2389": "Cena za kus",
  "text2390": "Platba a doprava",
  "text2391": "Na jednu API integráciu je povolená iba jedna aktívna kategória.",
  "text2392": "Ak u nás máte svoj účet, prihláste sa a údaje vyplníme na základe údajov z Vášho účtu.",
  "text2393": "Pozrite si, čo si naši zákazníci nevedia vynachváliť. Tieto top hodnotené produkty kombinujú štýl, funkčnosť a dostupnosť.",
  "text2394": "Pozrite si naše najobľúbenejšie drevené konštrukcie, vyrobené z kvalitného smreka alebo borovice pre odolnosť a šarm. Ideálne pre akýkoľvek vonkajší priestor.",
  "text2395": "Prihláška",
  "text2396": "Užitočné linky",
  "text2397": "Stať sa členom",
  "text2398": "Členská zóna",
  "text2399": "Meno priezvisko / Názov spoločnosti",
  "text2400": "Pracovisko (napr. biochemické laboratórium)",
  "text2401": "Inštitúcia (napr. NsP Bratislava)",
  "text2402": "pre účely marketingu a kontaktovania",
  "text2403": "Spracovanie osobných údajov",
  "text2404": "Zistite viac",
  "text2405": "Vitajte v členskej zóne",
  "text2406": "Dokumenty",
  "text2407": "Stanovy",
  "text2408": "Etický kódex",
  "text2409": "Predsedníctvo",
  "text2410": "Zápisnice a dokumenty",
  "text2411": "Zoznam zástupcov členov združenia",
  "text2412": "Štatistika IVD trhu",
  "text2413": "Pohľadávky",
  "text2414": "Súhlasím so zaslaním dotazníka spokojnosti v rámci programu Heureka Overené zákazníkmi, ktorý pomáha zlepšovať naše služby.",
  "text2415": "Spoznaj svojho lektora",
  "text2416": "Vyhľadávajte podľa názvu firmy alebo IČO",
  "text2417": "Nenašli sa žiadne firmy",
  "text2418": "Neznáma platobná brána",
  "text2419": "Nemáte žiadne aktívne predplatné.",
  "text2420": "Zakúpte si ho tu.",
  "text2421": "Typ platiteľa",
  "text2422": "Jedn. cena",
  "text2423": "Metráž",
  "text2424": "Zakúpené kurzy",
  "text2425": "Nemáte zakúpené žiadne kurzy.",
  "text2426": "Prehľad kurzov.",
  "text2427": "Krok späť",
  "text2428": "Stav svojej objednávky si môžete kedykoľvek skontrolovať kliknutím na tlačidlo nižšie",
  "text2429": "Vašu rezerváciu e-receptu sme obdržali. Skontrolujte si e-mailovú schránku.",
  "text2430": "Nevyplnené",
  "text2431": "Ďakujeme za zaslanie rezervácie!",
  "text2432": "Vaša rezervácia bola úspešne odoslaná.",
  "text2433": "Odoslané údaje",
  "text2434": "Nahrajte fotografiu receptu",
  "text2435": "Vybrané fotografie",
  "text2436": "Odfotiť",
  "text2437": "Obrázok e-receptu",
  "text2438": "Ako uchádzač",
  "text2439": "Už mám účet, chcem sa ",
  "text2440": "Ako zamestnávateľ",
  "text2441": "Identifikačné číslo (IČO)",
  "text2442": "Adresa a sídlo spoločnosti",
  "text2443": "Upraviť životopis",
  "text2444": "Úpravy v profile boli úspešne uložené",
  "text2445": "Spýtaj sa nášho odborníka",
  "text2446": "Preferované miesto",
  "text2447": "Práca cez víkendy",
  "text2448": "Práca počas noci",
  "text2449": "Dodatočné informácie",
  "text2450": "Pracovné preferencie",
  "text2451": "Vybraným filtrom nevyhovujú žiadne životopisy",
  "text2452": "Pre pridanie novej pracovnej ponuky je potrebné vyplniť všetky povinné polia.",
  "text2453": "Základné informácie o pozícii",
  "text2454": "Požiadavky na uchádzača",
  "text2455": "Typ úväzku",
  "text2456": "Vyberte požadovaný typ vodičského preukazu",
  "text2457": "Pridať ďalší jazyk",
  "text2458": "Predpokladaný deň nástupu",
  "text2459": "Uveďte informácie o mieste výkonu práce.",
  "text2460": "Mzdové podmienky",
  "text2461": "Uveďte platobné podmienky pre uchádzača",
  "text2462": "Odstrániť ponuku",
  "text2463": "Aktuálne ponuky",
  "text2464": "Táto firma nemá žiadne aktívne ponuky",
  "text2465": "Opíšte svoju firmu",
  "text2466": "Poskytujeme prax študentom",
  "text2467": "Spolupracujeme so školami",
  "text2468": "Obsah blogu",
  "text2469": "Podobné články",
  "text2470": "Prečítajte si užitočné články.",
  "text2471": "Registrovať",
  "text2472": "Vložiť do košíka",
  "text2473": "Pokročilé vyhľadávanie",
  "text2474": "Vyhľadávať v",
  "text2475": "Prosím počkajte na email a SMS",
  "text2476": "Vymazať filter",
  "text2477": "Čiastočná zhoda s názvom produktu",
  "text2478": "Krátky popis produktu",
  "text2479": "EAN kód produktu",
  "text2480": "Externý kód produktu",
  "text2481": "Kód produktu",
  "text2482": "Začnite písať adresu",
  "text2483": "Kandidáti",
  "text2484": "Najstarší kandidáti",
  "text2485": "Najmladší kandidáti",
  "text2486": "Najnovšie reakcie",
  "text2487": "Najstaršie reakcie",
  "text2488": "Prijatý",
  "text2489": "Neprijatý",
  "text2490": "Termín už čoskoro",
  "text2491": "Neboli nájdené žiadne kurzy",
  "text2492": "predajňa",
  "text2493": "Tréningový proces",
  "text2494": "Chýbajúce nastavenie mailovej šablóny v stave objednávky",
  "text2495": "Balíkovo samoobslužné boxy",
  "text2496": "Balíkovo obchodná prevádzka",
  "text2497": "Podaj",
  "text2498": "Vybrať",
  "text2499": "Vybrané miesto",
  "text2500": "Dobierka",
  "text2501": "Celková suma objednávky",
  "text2502": "Zakúpiť",
  "text2503": "Využiť voľné topovanie",
  "text2504": "kredit",
  "text2505": "kredity",
  "text2506": "kreditov",
  "text2507": "Platba kreditmi",
  "text2508": "Expedícia pre objednávku nie je pripravená",
  "text2509": "Objednávka už bola expedovaná",
  "text2510": "Dopravca neponúka automatizovanú expedíciu",
  "text2511": "Nabuduce nezobrazovať",
  "text2512": "Počet osôb",
  "text2513": "Pre platobnú metódu nie je povolený opakovaný pokus o zaplatenie",
  "text2514": "Platobná brána momentálne nepodporuje vrátenie peňazí cez API",
  "text2515": "Vytvorenie pripomienky",
  "text2516": "Upravenie pripomienky",
  "text2517": "Vymazanie pripomienky",
  "text2518": "Vytvorenie produktu",
  "text2519": "Upravenie produktu",
  "text2520": "Vymazanie produktu",
  "text2521": "Vytvorenie ceny",
  "text2522": "Upravenie ceny",
  "text2523": "Vymazanie ceny",
  "text2524": "Vytvorenie typu nehnuteľnosti",
  "text2525": "Upravenie typu nehnuteľnosti",
  "text2526": "Vymazanie typu nehnuteľnosti",
  "text2527": "Vytvorenie typu ponuky nehnuteľnosti",
  "text2528": "Upravenie typu ponuky nehnuteľnosti",
  "text2529": "Vymazanie typu ponuky nehnuteľnosti",
  "text2530": "Vytvorenie miestnosti",
  "text2531": "Upravenie miestnosti",
  "text2532": "Vymazanie miestnosti",
  "text2533": "Vytvorenie štítka nehnuteľnosti",
  "text2534": "Upravenie štítka nehnuteľnosti",
  "text2535": "Vymazanie štítka nehnuteľnosti",
  "text2536": "Vytvorenie doplnkovej informácie nehnuteľnosti",
  "text2537": "Upravenie doplnkovej informácie nehnuteľnosti",
  "text2538": "Vymazanie doplnkovej informácie nehnuteľnosti",
  "text2539": "Vytvorenie hodnoty doplnkovej informácie nehnuteľnosti",
  "text2540": "Upravenie hodnoty doplnkovej informácie nehnuteľnosti",
  "text2541": "Vymazanie hodnoty doplnkovej informácie nehnuteľnosti",
  "text2542": "Vytvorenie mesta",
  "text2543": "Upravenie mesta",
  "text2544": "Vymazanie mesta",
  "text2545": "Vytvorenie obce",
  "text2546": "Upravenie obce",
  "text2547": "Vymazanie obce",
  "text2548": "Vytvorenie textového poľa nehnuteľnosti",
  "text2549": "Upravenie textového poľa nehnuteľnosti",
  "text2550": "Vymazanie textového poľa nehnuteľnosti",
  "text2551": "Vytvorenie kategórie nehnuteľnosti",
  "text2552": "Upravenie kategórie nehnuteľnosti",
  "text2553": "Vymazanie kategórie nehnuteľnosti",
  "text2554": "Vytvorenie pravidla nehnuteľnosti",
  "text2555": "Upravenie pravidla nehnuteľnosti",
  "text2556": "Vymazanie pravidla nehnuteľnosti",
  "text2557": "Vytvorenie odpovede pravidla nehnuteľnosti",
  "text2558": "Upravenie odpovede pravidla nehnuteľnosti",
  "text2559": "Vymazanie odpovede pravidla nehnuteľnosti",
  "text2560": "Vytvorenie rezervácie nehnuteľnosti",
  "text2561": "Upravenie rezervácie nehnuteľnosti",
  "text2562": "Vymazanie rezervácie nehnuteľnosti",
  "text2563": "Vytvorenie destinácie nehnuteľnosti",
  "text2564": "Upravenie destinácie nehnuteľnosti",
  "text2565": "Vymazanie destinácie nehnuteľnosti",
  "text2566": "Vytvorenie pozície nehnuteľnosti",
  "text2567": "Upravenie pozície nehnuteľnosti",
  "text2568": "Vymazanie pozície nehnuteľnosti",
  "text2569": "Vytvorenie agentúry nehnuteľnosti",
  "text2570": "Upravenie agentúry nehnuteľnosti",
  "text2571": "Vymazanie agentúry nehnuteľnosti",
  "text2572": "Vytvorenie makléra nehnuteľnosti",
  "text2573": "Upravenie makléra nehnuteľnosti",
  "text2574": "Vymazanie makléra nehnuteľnosti",
  "text2575": "Vytvorenie developera nehnuteľnosti",
  "text2576": "Upravenie developera nehnuteľnosti",
  "text2577": "Vymazanie developera nehnuteľnosti",
  "text2578": "Vytvorenie nehnuteľnosti",
  "text2579": "Upravenie nehnuteľnosti",
  "text2580": "Vymazanie nehnuteľnosti",
  "text2581": "Vytvorenie ceny nehnuteľnosti",
  "text2582": "Upravenie ceny nehnuteľnosti",
  "text2583": "Vymazanie ceny nehnuteľnosti",
  "text2584": "Vytvorenie vlastného pravidla nehnuteľnosti",
  "text2585": "Upravenie vlastného pravidla nehnuteľnosti",
  "text2586": "Vymazanie vlastného pravidla nehnuteľnosti",
  "text2587": "Vytvorenie rezervovateľného dňa nehnuteľnosti",
  "text2588": "Upravenie rezervovateľného dňa nehnuteľnosti",
  "text2589": "Vymazanie rezervovateľného dňa nehnuteľnosti",
  "text2590": "Vytvorenie typu kurzu",
  "text2591": "Upravenie typu kurzu",
  "text2592": "Vymazanie typu kurzu",
  "text2593": "Vytvorenie kategórie kurzu",
  "text2594": "Upravenie kategórie kurzu",
  "text2595": "Vymazanie kategórie kurzu",
  "text2596": "Vytvorenie textového poľa kurzu",
  "text2597": "Upravenie textového poľa kurzu",
  "text2598": "Vymazanie textového poľa kurzu",
  "text2599": "Vytvorenie kurzu",
  "text2600": "Upravenie kurzu",
  "text2601": "Vymazanie kurzu",
  "text2602": "Vytvorenie kategórie poradne",
  "text2603": "Upravenie kategórie poradne",
  "text2604": "Vymazanie kategórie poradne",
  "text2605": "Vytvorenie ceny kurzu",
  "text2606": "Upravenie ceny kurzu",
  "text2607": "Vymazanie ceny kurzu",
  "text2608": "Vytvorenie kapitoly kurzu",
  "text2609": "Upravenie kapitoly kurzu",
  "text2610": "Vymazanie kapitoly kurzu",
  "text2611": "Vytvorenie lektora kurzu",
  "text2612": "Upravenie lektora kurzu",
  "text2613": "Vymazanie lektora kurzu",
  "text2614": "Vytvorenie úrovne kurzu",
  "text2615": "Upravenie úrovne kurzu",
  "text2616": "Vymazanie úrovne kurzu",
  "text2617": "Vytvorenie miestnosti kurzu",
  "text2618": "Upravenie miestnosti kurzu",
  "text2619": "Vymazanie miestnosti kurzu",
  "text2620": "Vytvorenie udalosti kurzu",
  "text2621": "Upravenie udalosti kurzu",
  "text2622": "Vymazanie udalosti kurzu",
  "text2623": "Vytvorenie harmonogramu kurzu",
  "text2624": "Upravenie harmonogramu kurzu",
  "text2625": "Vymazanie harmonogramu kurzu",
  "text2626": "Vytvorenie typu pracovného úväzku",
  "text2627": "Upravenie typu pracovného úväzku",
  "text2628": "Vymazanie typu pracovného úväzku",
  "text2629": "Vytvorenie štítka pracovného portálu",
  "text2630": "Upravenie štítka pracovného portálu",
  "text2631": "Vymazanie štítka pracovného portálu",
  "text2632": "Vytvorenie textového poľa pracovného portálu",
  "text2633": "Upravenie textového poľa pracovného portálu",
  "text2634": "Vymazanie textového poľa pracovného portálu",
  "text2635": "Vytvorenie kategórie pracovného portálu",
  "text2636": "Upravenie kategórie pracovného portálu",
  "text2637": "Vymazanie kategórie pracovného portálu",
  "text2638": "Vytvorenie typu platby pracovného portálu",
  "text2639": "Upravenie typu platby pracovného portálu",
  "text2640": "Vymazanie typu platby pracovného portálu",
  "text2641": "Vytvorenie veľkosti firmy pracovného portálu",
  "text2642": "Upravenie veľkosti firmy pracovného portálu",
  "text2643": "Vymazanie veľkosti firmy pracovného portálu",
  "text2644": "Vytvorenie firmy pracovného portálu",
  "text2645": "Upravenie firmy pracovného portálu",
  "text2646": "Vymazanie firmy pracovného portálu",
  "text2647": "Vytvorenie stavu pracovného portálu",
  "text2648": "Upravenie stavu pracovného portálu",
  "text2649": "Vymazanie stavu pracovného portálu",
  "text2650": "Vytvorenie hodnoty atribútu pracovného portálu",
  "text2651": "Upravenie hodnoty atribútu pracovného portálu",
  "text2652": "Vymazanie hodnoty atribútu pracovného portálu",
  "text2653": "Vytvorenie atribútu pracovného portálu",
  "text2654": "Upravenie atribútu pracovného portálu",
  "text2655": "Vymazanie atribútu pracovného portálu",
  "text2656": "Vytvorenie času práce pracovného portálu",
  "text2657": "Upravenie času práce pracovného portálu",
  "text2658": "Vymazanie času práce pracovného portálu",
  "text2659": "Vytvorenie miesta výkonu práce pracovného portálu",
  "text2660": "Upravenie miesta výkonu práce pracovného portálu",
  "text2661": "Vymazanie miesta výkonu práce pracovného portálu",
  "text2662": "Vytvorenie vekového rozpätia pracovného portálu",
  "text2663": "Upravenie vekového rozpätia pracovného portálu",
  "text2664": "Vymazanie vekového rozpätia pracovného portálu",
  "text2665": "Vytvorenie požadovanej predošlej praxe pracovného portálu",
  "text2666": "Upravenie požadovanej predošlej praxe pracovného portálu",
  "text2667": "Vymazanie požadovanej predošlej praxe pracovného portálu",
  "text2668": "Vytvorenie vhodnoti pre pozíciu pracovného portálu",
  "text2669": "Upravenie vhodnoti pre pozíciu pracovného portálu",
  "text2670": "Vymazanie vhodnoti pre pozíciu pracovného portálu",
  "text2671": "Vytvorenie ukončeného vzdelania pracovného portálu",
  "text2672": "Upravenie ukončeného vzdelania pracovného portálu",
  "text2673": "Vymazanie ukončeného vzdelania pracovného portálu",
  "text2674": "Vytvorenie vodičského preukazu pracovného portálu",
  "text2675": "Upravenie vodičského preukazu pracovného portálu",
  "text2676": "Vymazanie vodičského preukazu pracovného portálu",
  "text2677": "Vytvorenie typu školy pracovného portálu",
  "text2678": "Upravenie typu školy pracovného portálu",
  "text2679": "Vymazanie typu školy pracovného portálu",
  "text2680": "Vytvorenie školského odboru pracovného portálu",
  "text2681": "Upravenie školského odboru pracovného portálu",
  "text2682": "Vymazanie školského odboru pracovného portálu",
  "text2683": "Vytvorenie školy pracovného portálu",
  "text2684": "Upravenie školy pracovného portálu",
  "text2685": "Vymazanie školy pracovného portálu",
  "text2686": "Vytvorenie projektu školy pracovného portálu",
  "text2687": "Upravenie projektu školy pracovného portálu",
  "text2688": "Vymazanie projektu školy pracovného portálu",
  "text2689": "Vytvorenie spolupráce školy pracovného portálu",
  "text2690": "Upravenie spolupráce školy pracovného portálu",
  "text2691": "Vymazanie spolupráce školy pracovného portálu",
  "text2692": "Vytvorenie pracovnej ponuky pracovného portálu",
  "text2693": "Upravenie pracovnej ponuky pracovného portálu",
  "text2694": "Vymazanie pracovnej ponuky pracovného portálu",
  "text2695": "Vytvorenie zručnosti pracovnej ponuky pracovného portálu",
  "text2696": "Upravenie zručnosti pracovnej ponuky pracovného portálu",
  "text2697": "Vymazanie zručnosti pracovnej ponuky pracovného portálu",
  "text2698": "Vytvorenie mzdy pracovnej ponuky pracovného portálu",
  "text2699": "Upravenie mzdy pracovnej ponuky pracovného portálu",
  "text2700": "Vymazanie mzdy pracovnej ponuky pracovného portálu",
  "text2701": "Vytvorenie životopisu pracovného portálu",
  "text2702": "Upravenie životopisu pracovného portálu",
  "text2703": "Vymazanie životopisu pracovného portálu",
  "text2704": "Vytvorenie zručnosti životopisu pracovného portálu",
  "text2705": "Upravenie zručnosti životopisu pracovného portálu",
  "text2706": "Vymazanie zručnosti životopisu pracovného portálu",
  "text2707": "Vytvorenie pracovnej skúsenosti životopisu pracovného portálu",
  "text2708": "Upravenie pracovnej skúsenosti životopisu pracovného portálu",
  "text2709": "Vymazanie pracovnej skúsenosti životopisu pracovného portálu",
  "text2710": "Vytvorenie vzdelania životopisu pracovného portálu",
  "text2711": "Upravenie vzdelania životopisu pracovného portálu",
  "text2712": "Vymazanie vzdelania životopisu pracovného portálu",
  "text2713": "Vytvorenie mzdy životopisu pracovného portálu",
  "text2714": "Upravenie mzdy životopisu pracovného portálu",
  "text2715": "Vymazanie mzdy životopisu pracovného portálu",
  "text2716": "Vytvorenie stavu cestovnej kancelárie",
  "text2717": "Upravenie stavu cestovnej kancelárie",
  "text2718": "Vymazanie stavu cestovnej kancelárie",
  "text2719": "Vytvorenie štítka cestovnej kancelárie",
  "text2720": "Upravenie štítka cestovnej kancelárie",
  "text2721": "Vymazanie štítka cestovnej kancelárie",
  "text2722": "Vytvorenie textového poľa cestovnej kancelárie",
  "text2723": "Upravenie textového poľa cestovnej kancelárie",
  "text2724": "Vymazanie textového poľa cestovnej kancelárie",
  "text2725": "Vytvorenie hodnoty atribútu cestovnej kancelárie",
  "text2726": "Upravenie hodnoty atribútu cestovnej kancelárie",
  "text2727": "Vymazanie hodnoty atribútu cestovnej kancelárie",
  "text2728": "Vytvorenie atribútu cestovnej kancelárie",
  "text2729": "Upravenie atribútu cestovnej kancelárie",
  "text2730": "Vymazanie atribútu cestovnej kancelárie",
  "text2731": "Vytvorenie kategórie cestovnej kancelárie",
  "text2732": "Upravenie kategórie cestovnej kancelárie",
  "text2733": "Vymazanie kategórie cestovnej kancelárie",
  "text2734": "Vytvorenie zájazdu cestovnej kancelárie",
  "text2735": "Upravenie zájazdu cestovnej kancelárie",
  "text2736": "Vymazanie zájazdu cestovnej kancelárie",
  "text2737": "Vytvorenie termínu zájazdu cestovnej kancelárie",
  "text2738": "Upravenie termínu zájazdu cestovnej kancelárie",
  "text2739": "Vymazanie termínu zájazdu cestovnej kancelárie",
  "text2740": "Vytvorenie rezervácie zájazdu cestovnej kancelárie",
  "text2741": "Upravenie rezervácie zájazdu cestovnej kancelárie",
  "text2742": "Vymazanie rezervácie zájazdu cestovnej kancelárie",
  "text2743": "Vytvorenie účastníka zájazdu cestovnej kancelárie",
  "text2744": "Upravenie účastníka zájazdu cestovnej kancelárie",
  "text2745": "Vymazanie účastníka zájazdu cestovnej kancelárie",
  "text2746": "Vytvorenie typu zákazníka",
  "text2747": "Upravenie typu zákazníka",
  "text2748": "Vymazanie typu zákazníka",
  "text2749": "Vytvorenie zákazníka",
  "text2750": "Upravenie zákazníka",
  "text2751": "Vymazanie zákazníka",
  "text2752": "Vytvorenie zákazníka v zákaznickej skupine",
  "text2753": "Upravenie zákazníka v zákaznickej skupine",
  "text2754": "Vymazanie zákazníka zo zákaznickej skupiny",
  "text2755": "Vytvorenie zákaznickej skupiny",
  "text2756": "Upravenie zákaznickej skupiny",
  "text2757": "Vymazanie zákaznickej skupiny",
  "text2758": "Vytvorenie používateľskej roly",
  "text2759": "Upravenie používateľskej roly",
  "text2760": "Vymazanie používateľskej roly",
  "text2761": "Vytvorenie používateľa",
  "text2762": "Upravenie používateľa",
  "text2763": "Vymazanie používateľa",
  "text2764": "Vytvorenie kupónu k produktu",
  "text2765": "Upravenie kupónu k produktu",
  "text2766": "Vymazanie kupónu k produktu",
  "text2767": "Vytvorenie kupónu",
  "text2768": "Upravenie kupónu",
  "text2769": "Vymazanie kupónu",
  "text2770": "Vytvorenie zľavy kupónu",
  "text2771": "Upravenie zľavy kupónu",
  "text2772": "Vymazanie zľavy kupónu",
  "text2773": "Vytvorenie darčeku k produktu",
  "text2774": "Upravenie darčeku k produktu",
  "text2775": "Vymazanie darčeku k produktu",
  "text2776": "Vytvorenie príslušenstva k produktu",
  "text2777": "Upravenie príslušenstva k produktu",
  "text2778": "Vymazanie príslušenstva k produktu",
  "text2779": "Vytvorenie balíčka k produktu",
  "text2780": "Upravenie balíčka k produktu",
  "text2781": "Vymazanie balíčka k produktu",
  "text2782": "Vytvorenie otázky k produktu",
  "text2783": "Upravenie otázky k produktu",
  "text2784": "Vymazanie otázky k produktu",
  "text2785": "Vytvorenie virtuálneho produktu k produktu",
  "text2786": "Upravenie virtuálneho produktu k produktu",
  "text2787": "Vymazanie virtuálneho produktu k produktu",
  "text2788": "Vytvorenie služby k produktu",
  "text2789": "Upravenie služby k produktu",
  "text2790": "Vymazanie služby produktu",
  "text2791": "Vytvorenie recenzie produktu",
  "text2792": "Upravenie recenzie produktu",
  "text2793": "Vymazanie recenzie produktu",
  "text2794": "Vytvorenie varianty produktu",
  "text2795": "Upravenie varianty produktu",
  "text2796": "Vymazanie varianty produktu",
  "text2797": "Vytvorenie ceny varianty produktu",
  "text2798": "Upravenie ceny varianty produktu",
  "text2799": "Vymazanie ceny varianty produktu",
  "text2800": "Vytvorenie marže kategórie",
  "text2801": "Upravenie marže kategórie",
  "text2802": "Vymazanie marže kategórie",
  "text2803": "Vytvorenie zľavy kategórie",
  "text2804": "Upravenie zľavy kategórie",
  "text2805": "Vymazanie zľavy kategórie",
  "text2806": "Vytvorenie kategórie",
  "text2807": "Upravenie kategórie",
  "text2808": "Vymazanie kategórie",
  "text2809": "Vytvorenie hodnoty atribútu",
  "text2810": "Upravenie hodnoty atribútu",
  "text2811": "Vymazanie hodnoty atribútu",
  "text2812": "Vytvorenie atribútu",
  "text2813": "Upravenie atribútu",
  "text2814": "Vymazanie atribútu",
  "text2815": "Vytvorenie marže dodávateľa",
  "text2816": "Upravenie marže dodávateľa",
  "text2817": "Vymazanie marže dodávateľa",
  "text2818": "Vytvorenie zľavy dodávateľa",
  "text2819": "Upravenie zľavy dodávateľa",
  "text2820": "Vymazanie zľavy dodávateľa",
  "text2821": "Vytvorenie dodávateľa",
  "text2822": "Upravenie dodávateľa",
  "text2823": "Vymazanie dodávateľa",
  "text2824": "Vytvorenie výrobcu",
  "text2825": "Upravenie výrobcu",
  "text2826": "Vymazanie výrobcu",
  "text2827": "Vytvorenie textového poľa",
  "text2828": "Upravenie textového poľa",
  "text2829": "Vymazanie textového poľa",
  "text2830": "Vytvorenie stavu produktu",
  "text2831": "Upravenie stavu produktu",
  "text2832": "Vymazanie stavu produktu",
  "text2833": "Vytvorenie štítka produktu",
  "text2834": "Upravenie štítka produktu",
  "text2835": "Vymazanie štítka produktu",
  "text2836": "Vytvorenie darčeka k produktu",
  "text2837": "Upravenie darčeka k produktu",
  "text2838": "Vymazanie darčeka k produktu",
  "text2839": "Vytvorenie darčeka",
  "text2840": "Upravenie darčeka",
  "text2841": "Vymazanie darčeka",
  "text2842": "Vytvorenie produktu k akcii",
  "text2843": "Upravenie produktu k akcii",
  "text2844": "Vymazanie produktu k akcii",
  "text2845": "Vytvorenie akcie",
  "text2846": "Upravenie akcie",
  "text2847": "Vymazanie akcie",
  "text2848": "Vytvorenie ceny akcie",
  "text2849": "Upravenie ceny akcie",
  "text2850": "Vymazanie ceny akcie",
  "text2851": "Vytvorenie možnosti služby",
  "text2852": "Upravenie možnosti služby",
  "text2853": "Vymazanie možnosti služby",
  "text2854": "Vytvorenie ceny možnosti služby",
  "text2855": "Upravenie ceny možnosti služby",
  "text2856": "Vymazanie ceny možnosti služby",
  "text2857": "Vytvorenie spôsobu platby",
  "text2858": "Upravenie spôsobu platby",
  "text2859": "Vymazanie spôsobu platby",
  "text2860": "Vytvorenie ceny spôsobu platby",
  "text2861": "Upravenie ceny spôsobu platby",
  "text2862": "Vymazanie ceny spôsobu platby",
  "text2863": "Vytvorenie zľavy spôsobu platby",
  "text2864": "Upravenie zľavy spôsobu platby",
  "text2865": "Vymazanie zľavy spôsobu platby",
  "text2866": "Vytvorenie spôsobu dopravy",
  "text2867": "Upravenie spôsobu dopravy",
  "text2868": "Vymazanie spôsobu dopravy",
  "text2869": "Vytvorenie ceny spôsobu dopravy",
  "text2870": "Upravenie ceny spôsobu dopravy",
  "text2871": "Vymazanie ceny spôsobu dopravy",
  "text2872": "Vytvorenie výdajného miesta",
  "text2873": "Upravenie výdajného miesta",
  "text2874": "Vymazanie výdajného miesta",
  "text2875": "Vytvorenie multiprojektu",
  "text2876": "Upravenie multiprojektu",
  "text2877": "Vymazanie multiprojektu",
  "text2878": "Vytvorenie regiónu",
  "text2879": "Upravenie regiónu",
  "text2880": "Vymazanie regiónu",
  "text2881": "Vytvorenie jazyku",
  "text2882": "Upravenie jazyku",
  "text2883": "Vymazanie jazyku",
  "text2884": "Vytvorenie meny",
  "text2885": "Upravenie meny",
  "text2886": "Vymazanie meny",
  "text2887": "Vytvorenie krajiny",
  "text2888": "Upravenie krajiny",
  "text2889": "Vymazanie krajiny",
  "text2890": "Vytvorenie menu",
  "text2891": "Upravenie menu",
  "text2892": "Vymazanie menu",
  "text2893": "Vytvorenie položky menu",
  "text2894": "Upravenie položky menu",
  "text2895": "Vymazanie položky menu",
  "text2896": "Vytvorenie emailovej šablóny",
  "text2897": "Upravenie emailovej šablóny",
  "text2898": "Vymazanie emailovej šablóny",
  "text2899": "Vytvorenie DPH",
  "text2900": "Upravenie DPH",
  "text2901": "Vymazanie DPH",
  "text2902": "Vytvorenie typu veľkoobchodu",
  "text2903": "Upravenie typu veľkoobchodu",
  "text2904": "Vymazanie typu veľkoobchodu",
  "text2905": "Vytvorenie veľkoobchodu",
  "text2906": "Upravenie veľkoobchodu",
  "text2907": "Vymazanie veľkoobchodu",
  "text2908": "Vytvorenie adresy veľkoobchodu",
  "text2909": "Upravenie adresy veľkoobchodu",
  "text2910": "Vymazanie adresy veľkoobchodu",
  "text2911": "Vytvorenie domény veľkoobchodu",
  "text2912": "Upravenie domény veľkoobchodu",
  "text2913": "Vymazanie domény veľkoobchodu",
  "text2914": "Vytvorenie reklamácie",
  "text2915": "Upravenie reklamácie",
  "text2916": "Vymazanie reklamácie",
  "text2917": "Vytvorenie dôvodu reklamácie",
  "text2918": "Upravenie dôvodu reklamácie",
  "text2919": "Vymazanie dôvodu reklamácie",
  "text2920": "Vytvorenie stavu reklamácie",
  "text2921": "Upravenie stavu reklamácie",
  "text2922": "Vymazanie stavu reklamácie",
  "text2923": "Vytvorenie stránky",
  "text2924": "Upravenie stránky",
  "text2925": "Vymazanie stránky",
  "text2926": "Vytvorenie bannera",
  "text2927": "Upravenie bannera",
  "text2928": "Vymazanie bannera",
  "text2929": "Vytvorenie pohlavia",
  "text2930": "Upravenie pohlavia",
  "text2931": "Vymazanie pohlavia",
  "text2932": "Vytvorenie produktu k blogu",
  "text2933": "Upravenie produktu k blogu",
  "text2934": "Vymazanie produktu k blogu",
  "text2935": "Vytvorenie blogu",
  "text2936": "Upravenie blogu",
  "text2937": "Vymazanie blogu",
  "text2938": "Vytvorenie kategórie blogu",
  "text2939": "Upravenie kategórie blogu",
  "text2940": "Vymazanie kategórie blogu",
  "text2941": "Vytvorenie príspevku na sociálnu sieť",
  "text2942": "Upravenie príspevku na sociálnu sieť",
  "text2943": "Vymazanie príspevku na sociálnu sieť",
  "text2944": "Vytvorenie sociálnej siete",
  "text2945": "Upravenie sociálnej siete",
  "text2946": "Vymazanie sociálnej siete",
  "text2947": "Vytvorenie newslettra",
  "text2948": "Upravenie newslettra",
  "text2949": "Vymazanie newslettra",
  "text2950": "Vytvorenie hromadného mailu",
  "text2951": "Upravenie hromadného mailu",
  "text2952": "Vymazanie hromadného mailu",
  "text2953": "Vytvorenie štítka newslettra",
  "text2954": "Upravenie štítka newslettra",
  "text2955": "Vymazanie štítka newslettra",
  "text2956": "Vytvorenie emailu newslettra",
  "text2957": "Upravenie emailu newslettra",
  "text2958": "Vymazanie emailu newslettra",
  "text2959": "Vytvorenie vernostných bodov",
  "text2960": "Upravenie vernostných bodov",
  "text2961": "Vymazanie vernostných bodov",
  "text2962": "Vytvorenie odpovede poradne",
  "text2963": "Upravenie odpovede poradne",
  "text2964": "Vymazanie odpovede poradne",
  "text2965": "Vytvorenie poradne",
  "text2966": "Upravenie poradne",
  "text2967": "Vymazanie poradne",
  "text2968": "Vytvorenie kategórie referencie",
  "text2969": "Upravenie kategórie referencie",
  "text2970": "Vymazanie kategórie referencie",
  "text2971": "Vytvorenie referencie",
  "text2972": "Upravenie referencie",
  "text2973": "Vymazanie referencie",
  "text2974": "Vytvorenie služby",
  "text2975": "Upravenie služby",
  "text2976": "Vymazanie služby",
  "text2977": "Vytvorenie ceny služby",
  "text2978": "Upravenie ceny služby",
  "text2979": "Vymazanie ceny služby",
  "text2980": "Vytvorenie kariéry",
  "text2981": "Upravenie kariéry",
  "text2982": "Vymazanie kariéry",
  "text2983": "Vytvorenie povinného zverejňovania",
  "text2984": "Upravenie povinného zverejňovania",
  "text2985": "Vymazanie povinného zverejňovania",
  "text2986": "Vytvorenie galérie",
  "text2987": "Upravenie galérie",
  "text2988": "Vymazanie galérie",
  "text2989": "Vytvorenie člena tímu",
  "text2990": "Upravenie člena tímu",
  "text2991": "Vymazanie člena tímu",
  "text2992": "Vytvorenie zákazníka k predplatnému",
  "text2993": "Upravenie zákazníka k predplatnému",
  "text2994": "Vymazanie zákazníka k predplatnému",
  "text2995": "Vytvorenie kategórie predplatného",
  "text2996": "Upravenie kategórie predplatného",
  "text2997": "Vymazanie kategórie predplatného",
  "text2998": "Vytvorenie typu predplatného",
  "text2999": "Upravenie typu predplatného",
  "text3000": "Vymazanie typu predplatného",
  "text3001": "Vytvorenie ceny typu predplatného",
  "text3002": "Upravenie ceny typu predplatného",
  "text3003": "Vymazanie ceny typu predplatného",
  "text3004": "Vytvorenie predplatného",
  "text3005": "Upravenie predplatného",
  "text3006": "Vymazanie predplatného",
  "text3007": "Upravenie API konfigurácie",
  "text3008": "Vytvorenie stavu objednávky",
  "text3009": "Upravenie stavu objednávky",
  "text3010": "Vymazanie stavu objednávky",
  "text3011": "Vytvorenie nastavenia stavu objednávky",
  "text3012": "Upravenie nastavenia stavu objednávky",
  "text3013": "Vymazanie nastavenia stavu objednávky",
  "text3014": "Vytvorenie objednávky",
  "text3015": "Upravenie objednávky",
  "text3016": "Vymazanie objednávky",
  "text3017": "Vytvorenie expedície objednávky",
  "text3018": "Upravenie expedície objednávky",
  "text3019": "Vymazanie expedície objednávky",
  "text3020": "Vytvorenie ikony",
  "text3021": "Upravenie ikony",
  "text3022": "Vymazanie ikony",
  "text3023": "Vytvorenie útulku",
  "text3024": "Upravenie útulku",
  "text3025": "Vymazanie útulku",
  "text3026": "Vytvorenie typu recenzie",
  "text3027": "Upravenie typu recenzie",
  "text3028": "Vymazanie typu recenzie",
  "text3029": "Vytvorenie recenzie",
  "text3030": "Upravenie recenzie",
  "text3031": "Vymazanie recenzie",
  "text3032": "Vytvorenie konfigurácií",
  "text3033": "Upravenie konfigurácií",
  "text3034": "Vymazanie konfigurácií",
  "text3035": "Vytvorenie seo",
  "text3036": "Upravenie seo",
  "text3037": "Vymazanie seo",
  "text3038": "Vytvorenie presmerovania",
  "text3039": "Upravenie presmerovania",
  "text3040": "Vymazanie presmerovania",
  "text3041": "Vytvorenie služby kalkulačky",
  "text3042": "Upravenie služby kalkulačky",
  "text3043": "Vymazanie služby kalkulačky",
  "text3044": "Vytvorenie ceny služby kalkulačky",
  "text3045": "Upravenie ceny služby kalkulačky",
  "text3046": "Vymazanie ceny služby kalkulačky",
  "text3047": "Vytvorenie doplnkovej informácie kalkulačky",
  "text3048": "Upravenie doplnkovej informácie kalkulačky",
  "text3049": "Vymazanie doplnkovej informácie kalkulačky",
  "text3050": "Vytvorenie hodnoty doplnkovej informácie kalkulačky",
  "text3051": "Upravenie hodnoty doplnkovej informácie kalkulačky",
  "text3052": "Vymazanie hodnoty doplnkovej informácie kalkulačky",
  "text3053": "Vytvorenie ceny hodnoty doplnkovej informácie kalkulačky",
  "text3054": "Upravenie ceny hodnoty doplnkovej informácie kalkulačky",
  "text3055": "Vymazanie ceny hodnoty doplnkovej informácie kalkulačky",
  "text3056": "Vytvorenie produktu kalkulačky",
  "text3057": "Upravenie produktu kalkulačky",
  "text3058": "Vymazanie produktu kalkulačky",
  "text3059": "Vytvorenie ceny produktu kalkulačky",
  "text3060": "Upravenie ceny produktu kalkulačky",
  "text3061": "Vymazanie ceny produktu kalkulačky",
  "text3062": "Vytvorenie objednávky kalkulačky",
  "text3063": "Upravenie objednávky kalkulačky",
  "text3064": "Vymazanie objednávky kalkulačky",
  "text3065": "Vytvorenie hodnoty objednávky kalkulačky",
  "text3066": "Upravenie hodnoty objednávky kalkulačky",
  "text3067": "Vymazanie hodnoty objednávky kalkulačky",
  "text3068": "Vytvorenie služby objednávky kalkulačky",
  "text3069": "Upravenie služby objednávky kalkulačky",
  "text3070": "Vymazanie služby objednávky kalkulačky",
  "text3071": "Upravenie konfigurácie cestovnej kancelárie",
  "text3072": "Upravenie konfigurácie newslettra",
  "text3073": "Upravenie konfigurácie hromadného mailu",
  "text3074": "Upravenie konfigurácie vernostného programu",
  "text3075": "Upravenie konfigurácie opustených nákupných košíkov",
  "text3076": "Upravenie konfigurácie SEO",
  "text3077": "Vytvorenie stavu e-receptu",
  "text3078": "Upravenie stavu e-receptu",
  "text3079": "Vymazanie stavu e-receptu",
  "text3080": "Vytvorenie e-receptu",
  "text3081": "Upravenie e-receptu",
  "text3082": "Vymazanie e-receptu",
  "text3083": "Vytvorenie stavu rezervácie liekov",
  "text3084": "Upravenie stavu rezervácie liekov",
  "text3085": "Vymazanie stavu rezervácie liekov",
  "text3086": "Vytvorenie produktu rezervácie liekov",
  "text3087": "Upravenie produktu rezervácie liekov",
  "text3088": "Vymazanie produktu rezervácie liekov",
  "text3089": "Vytvorenie rezervácie liekov",
  "text3090": "Upravenie rezervácie liekov",
  "text3091": "Vymazanie rezervácie liekov",
  "text3092": "Vytvorenie služby rezervácie",
  "text3093": "Upravenie služby rezervácie",
  "text3094": "Vymazanie služby rezervácie",
  "text3095": "Vytvorenie ceny služby rezervácie",
  "text3096": "Upravenie ceny služby rezervácie",
  "text3097": "Vymazanie ceny služby rezervácie",
  "text3098": "Vytvorenie automatického rozvrhu rezervácie",
  "text3099": "Upravenie automatického rozvrhu rezervácie",
  "text3100": "Vymazanie automatického rozvrhu rezervácie",
  "text3101": "Vytvorenie času rezervácie",
  "text3102": "Upravenie času rezervácie",
  "text3103": "Vymazanie času rezervácie",
  "text3104": "Vytvorenie osoby rezervácie",
  "text3105": "Upravenie osoby rezervácie",
  "text3106": "Vymazanie osoby rezervácie",
  "text3107": "Vytvorenie rezervácie",
  "text3108": "Upravenie rezervácie",
  "text3109": "Vymazanie rezervácie",
  "text3110": "Upravenie konfigurácie všeobecných nastavení",
  "text3111": "Prihlásenie prebehlo úspešne",
  "text3112": "Váš účet bol úspešne prepojený.",
  "text3113": "Teraz môžete toto okno bezpečne zavrieť — výsledok bol odoslaný do aplikácie.",
  "text3114": "Zatvoriť okno",
  "text3115": "Zatvorte toto okno manuálne.",
  "text3116": "Sledujte nás na Instagrame",
  "text3117": "Odkaz bol úspešne skopírovaný do schránky",
  "text3118": "Predplatné vyprší",
  "text3119": "Zmeny v profile boli úspešne uložené",
  "text3120": "Profil bol úspešne vytvorený",
  "text3121": "Pripravujeme",
  "text3122": "Nemáte aktívne predplatné",
  "text3123": "Zakúpte si predplatné na 1 rok a získajte neobmedzený prístup ku všetkým online kurzom a zľavu vo výške 10% na eventy!",
  "text3124": "Zakúpiť predplatné",
  "text3125": "Moje produkty",
  "text3126": "Predsedníctvo združenia SEDMA",
  "text3127": "Predplatné už máte zakúpené.",
  "text3128": "Prejsť na kurzy",
  "text3129": "Dokumenty k objednávke nájdete vo svojom profile",
  "text3130": "Tento produkt na našom eshope nemáme k dispozícii",
  "text3131": "Vyhľadávam informácie o produkte...",
  "text3132": "Tento produkt na našom eshope nemáme k dispozícii",
  "text3133": "Vytvorenie darčeka kategórie",
  "text3134": "Upravenie darčeka kategórie",
  "text3135": "Vymazanie darčeka kategórie",
  "text3136": "Darček bol už priradený",
  "text3137": "Darček nie je povolený pre tento produkt",
  "text3138": "Zakúpte si kurzy v našich eventoch.",
  "text3139": "Potvrdzovací e-mail bol úspešne odoslaný",
  "text3140": "Odkaz na obnovenie hesla je neplatný",
  "text3141": "Vyhľadávať v poliach",
  "text3142": "Exaktné vyhľadávanie",
  "text3143": "Objednávka bola zrušená",
  "text3144": "Platobný príkaz bol zrušený a nebol vykonaný.",
  "text3145": "Boli ste odhlásený",
  "text3146": "Na váš účet sa niekto prihlásil z iného zariadenia.",
  "text3147": "Upravenie konfigurácie poradne",
  "text3148": "Vytvorenie naskladnenia",
  "text3149": "Upravenie naskladnenia",
  "text3150": "Vymazanie naskladnenia",
  "text3151": "Vytvorenie položky naskladnenia",
  "text3152": "Upravenie položky naskladnenia",
  "text3153": "Vymazanie položky naskladnenia",
  "text3154": "Súbor už bol v minulosti spracovaný",
  "text3155": "Vytvorenie nákupu dňa",
  "text3156": "Upravenie nákupu dňa",
  "text3157": "Vymazanie nákupu dňa",
  "text3158": "Vytvorenie položky nákupu dňa",
  "text3159": "Upravenie položky nákupu dňa",
  "text3160": "Vymazanie položky nákupu dňa",
  "text3161": "Zobraziť všetko",
  "text3162": "Vytvorenie zľavy položky nákupu dňa",
  "text3163": "Upravenie zľavy položky nákupu dňa",
  "text3164": "Vymazanie zľavy položky nákupu dňa",
  "text3165": "Vytvorenie skupiny produktov",
  "text3166": "Upravenie skupiny produktov",
  "text3167": "Vymazanie skupiny produktov",
  "text3168": "Vytvorenie zľavy skupiny produktov",
  "text3169": "Upravenie zľavy skupiny produktov",
  "text3170": "Vymazanie zľavy skupiny produktov",
  "text3171": "Darček bol pridaný k objednávke",
  "text3172": "Darček už bol pridaný k objednávke",
  "text3173": "Vytvorenie dopravy kategórie",
  "text3174": "Upravenie dopravy kategórie",
  "text3175": "Vymazanie dopravy kategórie",
  "text3176": "Vytvorenie ceny dopravy kategórie",
  "text3177": "Upravenie ceny dopravy kategórie",
  "text3178": "Vymazanie ceny dopravy kategórie",
  "text3179": "Meno / Názov spoločnosti",
  "text3180": "Parametre produktu",
  "text3181": "Zadajte, prosím, svoju e-mailovú adresu a my Vám odošleme odkaz na obnovenie hesla.",
  "text3182": "Vytvorenie účtu",
  "text3183": "Heslo znovu",
  "text3184": "Orientačné číslo",
  "text3185": "Späť na prihlásenie",
  "text3186": "Produkty v zľave",
  "text3187": "Celý výpredaj",
  "text3188": "Nákup dňa",
  "text3189": "minúta",
  "text3190": "hodina",
  "text3191": "hodiny",
  "text3192": "hodín",
  "text3193": "sekunda",
  "text3194": "sekundy",
  "text3195": "sekúnd",
  "text3196": "Akcia vyprší o",
  "text3197": "minúty",
  "text3198": "Kúpiť tento produkt",
  "text3199": "Odoberajte pre novinky a zľavy.",
  "text3200": "Newsletter ste začali úspešne odoberať",
  "text3201": "Ste prihlásený. Všetky Vaše objednávky viete nájsť vo svojom profile.",
  "text3202": "Stiahnúť cenník",
  "text3203": "Pošlite nám fax",
  "text3204": "Oprava",
  "text3205": "Bankové spojenie (EUR)",
  "text3206": "Naši distribútori",
  "text3207": "spokojných zákazníkov",
  "text3208": "Váš účet bol úspešne vytvorený!",
  "text3209": "Načítať viac článkov",
  "text3210": "Potrebujete poradiť? Neváhajte nás kontaktovať či už cez kontaktný formulár alebo priamo telefonicky a emailom.",
  "text3211": "Spojte sa s nami, radi vám poradíme",
  "text3212": "Fakturačné a dodacie údaje",
  "text3213": "Vytvorenie ceny dopravy produktu",
  "text3214": "Upravenie ceny dopravy produktu",
  "text3215": "Vymazanie ceny dopravy produktu",
  "text3216": "Zadaný kupón neexistuje",
  "text3217": "Mám zľavový kupón",
  "text3218": "Ďakujeme za Vašu objednávku číslo",
  "text3219": "Potvrdenie objednávky sme Vám zaslali na Vami zadanú e-mailovú adresu.",
  "text3220": "Neboli nájdené žiadne produkty",
  "text3221": "Zaujímavé články",
  "text3222": "Odoberané",
  "text3223": "Zrušiť odber",
  "text3224": "Naozaj si prajete zrušiť odoberanie newsletteru?",
  "text3225": "Odoberanie newsletteru bolo zrušené",
  "text3226": "Zrušiť odber newsletteru",
  "text3227": "Ku každej objednávke",
  "text3228": "V cene",
  "text3229": "Objednávka od",
  "text3230": "Ku každej objednávke",
  "text3231": "Čo hovoria naši spokojný zákazníci?",
  "text3232": "Expirovaná",
  "text3233": "Pre vstup do členskej zóny musíte byť",
  "text3234": "prihlásený",
  "text3235": "V prípade, že nie ste zaregistrovaný, kliknite na odkaz",
  "text3236": "Registrácia.",
  "text3237": "Zabudnuté heslo?",
  "text3238": "Prezerať kategóriu",
  "text3239": "Akciové produkty",
  "text3240": "Aktuálna ponuka zájazdov",
  "text3241": "Menu",
  "text3242": "Produkt bol pridaný do košíka",
  "text3243": "Vytvorenie dodávateľa varianty",
  "text3244": "Upravenie dodávateľa varianty",
  "text3245": "Vymazanie dodávateľa varianty",
  "text3246": "Vytvorenie ceny dodávateľa varianty",
  "text3247": "Upravenie ceny dodávateľa varianty",
  "text3248": "Vymazanie ceny dodávateľa varianty",
  "text3249": "Kupón je neplatný",
  "text3250": "Informácie o možnostiach vrátenia a reklamácia tovaru nájde na stránke",
  "text3251": "Vrátenie a reklamácia",
  "text3252": "Prevádzková doba zákazníckej linky",
  "text3253": "Po-Pia: 8:30 - 17:00",
  "text3254": "Viac než",
  "text3255": "Zobraziť všetky služby",
  "text3256": "Skryť",
  "text3257": "Darčeky k produktu",
  "text3258": "Darček k nákupu",
  "text3259": "Vypočítať splátky",
  "text3260": "overených recenzií",
  "text3261": "Dôvod kontaktovania",
  "text3262": "Neplatná autentifikácia. Skúste to prosím znova",
  "text3263": "Telefónne číslo je povinné",
  "text3264": "Prihlásením na odber súhlasíte so",
  "text3265": "Akcia",
  "text3266": "Rýchle doručenie",
  "text3267": "Rýchle a bezpečné doručenie zdarma pre objednávky nad 100€.",
  "text3268": "Možnosti doručenia",
  "text3269": "30 dní na vrátenie",
  "text3270": "Nie ste spokojní s produktom? Máte 30 dní na vrátenie tovaru a vrátenie peňazí.",
  "text3271": "Možnosti platby",
  "text3272": "Klient",
  "text3273": "Sadzba klienta",
  "text3274": "Ostáva hodín",
  "text3275": "Stav predplatného",
  "text3276": "Predplatné je aktivované",
  "text3277": "Predplatné nie je aktivované",
  "text3278": "Vyprší",
  "text3279": "Fakturačný email",
  "text3280": "Zodpovedný vedúci (konateľ)",
  "text3281": "Navigovať na adresu",
  "text3282": "Bankové spojenie",
  "text3283": "Reklamácia č.:",
  "text3284": "Dátum reklamácie",
  "text3285": "Dátum kúpy",
  "text3286": "Podpis zákazníka",
  "text3287": "Podpis predajcu",
  "text3288": "dňa",
  "text3289": "Podrobný popis závady a stav tovaru",
  "text3290": "Dodané príslušenstvo",
  "text3291": "Predmet reklamácie",
  "text3292": "Doklad o kúpe",
  "text3293": "Pôvodný obal",
  "text3294": "Vybavenie reklamácie č.:",
  "text3295": "Dátum ukončenia",
  "text3296": "Bližšia špecifikácia vykonanej opravy",
  "text3297": "Vytvorenie záznamu o nehode",
  "text3298": "Upravenie záznamu o nehode",
  "text3299": "Vymazanie záznamu o nehode",
  "text3300": "Prevádzková doba zákazníckej linky",
  "text3301": "Google Recenzie",
  "text3302": "Prihláste sa na odber noviniek",
  "text3303": "Buďte informovaní o našich zľavá a akciach včas.",
  "text3304": "Hľadať zájazd",
  "text3305": "Vyhľadať zájazd",
  "text3306": "Zobraziť všetky zájazdy",
  "text3307": "Mám záujem o zájazd na mieru",
  "text3308": "Čo pre vás môžeme zabezpečiť",
  "text3309": "Destinácia",
  "text3310": "Koľko by Vás chcelo vycestovať",
  "text3311": "Aký termín by Vám najviac vyhovoval",
  "text3312": "Preferovaný termín",
  "text3313": "Váš záujem o zájazd na mieru bol úspešne odoslaný",
  "text3314": "Funkcionalitu aktuálne nepodporujeme",
  "text3315": "Súbory sa nenašli",
  "text3316": "Katalóg produktov",
  "text3317": "Hodnotilo",
  "text3318": "viac než 1000 klientov",
  "text3319": "Prejsť do e-shopu",
  "text3320": "Stiahnúť e-book zdarma",
  "text3321": "Upravenie konfigurácie darčekov",
  "text3322": "Napíšte nám e-mail",
  "text3323": "Naše zaujímavé články",
  "text3324": "Ešte nie ste zaregistrovaný?",
  "text3325": "Tu je, o čo prichádzate:",
  "text3326": "Zaregistrovať sa",
  "text3327": "Dokumenty ZADARMO",
  "text3328": "Platené dokumenty",
  "text3329": "Nenašli ste odpoveď na otázku? Spojte sa s nami priamo prostredníctvom kontaktu.",
  "text3330": "Evidencia chorob z povolania, nebezpečných udalostí, pracovných úrazov",
  "text3331": "Zákony a zákonníky o zdraví a bezpečnosti",
  "text3332": "Prvá pomoc pri život ohrozujúcich stavoch",
  "text3333": "Traumatologický plán",
  "text3334": "Protokoly, kontroly a hlasenia",
  "text3335": "Smernice a zákony",
  "text3336": "Lehoty technického zariadenia",
  "text3337": "Protokol o školenie zamestnancov",
  "text3338": "Vzory dokumentov",
  "text3339": "Kontrola a postupy",
  "text3340": "Osvedčenie",
  "text3341": "Upravenie konfigurácie marketingu",
  "text3342": "Vytvorenie kategórie rezervácie",
  "text3343": "Upravenie kategórie rezervácie",
  "text3344": "Vymazanie kategórie rezervácie",
  "text3345": "Máte účet? Prihláste sa a údaje vyplníme za vás.",
  "text3346": "Ste úspešne prihlásený",
  "text3347": "Súčasťou členstva máte tieto výhody",
  "text3348": "Použiť kupón",
  "text3349": "Kompletná ochrana",
  "text3350": "toho, na čom Vám najviac záleží",
  "text3351": "Vyplňte formulár a my sa vám ozveme.",
  "text3352": "Vaša správa / záujem",
  "text3353": "Odoslaním správy súhlasíte so",
  "text3354": "pre účely kontaktovania.",
  "text3355": "Pokračujte v čítaní",
  "text3356": "Reklamácia",
  "text3357": "Odstúpenie od zmluvy",
  "text3358": "Odstúpenie od zmluvy a reklamácia tovaru",
  "text3359": "zobraziť všetky",
  "text3360": "min čítania",
  "text3361": "Nenašli ste odpoveď na vašu otázku? Kontaktujte nás telefonicky alebo emailom a radi vám odpovieme.",
  "text3362": "Zistiť viac o Sonicube",
  "text3363": "Stať sa partnerom",
  "text3364": "Upravenie konfigurácie upomienok",
  "text3365": "Upravenie konfigurácie plánovania upomienok",
  "text3366": "Vytvorenie upomienky",
  "text3367": "Upravenie upomienky",
  "text3368": "Vymazanie upomienky",
  "text3369": "Prihlásením na odber noviniek súhlasíte so",
  "text3370": "pre účely marketingu a zasielania noviniek.",
  "text3371": "Vyplňte formulár a my sa vám ozveme\ndo 24 hodín.",
  "text3372": "Počet dní po splatnosti",
  "text3373": "Dátum pridelenia na vymáhanie",
  "text3374": "Darček k produktu",
  "text3375": "Potrebujete informácie o produktoch alebo vašej objednávke?",
  "text3376": "Poznámka už bola odoslaná zákazníkovi",
  "text3377": "Vyhľadajte",
  "text3378": "Viac fotografií",
  "text3379": "Operácia zlyhala",
  "text3380": "Spôsob doručenia",
  "text3381": "Popis závady",
  "text3382": "Váš účet bol úspešne vytvorený!",
  "text3383": "Na zadanú e-mailovú adresu sme vám zaslali",
  "text3384": "Resetovať filter",
  "text3385": "Objednávka bola úspešne odoslaná",
  "text3386": "Vašu objednávku sme úspešne zaevidovali. Potvrdenie obdržíte na vašu e-mailovú adresu zadanú pri objednávke.",
  "text3387": "Prihlás sa na odber a dostávaj tipy, ako podporiť regeneráciu a zdravie.",
  "text3388": "Reklamácie",
  "text3389": "pre účely marketingu.",
  "text3390": "Firemný zákazník",
  "text3391": "Čítať článok",
  "text3392": "Mám otázku",
  "text3393": "EAN produktu",
  "text3394": "Vytvorenie typu skupín produktov",
  "text3395": "Upravenie typu skupín produktov",
  "text3396": "Vymazanie typu skupín produktov",
  "text3397": "Pridať recenziu",
  "text3398": "Daňová povinnosť",
  "text3399": "Hodnotenie produktu",
  "text3400": "Ohodnoťte tento produkt",
  "text3401": "Registrácia prebehla úspešne",
  "text3402": "Na zadanú e-mailovú adresu sme vám zaslali overovací e-mail.",
  "text3403": "Textový popis",
  "text3404": "pre účely spracovania hodnotenia produktu.",
  "text3405": "Váš kód",
  "text3406": "Na úhradu",
  "text3407": "Späť na doprava a platba",
  "text3408": "Objednávka s povinnosťou platby",
  "text3409": "Super! Objednávka je na ceste",
  "text3410": "Ďakujeme, že ste si vybrali práve nás.",
  "text3411": "Potvrdenie objednávky nájdete vo svojom e-maile a o jej stave vás budeme priebežne informovať",
  "text3412": "Máte u nás účet?",
  "text3413": "Prihláste sa a údaje vyplníme za vás.",
  "text3414": "Objednávka",
  "text3415": "Aktuálne heslo",
  "text3416": "Na zadanú e-mailovú adresu sme vám zaslali potvrdenie o zmene hesla.",
  "text3417": "Vyhľadať produkt",
  "text3418": "Certifikáty",
  "text3419": "Moje projekty",
  "text3420": "Žiadna SMS integrácia nie je aktívna",
  "text3421": "Chyba pri validácii SMS limitov",
  "text3422": "Nepodarilo sa overiť stav SMS kreditu. Skontrolujte konfiguráciu",
  "text3423": "Nedostatok SMS kreditu",
  "text3424": "Súhrn odoslaných upomienok",
  "text3425": "boli odoslané nasledujúce upomienky zákazníkom",
  "text3426": "Extrakcia dokumentu bola spustená. Po dokončení budete notifikovaný",
  "text3427": "Dohodni si konzultáciu",
  "text3428": "Aj s týmto Vám vieme pomôcť",
  "text3429": "Pre študentov",
  "text3430": "ponuka",
  "text3431": "Nájdete nás",
  "text3432": "Ponuka bola pridaná do obľúbených",
  "text3433": "Upravenie konfigurácie dokumentov",
  "text3434": "Počet ponúk",
  "text3435": "Ďalšie ponuky",
  "text3436": "Ponuka bola upravená",
  "text3437": "Ponuka bola vytvorená",
  "text3438": "Pomoc pri objednávke",
  "text3439": "Pozrieť všetky",
  "text3440": "otvorených pozícií",
  "text3441": "Pozície",
  "text3442": "Objednávka už bola uhradená",
  "text3443": "Faktúra je zároveň aj dodacím listom.",
  "text3444": "produktov",
  "text3445": "Vygenerované pomocou AI",
  "text3446": "mesačne",
  "text3447": "Zobraziť kompletný životopis",
  "text3448": "Prečo označiť AI obrázok?",
  "text3449": "Zaškrtnutím potvrdzujete, že obrázok bol vytvorený umelou inteligenciou.\n        Pomáhate nám tak dodržiavať zákon o AI a zvyšovať transparentnosť pre uchádzačov.",
  "text3450": "Zodpovednosť za správne označenie AI generovaného obsahu nesie inzerent.",
  "text3451": "Neoznačený AI obsah môže byť moderátorom dodatočne upravený alebo odstránený.",
  "text3452": "Nenašli ste odpoveď na otázku?",
  "text3453": "Kontaktujte nás a my vám čo najskôr odpovieme.",
  "text3454": "Rok narodenia",
  "text3455": "Údaj o roku narodenia slúži výhradne na overenie plnoletosti používateľa a zabezpečenie súladu s právnymi požiadavkami. Tento údaj sa nepoužíva na iné účely",
  "text3456": "Vybrať súbory",
  "text3457": "Maximálny počet súborov je ",
  "text3458": "Maximálna veľkosť súboru je 2MB",
  "text3459": "Chyba pri nahrávaní súboru",
  "text3460": "Spôsoby platby",
  "text3461": "Formy doručenia",
  "text3462": "Nezmeškajte žiadne novinky a aktuálny výpredaj!",
  "text3463": "Odoberajte novinky prihlásením do nášho newslettera",
  "text3464": "Váš e-mail",
  "text3465": "Počet hodnotení",
  "text3466": "Tento produkt nemá žiadne recenzie.",
  "text3467": "Doručovacie údaje",
  "text3468": "Vyplňte e-mail pre zaslanie linku na obnovenie hesla.",
  "text3469": "Naše články",
  "text3470": "Výpredaj",
  "text3471": "Nemáte prístup k životopisom",
  "text3472": "Táto sekcia je dostupná pre firemné účty s predplateným prístupom k životopisom.",
  "text3473": "Zobraziť cenník",
  "text3474": "Prístup k životopisom je dostupný len pre firemné účty.",
  "text3475": "Celá kategória",
  "text3476": "Skryť telefón",
  "text3477": "Zoznam pozícií",
  "text3478": "Zvolená sekvencia nie je použiteľná pre typ dokumentu",
  "text3479": "Otvoriť košík",
  "text3480": "Množstevné zľavy",
  "text3481": "Zakúpiť prístup k životopisom",
  "text3482": "Prístup k životopisom",
  "text3483": "Pre firmy",
  "text3484": "Zverejnenie pracovnej ponuky",
  "text3485": "Topovanie ponuky",
  "text3486": "Časovo obmedzená ponuka",
  "text3487": "Kupón vyprší o",
  "text3488": "Prihláste sa k odberu noviniek a získajte zľavu!",
  "text3489": "Novinky, aktuálne trendy a akcie priamo do e-mailu. Súčasťou odberu je zľavový kupón. Odhlásenie kedykoľvek zdarma.",
  "text3490": "Nie, ďakujem, nechcem zľavu",
  "text3491": "Získajte kupón",
  "text3492": "Pri objednávke nad",
  "text3493": "Pre všetky objednávky",
  "text3494": "Kupón bol zaslaný na váš e-mail",
  "text3495": "Získať kupón",
  "text3496": "Získavajte informácie o nových produktoch a zľavách medzi prvými.",
  "text3497": "Doručenie",
  "text3498": "Objaviť koncept",
  "text3499": "Staňte sa partnerom",
  "text3500": "Zistiť možnosti spolupráce",
  "text3501": "bodov",
  "text3502": "Počet bodov získaných za 1€ nákupu\n",
  "text3503": "Hodnota jedného bodu",
  "text3504": "Maximálne zľavnenie v percentách na objednávku",
  "text3505": "Ak chcete využiť vernostný program, prihláste sa",
  "text3506": "Uplatniť všetky body",
  "text3507": "Vernostné body boli aplikované",
  "text3508": "Uplatniť",
  "text3509": "Prihlasovací e-mail",
  "text3510": "Žiadne prílohy",
  "text3511": "hodnotenie",
  "text3512": "hodnotenia",
  "text3513": "hodnotení",
  "text3514": "Zvoliť hodnotenie",
  "text3515": "Zistite viac tu",
  "text3516": "Zobraziť všetky parametre",
  "text3517": "Zostávajúce odomknutia",
  "text3518": "Všetky údaje budú dostupné po odomknutí životopisu.",
  "text3519": "Uzamknutý profil",
  "text3520": "Profil kandidáta",
  "text3521": "Vyberte 1 až 3 kategórie/pozície",
  "text3522": "Zobraziť všetky blogy",
  "text3523": "Nezáväzná cenová ponuka",
  "text3524": "Hlavný banner",
  "text3525": "Predošlí snímok",
  "text3526": "Ďalší snímok",
  "text3527": "Otvoriť popup",
  "text3528": "Zobraziť na mape referenciu",
  "text3529": "Predchádzajúca stránka",
  "text3530": "Ďalšia stránka",
  "text3531": "Ísť na stránku",
  "text3532": "Ísť na snímok",
  "text3533": "Predchádzajúce náhľady",
  "text3534": "Zobraziť viac obrázkov",
  "text3535": "Ďalšie náhľady",
  "text3536": "Požiadať o partnerskú konzultáciu",
  "text3537": "Toto označenie môžu naši partneri využívať",
  "text3538": "Vytvorenie FAQ",
  "text3539": "Upravenie FAQ",
  "text3540": "Vymazanie FAQ",
  "text3541": "Vytvorenie Schema.org",
  "text3542": "Upravenie Schema.org",
  "text3543": "Vymazanie Schema.org",
  "text3544": "Vyplňte formulár a dohodnite si úvodnú partnerskú konzultáciu.",
  "text3545": "Vytvorenie strážneho psa",
  "text3546": "Upravenie strážneho psa",
  "text3547": "Vymazanie strážneho psa",
  "text3548": "HASQO balík",
  "text3549": "Viac informácií",
  "text3550": "Balík",
  "text3551": "Balík obsahuje",
  "text3552": "Vhodné pre",
  "text3553": "Konzultácia",
  "text3554": "Názov prevádzky",
  "text3555": "Mesto prevádzky",
  "text3556": "Typ prevádzky",
  "text3557": "Veľkosť (m²)",
  "text3558": "Planovaný čas",
  "text3559": "Tel. číslo",
  "text3560": "Vaše údaje",
  "text3561": "Životopis je zamknutý",
  "text3562": "Životopis je dostupný až po zakúpení. Po odomknutí sa zobrazi plný profil uchádzača.",
  "text3563": "Strážny pes",
  "text3564": "Strážny pes bol úspešne vytvorený",
  "text3565": "Dáme Vám vedieť, keď bude tento produkt opäť dostupný",
  "text3566": "Nepodarilo sa vytvoriť strážneho psa",
  "text3567": "Zadajte svoj e-mail a dostanete upozornenie, keď bude tento produkt opäť dostupný",
  "text3568": "Strážne psy",
  "text3569": "Strážny pes bol odstránený",
  "text3570": "Nepodarilo sa odstrániť strážneho psa",
  "text3571": "Nemáte nastavených žiadných strážnych psov",
  "text3572": "Voľné topovania",
  "text3573": "Quatro kalkulačka",
  "text3574": "Vyberte výdajné miesto GLS",
  "text3575": "Popis projektu",
  "text3576": "O akú realizáciu máte záujem?",
  "text3577": "Vyberte",
  "text3578": "Lokalita realizácie",
  "text3579": "Vyplňte adresu",
  "text3580": "Orientačný dátum realizácie",
  "text3581": "Meno / Spoločnosť",
  "text3582": "Vyplňte meno / názov spoločnosti",
  "text3583": "Vyplňte email",
  "text3584": "Vyplňte telefón",
  "text3585": "Vaša poznámka",
  "text3586": "Poznámka",
  "text3587": "Odoslaním súhlasíte so",
  "text3588": "Spoznajte naše služby",
  "text3589": "Zobraziť viac realizácií",
  "text3590": "Máte ďalšie otázky?",
  "text3591": "Máte ešte inú otázku alebo ste nenašli svoju odpoveď?",
  "text3592": "Pracovná doba",
  "text3593": "Výroba na mieru",
  "text3594": "Kvalitné materiály\n",
  "text3595": "Detail prevedenia",
  "text3596": "Proces realizácie",
  "text3597": "na odber noviniek",
  "text3598": "Získavajte najnovšie informácie spoločnosti KAUFMANN.",
  "text3599": "Váš email",
  "text3600": "Odberom noviniek súhlasíte so",
  "text3601": "Ukázať na mape",
  "text3602": "alebo",
  "text3603": "Naši pracovníci sú vám k dispozícii v",
  "text3604": "pracovné dni od 8:00 do 16:00",
  "text3605": "Sklad",
  "text3606": "Načítať viac realizácii",
  "text3607": "V tejto kategórii sme nenašli žiadne výsledky",
  "text3608": "Vytvorenie najpredávanejšieho produktu",
  "text3609": "Upravenie najpredávanejšieho produktu",
  "text3610": "Vymazanie najpredávanejšieho produktu",
  "text3611": "Nahlásiť",
  "text3612": "Dôvod nahlásenia",
  "text3613": "Maturita",
  "text3614": "nocí",
  "text3615": "Termín zajazdu",
  "text3616": "Dĺžka zájazdu",
  "text3617": "Cena od",
  "text3618": "Na vyžiadanie",
  "text3619": "Zobraziť detail zájazdu",
  "text3620": "Voľné miesta",
  "text3621": "Aktualizujem termíny",
  "text3622": "Všetky zájazdy sú skryté",
  "text3623": "Pre vybrané obdobie nie sú dostupné žiadne zájazdy",
  "text3624": "Zmenšiť",
  "text3625": "Na celú obrazovku",
  "text3626": "Termíny sa nepodarilo načítať",
  "text3627": "podkategórií",
  "text3628": "Odstrániť výber",
  "text3629": "Nahlásenie ponuky",
  "text3630": "Nahlásenie firmy",
  "text3631": "Nahlásenie životopisu",
  "text3632": "Nahlásenie sa nepodarilo odoslať",
  "text3633": "Nahlásenie bolo odoslané",
  "text3634": "životopisov",
  "text3635": "životopisy",
  "text3636": "Objednávka v procese",
  "text3637": "Domov",
  "text3638": "Vytvorenie platby objednávky",
  "text3639": "Upravenie platby objednávky",
  "text3640": "Vymazanie platby objednávky",
  "text3641": "Staňte sa našim jedinečným partnerom.",
  "text3642": "Prihláste sa na odber noviniek a informácií o\npridaných nových vlastnostiach.",
  "text3643": "Nové nehnuteľnosti",
  "text3644": "Nehnuteľnosti za špičkovú cenu",
  "text3645": "Referencie spokojných klientov",
  "text3646": "Pozrite si, čo si o nás myslia naši klienti.",
  "text3647": "Prečítajte si články o atrakciách na Cypre",
  "text3648": "Všetky fotografie",
  "text3649": "Zdielať",
  "text3650": "Dátum dokončenia",
  "text3651": "Popis nehnuteľnosti",
  "text3652": "Prehliadka rezortu",
  "text3653": "Vygenerovať PDF",
  "text3654": "Rezervácia prehliadky",
  "text3655": "Výber termínu online konzultácie",
  "text3656": "Nehnuteľnosti na severnom Cypre",
  "text3657": "Počet izieb",
  "text3658": "Realitná kancelária",
  "text3659": "Nehnutelnosti",
  "text3660": "Resale / Platená intercia",
  "text3661": "Objednajte sa na konzultáciu",
  "text3662": "Zoom hovor trvá maximálne 1 hodinu a my vám odpovieme na všetky vaše otázky + získate\n              bezplatnú prezentáciu všetkých dostupných projektov, ktoré na Cypre máme.",
  "text3663": "Ponuky",
  "text3664": "Máte ďalšie otázky? Radi vám predstavíme koncept  HASQO v praxi.",
  "text3665": "Požiadať o konzultáciu",
  "text3666": "Zákaznická zóna",
  "text3667": "Zásielka",
  "text3668": "Úspešnosť doručenia",
  "text3669": "Zákaznická linka",
  "text3670": "Chcem získať cenovú ponuku",
  "text3671": "Príhlásením do newsletteru súhlasíte so",
  "text3672": "Vyberte z noviniek",
  "text3673": "Nakupujte podľa kategórie",
  "text3674": "TOP výber produktov",
  "text3675": "Prihláste sa k odberu noviniek a dostávajte vždy aktuálne informácie o akciách a novinkách.",
  "text3676": "Vaša e-mailová adresa...",
  "text3677": "Záruka bezpečného nákupu",
  "text3678": "Spôsoby dopravy",
  "text3679": "Naše realizácie",
  "text3680": "Kolekcie",
  "text3681": "Zobraziť všetky kolekcie",
  "text3682": "Dôverujú nám",
  "text3683": "Overené a získané prostredníctvom Google",
  "text3684": "Všetky recenzie",
  "text3685": "Overené",
  "text3686": "Všetky filtre",
  "text3687": "Žiadne produkty neboli nájdené",
  "text3688": "Hĺbka",
  "text3689": "Získajte cenovú ponuku pre vašu prepravu",
  "text3690": "Web vytvorili",
  "text3691": "od 9:00 do 17:00",
  "text3692": "O službe",
  "text3693": "Čo služba zahŕňa?",
  "text3694": "Pre aké zásielky je služba vhodná?",
  "text3695": "Ako to prebieha?",
  "text3696": "Prezrite si ďalšiu službu",
  "text3697": "Čo hovoria naši spokojni klienti",
  "text3698": "Registračný e-mail",
  "text3699": "Vyplňte formulár a získajte ponuku",
  "text3700": "Vyhľadajte zásielku",
  "text3701": "Napíšte nám správu",
  "text3702": "Získať ponuku",
  "text3703": "Ukončiť",
  "text3704": "Vernostný systém",
  "text3705": "Adresa doručenia je rovnaká ako fakturačná",
  "text3706": "Meno kontaktnej osoby",
  "text3707": "Priezvisko kontaktnej osoby",
  "text3708": "E-mailovú adresu nie je možné zmeniť, kontaktuje prosím našu podporu.",
  "text3709": "Rady, trendy a praktické články",
  "text3710": "Ďalšie články ktoré by vás mohli zaujímať",
  "text3711": "Prevádzkovateľ",
  "text3712": "Potrebujete poradiť?\nOzvite sa nám a radi vám pomôžeme.",
  "text3713": "Kontaktujte našu zákaznickú podporu alebo nám napíšte prostredníctvom kontaktného formulári a naši pracovníci vám poradia.",
  "text3714": "Vaša požiadavka",
  "text3715": "Odoslať žiadosť o zmenu hesla",
  "text3716": "Položky v objednávke",
  "text3717": "Suma objednávky",
  "text3718": "bola zaznamenaná. Čakáme na úhradu, a po jej pripisaní na náš účet následne dáme na realizáciu. Prosím skontrolujte si Váš email",
  "text3719": "Pozrieť voľné pozície",
  "text3720": "Najnovšia ponuka",
  "text3721": "Staňte sa súčasťou nášho tímu",
  "text3722": "Vyplňte formulár a pošlite nám životopis. Ak nás váš profil zaujme a bude spĺňať vaše požiadavky, ozveme sa vám.",
  "text3723": "Pošlite nám životopis",
  "text3724": "Miesto naloženia",
  "text3725": "Cieľová destinácia",
  "text3726": "Typ tovaru",
  "text3727": "Váha (cca)",
  "text3728": "Objem (m3)",
  "text3729": "Ukázať trasu",
  "text3730": "Dokončiť objednávku",
  "text3731": "Varianta",
  "text3732": "Vložte zľavový kód",
  "text3733": "Použiť body",
  "text3734": "Počet bodov (vložte celé číslo)",
  "text3735": "Upozornenie: Dodatočná zmena odberateľa na faktúre nie je možná.",
  "text3736": "Chcem nakúpiť na firmu",
  "text3737": "Doručovacia adresa je iná ako fakturačná",
  "text3738": "Fakturačné a doručovacie údaje",
  "text3739": "Vaša objednávka bola odoslaná",
  "text3740": "Vašu objednávku sme zaevidovali pod číslom",
  "text3741": "potvrdenie objednávky vám doručíme na zadanú e-mailovú adresu pri vytváraní objednávky.",
  "text3742": " Späť na hlavnú stránku",
  "text3743": "Vyhľadané produkty",
  "text3744": "položiek",
  "text3745": "Zobraziť všetky vyhľadané",
  "text3746": "Porovnanie produktov",
  "text3747": "Žiadne produkty na porovnanie. Pridajte produkty kliknutím na ikonu porovnania.",
  "text3748": "Hmotnosť",
  "text3749": "Farebné varianty",
  "text3750": "Váš účet bol úspešne vytvorený ",
  "text3751": "Registrácia tu",
  "text3752": "1 kurz = 5 tréningov",
  "text3753": "Prihlásením k odberu noviniek súhlasíte so",
  "text3754": "Prečítajte si naše praktické články alebo sa inšpirujte trendami s teakovým nábytkom.",
  "text3755": "Prezerať ponuku",
  "text3756": "Akčné produkty",
  "text3757": "Vytvorenie typu nákladu",
  "text3758": "Upravenie typu nákladu",
  "text3759": "Vymazanie typu nákladu",
  "text3760": "Vytvorenie nákladu",
  "text3761": "Upravenie nákladu",
  "text3762": "Vymazanie nákladu",
  "text3763": "Vytvorenie platby rezervácie",
  "text3764": "Upravenie platby rezervácie",
  "text3765": "Vymazanie platby rezervácie",
  "text3766": "O ubytovaní",
  "text3767": "Vaše údaje sú zabezpečené",
  "text3768": "Pripojte sa k viac než",
  "text3769": "spokojným klientom",
  "text3770": "Overené a získané prostredníctvom Google",
  "text3771": "Otváracie hodiny showroomu",
  "text3772": "Nákupom tohto produktu získate",
  "text3773": "bodov",
  "text3774": "Na účte máte",
  "text3775": "Popíšte produkt",
  "text3776": "(+) Pozitívum",
  "text3777": "(-) Negatívum",
  "text3778": "Pridať pozitívum",
  "text3779": "Pridať negatívum",
  "text3780": "Nadradená položka nemôže byť táto položka ani jej podradená položka.",
  "text3781": "IČ DPH je neplatné",
  "text3782": "Zadané IČ DPH je neplatné",
  "text3783": "Máte {{param}} bodov",
  "text3784": "Rezervačný systém",
  "text3785": "Uplatniť môžete max.",
  "text3786": "Uplatnené body",
  "text3787": "Prenájom štúdia",
  "text3788": "Počet bodov",
  "text3789": "Predaj skončil",
  "text3790": "Tento produkt zatiaľ pripravujeme",
  "text3791": "Chcem cenovú ponuku",
  "text3792": "Cenová ponuka do 24h",
  "text3793": "Potrebujete cenovú ponuku pre váš projekt? Odpovedáme do 24hodín",
  "text3794": "Odborné zváranie a kovovýroba na profesionálnej úrovni",
  "text3795": "Náš tím je pripravený nastúpiť na projekt okamžite. Kontaktujte nás ešte dnes.",
  "text3796": "alebo nám zavolajte",
  "text3797": "Vyplňte dopytový formulár a my vás kontaktujeme späť v čo najkratšej dobe kde detaile preberieme váš projekt.",
  "text3798": "Naše posledné realizácie",
  "text3799": "Pôsobíme naprieč celou európou",
  "text3800": "Čo vieme ponúknuť naším partnerom?",
  "text3801": "Pozrieť pracovné pozície",
  "text3802": "O akú službu máte záujem?",
  "text3803": "Vyberte službu zo zoznamu",
  "text3804": "Požadovaný dátum dodania",
  "text3805": "Projektová dokumentácia",
  "text3806": "Priložiť súbor",
  "text3807": "Odoslaním správy súhlasíte so spracovaním osobných údajov pre účely kontaktovania.",
  "text3808": "V tento moment neponúkame žiadne voľné pozície",
  "text3809": "V tejto kategórií neboli nájdené žiadne referencie.",
  "text3810": "Odstrániť súbor",
  "text3811": "Na základe vyplneného formuláru cenovej ponuky vás čo najskôr kontaktujem s návrhom cenovej ponuky. Ďakujeme za trpezlivosť.",
  "text3812": "Mám záujem o pracovnú ponuku",
  "text3813": "Použité služby",
  "text3814": "Krok",
  "text3815": "Realizujeme projekty v rámci EÚ - najmä v Nemecku, Rakúsku, Česku a na Slovensku, ale aj v ďalších krajinách podľa potrieb klienta.",
  "text3816": "Získajte cenovú ponuku pre váš projekt ešte dnes!",
  "text3817": "Nástup do práce",
  "text3818": "Typ pracovného pomeru",
  "text3819": "Mzda (brutto)",
  "text3820": "O realizácii",
  "text3821": "Ďalšie realizácie",
  "text3822": "Späť na všetky články",
  "text3823": "Ďalšie články",
  "text3824": "Obsah",
  "text3825": "Pokračovať cez\n",
  "text3826": "alebo",
  "text3827": "Prihlásenie sa nepodarilo",
  "text3828": "Pre registráciu cez sociálne konto je potrebný súhlas so spracovaním osobných údajov.",
  "text3829": "Prihlásenie bolo úspešné",
  "text3830": "E-mail zo sociálneho konta nie je overený.",
  "text3831": "Používateľský účet nie je možné prihlásiť.",
  "text3832": "Platnosť prihlásenia cez sociálne konto vypršala.",
  "text3833": "Prihlásenie cez sociálne konto sa nepodarilo.",
  "text3834": "Vyhľadajte lieky, vitamíny, kozmetiku...",
  "text3835": "Odkaz skopírovaný do schránky",
  "text3836": "Číslo balíka / sledovacie číslo...",
  "text3837": "Odstúpiť od zmluvy tu",
  "text3838": "Mohlo by vás ešte zaujímať.",
  "text3839": "Viac o kategórii",
  "text3840": "Registrovaný účet",
  "text3841": "Vrátenie tovaru - odstúpenie od zmluvy",
  "text3842": "Oprava tovaru",
  "text3843": "",
  "text3844": "Filtrovať produkty",
  "text3845": "Súhrn podania",
  "text3846": "Prijatie",
  "text3847": "Ukončenie",
  "text3848": "Nová reklamácia č.:",
  "text3849": "Bezpečný nákup",
  "text3850": "Resetovať",
  "text3851": "Čítať celý popis",
  "text3852": "Obsah balenia",
  "text3853": "K registrácii teraz získate:",
  "text3854": "Ponuky zadarmo",
  "text3855": "Topovania ponúk zadarmo",
  "text3856": "Kurzy zadarmo",
  "text3857": "Topovania kurzov zadarmo",
  "text3858": "Prístupy k životopisom zadarmo",
  "text3859": "pre vaše predplatné",
  "text3860": "bol vytvorený fleet prístupový kód:",
  "text3861": " Tento kód môžete zdieľať s používateľmi, ktorí sa majú pripojiť k vášmu predplatnému.",
  "text3862": "Maximálny počet členov:",
  "text3863": "Fleet kód pre predplatné",
  "text3864": "Na odoslanie ďalšej správy o nehode je potrebné aktívne predplatné.",
  "text3865": "Potvrdiť odstúpenie od zmluvy",
  "text3866": "odstúpenie od zmluvy č.:",
  "text3867": "výmena tovaru č.:",
  "text3868": "reklamácia č.:",
  "text3869": "výmenu tovaru",
  "text3870": "odstúpenie od zmluvy",
  "text3871": "reklamáciu",
  "text3872": "1750+ originálnych dielov skladom",
  "text3873": "Aký diel hľadáte?",
  "text3874": "Nájsť najbližšiu predajňu",
  "text3875": "Otvoriť katalóg",
  "text3876": "Zobraziť všetky",
  "text3877": "Náhradné diely",
  "text3878": "Recenzie zákazníkov",
  "text3879": "Pre pridanie recenzie produktu je potrebné prihlásenie",
  "text3880": "Zľavový kód",
  "text3881": "Zadajte kód",
  "text3882": "Súhrn objednávky",
  "text3883": "Pokračovať na Dopravu a platbu",
  "text3884": "Pokračovať na Doručovacie údaje",
  "text3885": "Pokračovať na Zhrnutie objednávky",
  "text3886": "Poznámka k objednávke",
  "text3887": "Objednávka potvrdená!",
  "text3888": "Ďakujeme za Váš nákup",
  "text3889": "Potvrdenie sme odoslali na",
  "text3890": "Čo bude následovať ďalej?",
  "text3891": "Objednávka spracovaná",
  "text3892": "Váš platba prebehla úspešne.",
  "text3893": "Príprava balíčka",
  "text3894": "Sklad pripravuje vašu objednávku",
  "text3895": "Odovzdanie dopravcovi",
  "text3896": "Dopravca prevezme balík na doručenie.",
  "text3897": "Doručenie",
  "text3898": "Budete kontaktovaný",
  "text3899": "Otváracia doba",
  "text3900": "Expedícia a sklad",
  "text3901": "Prepravcovia",
  "text3902": "Produkty v kolekcii",
  "text3903": "V tejto kolekcii nemáme žiadne produkty",
  "text3904": "Zobraziť ďalšie články",
  "text3905": "Cenová kalkulačka",
  "text3906": "Mám záujem o revíziu",
  "text3907": "Mám záujem o ponuku",
  "text3908": "Objednať bezplatnú konzultáciu",
  "text3909": "Odoslať žiadosť o ponuku",
  "text3910": "Zobraziť podrobnosti",
  "text3911": "Zobraziť ďalších 5 otázok",
  "text3912": "Začnite ešte dnes",
  "text3913": "Získajte nezáväznú cenovú ponuku na čističku odpadových vôd",
  "text3914": "Radšej zavolajte?",
  "text3915": "Po až Pi, 8:00 do 17:00",
  "text3916": "Som v blízkosti potoka",
  "text3917": "Koľko ľudí bude čistiareň využívať?",
  "text3918": "Mám svahovitý pozemok",
  "text3919": "Porovnanie nákladov",
  "text3920": "Prečo sa koreňová čistička odpadových vôd oplatí viac ako žumpa a aktivačná čistička",
  "text3921": "Ročné prevádzkové náklady",
  "text3922": "Celkové náklady za 10 rokov",
  "text3923": "Prevádzka bez starostí",
  "text3924": "Od objednávky po spustenie",
  "text3925": "Ako prebieha inštalácia čističky odpadových vôd",
  "text3926": "Mechanické predčistenie v septiku",
  "text3927": "Biologické čistenie baktériami",
  "text3928": "Koreňová filtrácia rastlinami",
  "text3929": "Prírodný proces v 4 krokoch",
  "text3930": "Ako funguje koreňová čistička odpadových vôd",
  "text3931": "Detailný sprievodca",
  "text3932": "Čističky odpadových vôd pre rodinné domy na Slovensku",
  "text3933": "Prečo si vybrať ECOPLANET SLOVAKIA",
  "text3934": "Kompletný sprievodca",
  "text3935": "Čistička odpadových vôd ECOKOCKA",
  "text3936": "na vyžiadanie",
  "text3937": "individuálna kalkulácia",
  "text3938": "Odpovede na vaše otázky",
  "text3939": "Často kladené otázky o čističkách odpadových vôd",
  "text3940": "Vaša istota",
  "text3941": "Prečo dôverovať ECOPLANET SLOVAKIA",
  "text3942": "Praktické informácie",
  "text3943": "Čo by ste mali vedieť pred kúpou čističky odpadových vôd",
  "text3944": "Reálne skúsenosti",
  "text3945": "Čo hovoria naši zákazníci",
  "text3946": "Google recenzia",
  "text3947": "Posúvajte šípkami pre ďalšie recenzie",
  "text3948": "Celé Slovensko",
  "text3949": "Čističky odpadových vôd montujeme po celom Slovensku",
  "text3950": "domácností",
  "text3951": "po celom Slovensku",
  "text3952": "obcí a penziónov",
  "text3953": "Najčastejšie sa pýtate",
  "text3954": "Názov stránky",
  "text3955": "Kontaktné osoby",
  "text3956": "Kontaktná adresa",
  "text3957": "Termíny a ceny",
  "text3958": "Popis zájazdu",
  "text3959": "Videá",
  "text3960": "Turnus",
  "text3961": "Počet dní / nocí\n",
  "text3962": "Rezervované",
  "text3963": "Neznámy stav",
  "text3964": "Cena zahŕňa",
  "text3965": "Cena nezahŕňa",
  "text3966": "Všetky zájazdy",
  "text3967": "Rezervovať stretnutie",
  "text3968": "Rezervácia stretnutia",
  "text3969": "Príhláste sa do newsletteru",
  "text3970": "Buďte prvý kto sa dozvie o hovinkách, termínoch a zľavách.",
  "text3971": "Odoslaním súhlasíte so spracovaním osobných údajov.",
  "text3972": "Prehľad termínov",
  "text3973": "Pozrieť program",
  "text3974": "Podobné zájazdy",
  "text3975": "Uskutočnené",
  "text3976": "Všetky termíny sa už uskutočnili",
  "text3977": "Prečítajte články o Madeire!",
  "text3978": "Nezáväzne rezervovať",
  "text3979": "Nezáväzná rezervácia zájazdu",
  "text3980": "Nezáväzná rezervácia",
  "text3981": "Zadajte Vaše tel. číslo",
  "text3982": "Pridať ďalšieho účastníka",
  "text3983": "Vymazať účastníka",
  "text3984": "Typ stretnutia",
  "text3985": "Mesto stretnutia",
  "text3986": "Dátum a čas",
  "text3987": "Ďalej",
  "text3988": "Odosielanie...",
  "text3989": "Potvrdiť rezerváciu",
  "text3990": "Vyberte miesto stretnutia",
  "text3991": "Miesto stretnutia",
  "text3992": "Prihláste sa na odber noviniek a dostávajte vždy tie najaktuálnejšie informácie z našej ponuky.",
  "text3993": "Kde nás nájdete?",
  "text3994": "V čom je naša cestovná kancelária OBJAVUJ SVET výnimočná?",
  "text3995": "Kancelária (prevádzka)",
  "text3996": "Budova INFORMATIKA na 2. poschodí",
  "text3997": "Ďakujeme za vašu rezerváciu!...",
  "text3998": "Najbližšie zájazdy",
  "text3999": "Vyplňte kontaktné údaje a približný rozpočet.",
  "text4000": "Žiadam ako",
  "text4001": "6 000 a viac",
  "text4002": "Čo pre vás máme pripraviť?",
  "text4003": "Žiadosť bola odoslaná",
  "text4004": "Ďakujeme. Po spracovaní vám cenovú ponuku pošleme e-mailom.",
  "text4005": "Číslo žiadosti",
  "text4006": "Odoslať ďalšiu žiadosť",
  "text4007": "Maximálny rozpočet musí byť vyšší ako minimálny.",
  "text4008": "Skontrolujte označené polia.",
  "text4009": "Odoslali ste priveľa žiadostí. Skúste to znova o chvíľu.",
  "text4010": "Pozrite si pripravenú ponuku a rozhodnite sa, či ju prijmete.",
  "text4011": "Cenová ponuka sa pripravuje.",
  "text4012": "Cenová ponuka zatiaľ nie je finálna.",
  "text4013": "Ponuku ste si otvorili. Môžete ju prijať alebo zamietnuť.",
  "text4014": "Túto cenovú ponuku ste prijali.",
  "text4015": "Túto cenovú ponuku ste zamietli.",
  "text4016": "Platnosť tejto cenovej ponuky vypršala.",
  "text4017": "Cenová ponuka bola prevedená na objednávku.",
  "text4018": "Platná do",
  "text4019": "Bez obmedzenia",
  "text4020": "Položky cenovej ponuky",
  "text4021": "Produkty spolu",
  "text4022": "Poznámka k ponuke",
  "text4023": "Prijať ponuku",
  "text4024": "Zamietnuť ponuku",
  "text4025": "Prijať cenovú ponuku?",
  "text4026": "Potvrdením oznámite predajcovi, že s cenovou ponukou súhlasíte.",
  "text4027": "Zamietnuť cenovú ponuku?",
  "text4028": "Potvrdením oznámite predajcovi, že cenovú ponuku neprijímate.",
  "text4029": "Áno, prijať",
  "text4030": "Áno, zamietnuť",
  "text4031": "O tejto cenovej ponuke už nie je možné rozhodnúť.",
  "text4032": "Rozhodnutie sa nepodarilo uložiť. Obnovte stránku a skúste to znova.",
  "text4033": "Dokument sa nepodarilo stiahnuť. Skúste to znova.",
  "text4034": "Cenová ponuka nebola nájdená",
  "text4035": "Odkaz je neplatný, ponuka ešte nebola odoslaná alebo už nie je dostupná.",
  "text4036": "Cenovú ponuku sa nepodarilo načítať",
  "text4037": "Skúste stránku obnoviť alebo sa obráťte na predajcu.",
  "text4038": "Vytvoriť novú žiadosť",
  "text4039": "Ponuka neobsahuje žiadne položky.",
  "text4040": "Zobraziť produkt",
  "text4041": "Koncept",
  "text4042": "Odoslaná",
  "text4043": "Zobrazená",
  "text4044": "Prijatá",
  "text4045": "Expirovaná",
  "text4046": "Prevedená na objednávku",
  "text4047": "Vyprázdniť košík?",
  "text4048": "Naozaj chcete odstrániť všetky položky z košíka? Túto akciu nie je možné vrátiť späť.",
  "text4049": "Áno, vyprázdniť",
  "text4050": "Poprosíme uviesť cenové rozpätie, nakoľko to má vplyv na nacenenie.",
  "text4051": "Cenové rozpätie",
  "text4052": "Sú toto vaše firemné údaje?",
  "text4053": "Jednotková cena s DPH",
  "text4054": "Odstrániť kupón",
  "text4055": "Neaktívne",
  "text4056": "Poistené",
  "text4057": "Nepoistené",
  "text4058": "Pridať vozidlo",
  "text4059": "Upraviť vozidlo",
  "text4060": "Vymazať vozidlo?",
  "text4061": "Moja garáž",
  "text4062": "Dátum STK, EK",
  "text4063": "Export sa nepodaril. Skúste to prosím znova.",
  "text4064": "Pozastaviť video",
  "text4065": "Materiál",
  "text4066": "Nová konfigurácia",
  "text4067": "Kroky konfigurácie",
  "text4068": "Nahrajte súbor",
  "text4069": "Objednať sa",
  "text4070": "Nepodarilo sa skopírovať odkaz",
  "text4071": "Údaje boli úspešne aktualizované",
  "text4072": "Pridať do porovnania",
  "text4073": "Odstrániť z porovnania",
  "text4074": "Späť na zoznam",
  "text4075": "Región",
  "text4076": "Katalógy",
  "text4077": "Moja flotila",
  "text4078": "Prehľad škôd",
  "text4079": "ŠPZ",
  "text4080": "Dátum a čas odletu",
  "text4081": "Dátum a čas príletu",
  "text4082": "Číslo letenky",
  "text4083": "Číslo pasu",
  "text4084": "Späť na parametre",
  "text4085": "Súhrn & kontakt",
  "text4086": "Konfigurácia bola odoslaná",
  "text4087": "Najnižšia mzda",
  "text4088": "Najvyššia mzda",
  "text4089": "Súhrn konfigurácie",
  "text4090": "Aktualizované:",
  "text4091": "Kontaktný e-mail *",
  "text4092": "Načítavam konfigurácie...",
  "text4093": "Použiť kód",
  "text4094": "Poznámka (voliteľné)...",
  "text4095": "Rozpracované konfigurácie",
  "text4096": "Žiadne výrobky sa tu zatiaľ nenachádzajú",
  "text4097": "Konfiguráciu sa nepodarilo načítať",
  "text4098": "Konfiguráciu sa nepodarilo odoslať",
  "text4099": "Konfiguráciu sa nepodarilo otvoriť",
  "text4100": "Konfiguráciu sa nepodarilo uložiť",
  "text4101": "Načítať z registra",
  "text4102": "Odhadovaná cena",
  "text4103": "Odoslané",
  "text4104": "Odoslané cenové ponuky",
  "text4105": "Pošleme cenovú ponuku e-mailom",
  "text4106": "pre účely vystavenia cenovej ponuky v zmysle GDPR.",
  "text4107": "Pridať otázku k produktu",
  "text4108": "Predbežný záujem",
  "text4109": "Štatistiky",
  "text4110": "Celkovo",
  "text4111": "Posledných 7 dní",
  "text4112": "Dní online",
  "text4113": "Priemer kliknutí za deň",
  "text4114": "Zobrazená",
  "text4115": "",
  "text4116": "Mestá",
  "text4117": "Všetky mestá",
  "text4118": "Oprava preliačin",
  "text4119": "Zdroje fotografií miest",
  "text4120": "Dohodnite si termín obhliadky",
  "text4121": "300+ recenzií na Google",
  "text4122": "Zobraziť recenzie",
  "text4123": "Kontaktujte nás a dohodnite si termín obhliadky",
  "text4124": "Kritérium",
  "text4125": "PDR bez lakovania",
  "text4126": "Lakovanie",
  "text4127": "Typ poškodenia",
  "text4128": "Rozsah",
  "text4129": "Orientačná cena",
  "text4130": "Typ prepravy",
  "text4131": "Odkiaľ",
  "text4132": "Kam",
  "text4133": "Rozmery (cm)",
  "text4134": "Váha (kg)",
  "text4135": "",
  "text4136": "",
  "text4137": "",
  "text4138": "",
  "text4139": "",
  "text4140": "",
  "text4141": "",
  "text4142": "",
  "text4143": "",
  "text4144": "",
  "text4145": "",
  "text4146": "",
  "text4147": "",
  "text4148": "",
  "text4149": "",
  "text4150": "",
  "coupon_offer_without_vat": "bez DPH",
  "coupon_offer_with_code": "s použitím zľavového kódu",
  "coupon_offer_validity": "Platnosť (hodiny:minúty:sekundy):",
  "coupon_offer_minimum": "Minimálna suma tovaru v košíku s DPH:",
  "coupon_offer_cart_hint": "Kód zadajte v košíku. Platnosť a podmienky sa overia pri jeho použití.",
  "coupon_offer_fixed_hint": "Pevná zľava sa rozdelí medzi oprávnené položky košíka.",
  "Price for one unit with code (including VAT):": "Cena za jeden kus s kódom (s DPH):",
  "Price before coupon (including VAT):": "Cena pred kupónom (s DPH):"
}) satisfies TranslationDictionary;
